// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:application/font-woff;charset=utf-8;base64,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", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ag-theme-alpine {
  -webkit-font-smoothing: antialiased;
  color: #181d1f;
  color: var(--ag-foreground-color, #181d1f);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  font-size: 13px;
  line-height: normal;
}
@font-face {
  font-family: "agGridAlpine";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
  font-weight: normal;
  font-style: normal;
}
.ag-theme-alpine .ag-icon {
  font-family: "agGridAlpine";
  font-size: 16px;
  line-height: 16px;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.ag-theme-alpine .ag-icon-aggregation::before {
  content: "\\f101";
}
.ag-theme-alpine .ag-icon-arrows::before {
  content: "\\f102";
}
.ag-theme-alpine .ag-icon-asc::before {
  content: "\\f103";
}
.ag-theme-alpine .ag-icon-cancel::before {
  content: "\\f104";
}
.ag-theme-alpine .ag-icon-chart::before {
  content: "\\f105";
}
.ag-theme-alpine .ag-icon-color-picker::before {
  content: "\\f109";
}
.ag-theme-alpine .ag-icon-columns::before {
  content: "\\f10a";
}
.ag-theme-alpine .ag-icon-contracted::before {
  content: "\\f10b";
}
.ag-theme-alpine .ag-icon-copy::before {
  content: "\\f10c";
}
.ag-theme-alpine .ag-icon-cross::before {
  content: "\\f10d";
}
.ag-theme-alpine .ag-icon-csv::before {
  content: "\\f10e";
}
.ag-theme-alpine .ag-icon-desc::before {
  content: "\\f10f";
}
.ag-theme-alpine .ag-icon-excel::before {
  content: "\\f110";
}
.ag-theme-alpine .ag-icon-expanded::before {
  content: "\\f111";
}
.ag-theme-alpine .ag-icon-eye-slash::before {
  content: "\\f112";
}
.ag-theme-alpine .ag-icon-eye::before {
  content: "\\f113";
}
.ag-theme-alpine .ag-icon-filter::before {
  content: "\\f114";
}
.ag-theme-alpine .ag-icon-first::before {
  content: "\\f115";
}
.ag-theme-alpine .ag-icon-grip::before {
  content: "\\f116";
}
.ag-theme-alpine .ag-icon-group::before {
  content: "\\f117";
}
.ag-theme-alpine .ag-icon-last::before {
  content: "\\f118";
}
.ag-theme-alpine .ag-icon-left::before {
  content: "\\f119";
}
.ag-theme-alpine .ag-icon-linked::before {
  content: "\\f11a";
}
.ag-theme-alpine .ag-icon-loading::before {
  content: "\\f11b";
}
.ag-theme-alpine .ag-icon-maximize::before {
  content: "\\f11c";
}
.ag-theme-alpine .ag-icon-menu::before {
  content: "\\f11d";
}
.ag-theme-alpine .ag-icon-minimize::before {
  content: "\\f11e";
}
.ag-theme-alpine .ag-icon-next::before {
  content: "\\f11f";
}
.ag-theme-alpine .ag-icon-none::before {
  content: "\\f120";
}
.ag-theme-alpine .ag-icon-not-allowed::before {
  content: "\\f121";
}
.ag-theme-alpine .ag-icon-paste::before {
  content: "\\f122";
}
.ag-theme-alpine .ag-icon-pin::before {
  content: "\\f123";
}
.ag-theme-alpine .ag-icon-pivot::before {
  content: "\\f124";
}
.ag-theme-alpine .ag-icon-previous::before {
  content: "\\f125";
}
.ag-theme-alpine .ag-icon-right::before {
  content: "\\f128";
}
.ag-theme-alpine .ag-icon-save::before {
  content: "\\f129";
}
.ag-theme-alpine .ag-icon-small-down::before {
  content: "\\f12a";
}
.ag-theme-alpine .ag-icon-small-left::before {
  content: "\\f12b";
}
.ag-theme-alpine .ag-icon-small-right::before {
  content: "\\f12c";
}
.ag-theme-alpine .ag-icon-small-up::before {
  content: "\\f12d";
}
.ag-theme-alpine .ag-icon-tick::before {
  content: "\\f12e";
}
.ag-theme-alpine .ag-icon-tree-closed::before {
  content: "\\f12f";
}
.ag-theme-alpine .ag-icon-tree-indeterminate::before {
  content: "\\f130";
}
.ag-theme-alpine .ag-icon-tree-open::before {
  content: "\\f131";
}
.ag-theme-alpine .ag-icon-unlinked::before {
  content: "\\f132";
}
.ag-theme-alpine .ag-icon-row-drag::before {
  content: "\\f116";
}
.ag-theme-alpine .ag-left-arrow::before {
  content: "\\f119";
}
.ag-theme-alpine .ag-right-arrow::before {
  content: "\\f128";
}
.ag-theme-alpine .ag-root-wrapper {
  background-color: #fff;
  background-color: var(--ag-background-color, #fff);
}
.ag-theme-alpine [class^=ag-], .ag-theme-alpine [class^=ag-]:focus, .ag-theme-alpine [class^=ag-]:after, .ag-theme-alpine [class^=ag-]:before {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  outline: none;
}
.ag-theme-alpine [class^=ag-]::-ms-clear {
  display: none;
}
.ag-theme-alpine .ag-checkbox .ag-input-wrapper,
.ag-theme-alpine .ag-radio-button .ag-input-wrapper {
  overflow: visible;
}
.ag-theme-alpine .ag-range-field .ag-input-wrapper {
  height: 100%;
}
.ag-theme-alpine .ag-toggle-button {
  -webkit-box-flex: 0;
          flex: none;
  width: unset;
  min-width: unset;
}
.ag-theme-alpine .ag-ltr .ag-label-align-right .ag-label {
  margin-left: 6px;
}

.ag-theme-alpine .ag-rtl .ag-label-align-right .ag-label {
  margin-right: 6px;
}

.ag-theme-alpine input[class^=ag-] {
  margin: 0;
  background-color: #fff;
  background-color: var(--ag-background-color, #fff);
}
.ag-theme-alpine textarea[class^=ag-],
.ag-theme-alpine select[class^=ag-] {
  background-color: #fff;
  background-color: var(--ag-background-color, #fff);
}
.ag-theme-alpine input[class^=ag-]:not([type]),
.ag-theme-alpine input[class^=ag-][type=text],
.ag-theme-alpine input[class^=ag-][type=number],
.ag-theme-alpine input[class^=ag-][type=tel],
.ag-theme-alpine input[class^=ag-][type=date],
.ag-theme-alpine input[class^=ag-][type=datetime-local],
.ag-theme-alpine textarea[class^=ag-] {
  font-size: inherit;
  line-height: inherit;
  color: inherit;
  border-width: 1px;
  border-style: solid;
  border-color: #babfc7;
  border-color: var(--ag-input-border-color, var(--ag-border-color, #babfc7));
}
.ag-theme-alpine input[class^=ag-]:not([type]):disabled,
.ag-theme-alpine input[class^=ag-][type=text]:disabled,
.ag-theme-alpine input[class^=ag-][type=number]:disabled,
.ag-theme-alpine input[class^=ag-][type=tel]:disabled,
.ag-theme-alpine input[class^=ag-][type=date]:disabled,
.ag-theme-alpine input[class^=ag-][type=datetime-local]:disabled,
.ag-theme-alpine textarea[class^=ag-]:disabled {
  color: rgba(24, 29, 31, 0.5);
  color: var(--ag-disabled-foreground-color, rgba(24, 29, 31, 0.5));
  background-color: #f1f2f4;
  background-color: var(--ag-input-disabled-background-color, #f1f2f4);
  border-color: rgba(186, 191, 199, 0.3);
  border-color: var(--ag-input-disabled-border-color, rgba(186, 191, 199, 0.3));
}
.ag-theme-alpine input[class^=ag-]:not([type]):focus,
.ag-theme-alpine input[class^=ag-][type=text]:focus,
.ag-theme-alpine input[class^=ag-][type=number]:focus,
.ag-theme-alpine input[class^=ag-][type=tel]:focus,
.ag-theme-alpine input[class^=ag-][type=date]:focus,
.ag-theme-alpine input[class^=ag-][type=datetime-local]:focus,
.ag-theme-alpine textarea[class^=ag-]:focus {
  outline: none;
  -webkit-box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);
          box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);
  border-color: rgba(33, 150, 243, 0.4);
  border-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));
}
.ag-theme-alpine input[class^=ag-]:not([type]):invalid,
.ag-theme-alpine input[class^=ag-][type=text]:invalid,
.ag-theme-alpine input[class^=ag-][type=number]:invalid,
.ag-theme-alpine input[class^=ag-][type=tel]:invalid,
.ag-theme-alpine input[class^=ag-][type=date]:invalid,
.ag-theme-alpine input[class^=ag-][type=datetime-local]:invalid,
.ag-theme-alpine textarea[class^=ag-]:invalid {
  border-width: 2px;
  border-style: solid;
  border-color: #e02525;
  border-color: var(--ag-input-border-color-invalid, var(--ag-invalid-color, #e02525));
}
.ag-theme-alpine input[class^=ag-][type=number] {
  -moz-appearance: textfield;
}
.ag-theme-alpine input[class^=ag-][type=number]::-webkit-outer-spin-button, .ag-theme-alpine input[class^=ag-][type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.ag-theme-alpine input[class^=ag-][type=range] {
  padding: 0;
}
.ag-theme-alpine input[class^=ag-][type=button]:focus, .ag-theme-alpine button[class^=ag-]:focus {
  -webkit-box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);
          box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);
}
.ag-theme-alpine .ag-drag-handle {
  color: #181d1f;
  color: var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f));
}
.ag-theme-alpine .ag-list-item, .ag-theme-alpine .ag-virtual-list-item {
  height: 24px;
}
.ag-theme-alpine .ag-keyboard-focus .ag-virtual-list-item:focus {
  outline: none;
}
.ag-theme-alpine .ag-keyboard-focus .ag-virtual-list-item:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: rgba(33, 150, 243, 0.4);
  border-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));
}
.ag-theme-alpine .ag-select-list {
  background-color: #fff;
  background-color: var(--ag-background-color, #fff);
  overflow-y: auto;
  overflow-x: hidden;
}
.ag-theme-alpine .ag-list-item {
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
          align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ag-theme-alpine .ag-list-item.ag-active-item {
  background-color: rgba(33, 150, 243, 0.1);
  background-color: var(--ag-row-hover-color, rgba(33, 150, 243, 0.1));
}
.ag-theme-alpine .ag-select-list-item {
  padding-left: 4px;
  padding-right: 4px;
  cursor: default;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
}
.ag-theme-alpine .ag-select-list-item span {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.ag-theme-alpine .ag-select .ag-picker-field-wrapper {
  background-color: #fff;
  background-color: var(--ag-background-color, #fff);
  min-height: 24px;
  cursor: default;
}
.ag-theme-alpine .ag-select.ag-disabled .ag-picker-field-wrapper:focus {
  -webkit-box-shadow: none;
          box-shadow: none;
}
.ag-theme-alpine .ag-select:not(.ag-cell-editor) {
  height: 24px;
}
.ag-theme-alpine .ag-select .ag-picker-field-display {
  margin: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ag-theme-alpine .ag-select .ag-picker-field-icon {
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
          align-items: center;
}
.ag-theme-alpine .ag-select.ag-disabled {
  opacity: 0.5;
}
.ag-theme-alpine .ag-rich-select {
  background-color: #f8f8f8;
  background-color: var(--ag-control-panel-background-color, #f8f8f8);
}
.ag-theme-alpine .ag-rich-select-list {
  width: 100%;
  min-width: 200px;
  height: 273px;
}
.ag-theme-alpine .ag-rich-select-value {
  padding: 0 6px 0 18px;
  height: 42px;
  border-bottom: solid 1px;
  border-bottom-color: #dde2eb;
  border-bottom-color: var(--ag-secondary-border-color, #dde2eb);
}
.ag-theme-alpine .ag-rich-select-virtual-list-item {
  cursor: default;
  height: 24px;
}
.ag-theme-alpine .ag-rich-select-virtual-list-item:hover {
  background-color: rgba(33, 150, 243, 0.1);
  background-color: var(--ag-row-hover-color, rgba(33, 150, 243, 0.1));
}
.ag-theme-alpine .ag-rich-select-row {
  padding-left: 18px;
}
.ag-theme-alpine .ag-rich-select-row-selected {
  background-color: rgba(33, 150, 243, 0.3);
  background-color: var(--ag-selected-row-background-color, rgba(33, 150, 243, 0.3));
}
.ag-theme-alpine .ag-row-drag,
.ag-theme-alpine .ag-selection-checkbox,
.ag-theme-alpine .ag-group-expanded,
.ag-theme-alpine .ag-group-contracted {
  color: #181d1f;
  color: var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f));
}
.ag-theme-alpine .ag-ltr .ag-row-drag, .ag-theme-alpine .ag-ltr .ag-selection-checkbox, .ag-theme-alpine .ag-ltr .ag-group-expanded, .ag-theme-alpine .ag-ltr .ag-group-contracted {
  margin-right: 12px;
}

.ag-theme-alpine .ag-rtl .ag-row-drag, .ag-theme-alpine .ag-rtl .ag-selection-checkbox, .ag-theme-alpine .ag-rtl .ag-group-expanded, .ag-theme-alpine .ag-rtl .ag-group-contracted {
  margin-left: 12px;
}

.ag-theme-alpine .ag-cell-wrapper > *:not(.ag-cell-value):not(.ag-group-value) {
  height: min(var(--ag-line-height, 40px), 40px);
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
          align-items: center;
  -webkit-box-flex: 0;
          flex: none;
}
.ag-theme-alpine .ag-group-expanded,
.ag-theme-alpine .ag-group-contracted {
  cursor: pointer;
}
.ag-theme-alpine .ag-group-title-bar-icon {
  cursor: pointer;
  -webkit-box-flex: 0;
          flex: none;
  color: #181d1f;
  color: var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f));
}
.ag-theme-alpine .ag-ltr .ag-group-child-count {
  margin-left: 2px;
}

.ag-theme-alpine .ag-rtl .ag-group-child-count {
  margin-right: 2px;
}

.ag-theme-alpine .ag-group-title-bar {
  background-color: #fff;
  background-color: var(--ag-subheader-background-color, #fff);
  padding: 6px;
}
.ag-theme-alpine .ag-group-toolbar {
  padding: 6px;
}
.ag-theme-alpine .ag-disabled-group-title-bar, .ag-theme-alpine .ag-disabled-group-container {
  opacity: 0.5;
}
.ag-theme-alpine .group-item {
  margin: 3px 0;
}
.ag-theme-alpine .ag-label {
  white-space: nowrap;
}
.ag-theme-alpine .ag-ltr .ag-label {
  margin-right: 6px;
}

.ag-theme-alpine .ag-rtl .ag-label {
  margin-left: 6px;
}

.ag-theme-alpine .ag-label-align-top .ag-label {
  margin-bottom: 3px;
}
.ag-theme-alpine .ag-ltr .ag-slider-field, .ag-theme-alpine .ag-ltr .ag-angle-select-field {
  margin-right: 12px;
}

.ag-theme-alpine .ag-rtl .ag-slider-field, .ag-theme-alpine .ag-rtl .ag-angle-select-field {
  margin-left: 12px;
}

.ag-theme-alpine .ag-angle-select-parent-circle {
  width: 24px;
  height: 24px;
  border-radius: 12px;
  border: solid 1px;
  border-color: #babfc7;
  border-color: var(--ag-border-color, #babfc7);
  background-color: #fff;
  background-color: var(--ag-background-color, #fff);
}
.ag-theme-alpine .ag-angle-select-child-circle {
  top: 4px;
  left: 12px;
  width: 6px;
  height: 6px;
  margin-left: -3px;
  margin-top: -4px;
  border-radius: 3px;
  background-color: #181d1f;
  background-color: var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f));
}
.ag-theme-alpine .ag-picker-field-wrapper {
  border: 1px solid;
  border-color: #babfc7;
  border-color: var(--ag-border-color, #babfc7);
  border-radius: 5px;
}
.ag-theme-alpine .ag-picker-field-wrapper:focus {
  -webkit-box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);
          box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);
}
.ag-theme-alpine .ag-picker-field-button {
  background-color: #fff;
  background-color: var(--ag-background-color, #fff);
  color: #181d1f;
  color: var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f));
}
.ag-theme-alpine .ag-dialog.ag-color-dialog {
  border-radius: 5px;
}
.ag-theme-alpine .ag-color-picker .ag-picker-field-display {
  height: 16px;
}
.ag-theme-alpine .ag-color-panel {
  padding: 6px;
}
.ag-theme-alpine .ag-spectrum-color {
  background-color: rgb(255, 0, 0);
  border-radius: 2px;
}
.ag-theme-alpine .ag-spectrum-tools {
  padding: 10px;
}
.ag-theme-alpine .ag-spectrum-sat {
  background-image: -webkit-gradient(linear, left top, right top, from(white), to(rgba(204, 154, 129, 0)));
  background-image: linear-gradient(to right, white, rgba(204, 154, 129, 0));
}
.ag-theme-alpine .ag-spectrum-val {
  background-image: -webkit-gradient(linear, left bottom, left top, from(black), to(rgba(204, 154, 129, 0)));
  background-image: linear-gradient(to top, black, rgba(204, 154, 129, 0));
}
.ag-theme-alpine .ag-spectrum-dragger {
  border-radius: 12px;
  height: 12px;
  width: 12px;
  border: 1px solid white;
  background: black;
  -webkit-box-shadow: 0 0 2px 0px rgba(0, 0, 0, 0.24);
          box-shadow: 0 0 2px 0px rgba(0, 0, 0, 0.24);
}
.ag-theme-alpine .ag-spectrum-hue-background {
  border-radius: 2px;
}
.ag-theme-alpine .ag-spectrum-alpha-background {
  border-radius: 2px;
}
.ag-theme-alpine .ag-spectrum-tool {
  margin-bottom: 10px;
  height: 11px;
  border-radius: 2px;
}
.ag-theme-alpine .ag-spectrum-slider {
  margin-top: -12px;
  width: 13px;
  height: 13px;
  border-radius: 13px;
  background-color: rgb(248, 248, 248);
  -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);
          box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);
}
.ag-theme-alpine .ag-recent-color {
  margin: 0 3px;
}
.ag-theme-alpine .ag-recent-color:first-child {
  margin-left: 0;
}
.ag-theme-alpine .ag-recent-color:last-child {
  margin-right: 0;
}
.ag-theme-alpine.ag-dnd-ghost {
  border: solid 1px;
  border-color: #babfc7;
  border-color: var(--ag-border-color, #babfc7);
  background: #fff;
  background: var(--ag-background-color, #fff);
  border-radius: 3px;
  -webkit-box-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);
          box-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);
  padding: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  border: solid 1px;
  border-color: #dde2eb;
  border-color: var(--ag-secondary-border-color, #dde2eb);
  color: #181d1f;
  color: var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f));
  height: 48px !important;
  line-height: 48px;
  margin: 0;
  padding: 0 12px;
  -webkit-transform: translateY(12px);
          transform: translateY(12px);
}
.ag-theme-alpine .ag-dnd-ghost-icon {
  margin-right: 6px;
  color: #181d1f;
  color: var(--ag-foreground-color, #181d1f);
}
.ag-theme-alpine .ag-popup-child:not(.ag-tooltip-custom) {
  -webkit-box-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);
          box-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);
}
.ag-dragging-range-handle .ag-theme-alpine .ag-dialog, .ag-dragging-fill-handle .ag-theme-alpine .ag-dialog {
  opacity: 0.7;
  pointer-events: none;
}
.ag-theme-alpine .ag-dialog {
  border-radius: 3px;
  border: solid 1px;
  border-color: #babfc7;
  border-color: var(--ag-border-color, #babfc7);
}
.ag-theme-alpine .ag-panel {
  background-color: #fff;
  background-color: var(--ag-background-color, #fff);
}
.ag-theme-alpine .ag-panel-title-bar {
  background-color: #f8f8f8;
  background-color: var(--ag-header-background-color, #f8f8f8);
  color: #181d1f;
  color: var(--ag-header-foreground-color, var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f)));
  height: 48px;
  padding: 6px 18px;
  border-bottom: solid 1px;
  border-bottom-color: #babfc7;
  border-bottom-color: var(--ag-border-color, #babfc7);
}
.ag-theme-alpine .ag-ltr .ag-panel-title-bar-button {
  margin-left: 6px;
}

.ag-theme-alpine .ag-rtl .ag-panel-title-bar-button {
  margin-right: 6px;
}

.ag-theme-alpine .ag-tooltip {
  background-color: #f8f8f8;
  background-color: var(--ag-header-background-color, #f8f8f8);
  color: #181d1f;
  color: var(--ag-foreground-color, #181d1f);
  padding: 6px;
  border: solid 1px;
  border-color: #babfc7;
  border-color: var(--ag-border-color, #babfc7);
  border-radius: 3px;
  -webkit-transition: opacity 1s;
  transition: opacity 1s;
  white-space: normal;
}
.ag-theme-alpine .ag-tooltip.ag-tooltip-hiding {
  opacity: 0;
}
.ag-theme-alpine .ag-tooltip-custom {
  -webkit-transition: opacity 1s;
  transition: opacity 1s;
}
.ag-theme-alpine .ag-tooltip-custom.ag-tooltip-hiding {
  opacity: 0;
}
.ag-theme-alpine .ag-ltr .ag-column-select-indent-1 {
  padding-left: 16px;
}

.ag-theme-alpine .ag-rtl .ag-column-select-indent-1 {
  padding-right: 16px;
}

.ag-theme-alpine .ag-ltr .ag-column-select-indent-2 {
  padding-left: 32px;
}

.ag-theme-alpine .ag-rtl .ag-column-select-indent-2 {
  padding-right: 32px;
}

.ag-theme-alpine .ag-ltr .ag-column-select-indent-3 {
  padding-left: 48px;
}

.ag-theme-alpine .ag-rtl .ag-column-select-indent-3 {
  padding-right: 48px;
}

.ag-theme-alpine .ag-ltr .ag-column-select-indent-4 {
  padding-left: 64px;
}

.ag-theme-alpine .ag-rtl .ag-column-select-indent-4 {
  padding-right: 64px;
}

.ag-theme-alpine .ag-ltr .ag-column-select-indent-5 {
  padding-left: 80px;
}

.ag-theme-alpine .ag-rtl .ag-column-select-indent-5 {
  padding-right: 80px;
}

.ag-theme-alpine .ag-ltr .ag-column-select-indent-6 {
  padding-left: 96px;
}

.ag-theme-alpine .ag-rtl .ag-column-select-indent-6 {
  padding-right: 96px;
}

.ag-theme-alpine .ag-ltr .ag-column-select-indent-7 {
  padding-left: 112px;
}

.ag-theme-alpine .ag-rtl .ag-column-select-indent-7 {
  padding-right: 112px;
}

.ag-theme-alpine .ag-ltr .ag-column-select-indent-8 {
  padding-left: 128px;
}

.ag-theme-alpine .ag-rtl .ag-column-select-indent-8 {
  padding-right: 128px;
}

.ag-theme-alpine .ag-ltr .ag-column-select-indent-9 {
  padding-left: 144px;
}

.ag-theme-alpine .ag-rtl .ag-column-select-indent-9 {
  padding-right: 144px;
}

.ag-theme-alpine .ag-column-select-header-icon {
  cursor: pointer;
}
.ag-theme-alpine .ag-keyboard-focus .ag-column-select-header-icon:focus {
  outline: none;
}
.ag-theme-alpine .ag-keyboard-focus .ag-column-select-header-icon:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 0px;
  left: 0px;
  display: block;
  width: calc(100% - 0px);
  height: calc(100% - 0px);
  border: 1px solid;
  border-color: rgba(33, 150, 243, 0.4);
  border-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));
}
.ag-theme-alpine .ag-ltr .ag-column-group-icons:not(:last-child), .ag-theme-alpine .ag-ltr .ag-column-select-header-icon:not(:last-child), .ag-theme-alpine .ag-ltr .ag-column-select-header-checkbox:not(:last-child), .ag-theme-alpine .ag-ltr .ag-column-select-header-filter-wrapper:not(:last-child), .ag-theme-alpine .ag-ltr .ag-column-select-checkbox:not(:last-child), .ag-theme-alpine .ag-ltr .ag-column-select-column-drag-handle:not(:last-child), .ag-theme-alpine .ag-ltr .ag-column-select-column-group-drag-handle:not(:last-child), .ag-theme-alpine .ag-ltr .ag-column-select-column-label:not(:last-child) {
  margin-right: 12px;
}

.ag-theme-alpine .ag-rtl .ag-column-group-icons:not(:last-child), .ag-theme-alpine .ag-rtl .ag-column-select-header-icon:not(:last-child), .ag-theme-alpine .ag-rtl .ag-column-select-header-checkbox:not(:last-child), .ag-theme-alpine .ag-rtl .ag-column-select-header-filter-wrapper:not(:last-child), .ag-theme-alpine .ag-rtl .ag-column-select-checkbox:not(:last-child), .ag-theme-alpine .ag-rtl .ag-column-select-column-drag-handle:not(:last-child), .ag-theme-alpine .ag-rtl .ag-column-select-column-group-drag-handle:not(:last-child), .ag-theme-alpine .ag-rtl .ag-column-select-column-label:not(:last-child) {
  margin-left: 12px;
}

.ag-theme-alpine .ag-keyboard-focus .ag-column-select-virtual-list-item:focus {
  outline: none;
}
.ag-theme-alpine .ag-keyboard-focus .ag-column-select-virtual-list-item:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 1px;
  left: 1px;
  display: block;
  width: calc(100% - 2px);
  height: calc(100% - 2px);
  border: 1px solid;
  border-color: rgba(33, 150, 243, 0.4);
  border-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));
}
.ag-theme-alpine .ag-column-select-column-group:not(:last-child),
.ag-theme-alpine .ag-column-select-column:not(:last-child) {
  margin-bottom: 9px;
}
.ag-theme-alpine .ag-column-select-column-readonly,
.ag-theme-alpine .ag-column-select-column-group-readonly {
  color: rgba(24, 29, 31, 0.5);
  color: var(--ag-disabled-foreground-color, rgba(24, 29, 31, 0.5));
  pointer-events: none;
}
.ag-theme-alpine .ag-ltr .ag-column-select-add-group-indent {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-column-select-add-group-indent {
  margin-right: 28px;
}

.ag-theme-alpine .ag-column-select-virtual-list-viewport {
  padding: 6px 0px;
}
.ag-theme-alpine .ag-column-select-virtual-list-item {
  padding: 0 12px;
}
.ag-theme-alpine .ag-rtl {
  text-align: right;
}
.ag-theme-alpine .ag-root-wrapper {
  border: solid 1px;
  border-color: #babfc7;
  border-color: var(--ag-border-color, #babfc7);
}
.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-1 {
  padding-left: 46px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-1 {
  padding-right: 46px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-1 {
  padding-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-1 {
  padding-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-1 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-1 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-2 {
  padding-left: 74px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-2 {
  padding-right: 74px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-2 {
  padding-left: 56px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-2 {
  padding-right: 56px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-2 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-2 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-3 {
  padding-left: 102px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-3 {
  padding-right: 102px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-3 {
  padding-left: 84px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-3 {
  padding-right: 84px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-3 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-3 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-4 {
  padding-left: 130px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-4 {
  padding-right: 130px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-4 {
  padding-left: 112px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-4 {
  padding-right: 112px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-4 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-4 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-5 {
  padding-left: 158px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-5 {
  padding-right: 158px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-5 {
  padding-left: 140px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-5 {
  padding-right: 140px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-5 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-5 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-6 {
  padding-left: 186px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-6 {
  padding-right: 186px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-6 {
  padding-left: 168px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-6 {
  padding-right: 168px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-6 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-6 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-7 {
  padding-left: 214px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-7 {
  padding-right: 214px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-7 {
  padding-left: 196px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-7 {
  padding-right: 196px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-7 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-7 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-8 {
  padding-left: 242px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-8 {
  padding-right: 242px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-8 {
  padding-left: 224px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-8 {
  padding-right: 224px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-8 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-8 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-9 {
  padding-left: 270px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-9 {
  padding-right: 270px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-9 {
  padding-left: 252px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-9 {
  padding-right: 252px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-9 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-9 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-10 {
  padding-left: 298px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-10 {
  padding-right: 298px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-10 {
  padding-left: 280px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-10 {
  padding-right: 280px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-10 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-10 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-11 {
  padding-left: 326px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-11 {
  padding-right: 326px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-11 {
  padding-left: 308px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-11 {
  padding-right: 308px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-11 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-11 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-12 {
  padding-left: 354px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-12 {
  padding-right: 354px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-12 {
  padding-left: 336px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-12 {
  padding-right: 336px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-12 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-12 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-13 {
  padding-left: 382px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-13 {
  padding-right: 382px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-13 {
  padding-left: 364px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-13 {
  padding-right: 364px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-13 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-13 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-14 {
  padding-left: 410px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-14 {
  padding-right: 410px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-14 {
  padding-left: 392px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-14 {
  padding-right: 392px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-14 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-14 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-15 {
  padding-left: 438px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-15 {
  padding-right: 438px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-15 {
  padding-left: 420px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-15 {
  padding-right: 420px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-15 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-15 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-16 {
  padding-left: 466px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-16 {
  padding-right: 466px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-16 {
  padding-left: 448px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-16 {
  padding-right: 448px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-16 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-16 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-17 {
  padding-left: 494px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-17 {
  padding-right: 494px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-17 {
  padding-left: 476px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-17 {
  padding-right: 476px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-17 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-17 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-18 {
  padding-left: 522px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-18 {
  padding-right: 522px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-18 {
  padding-left: 504px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-18 {
  padding-right: 504px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-18 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-18 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-19 {
  padding-left: 550px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-19 {
  padding-right: 550px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-19 {
  padding-left: 532px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-19 {
  padding-right: 532px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-19 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-19 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-20 {
  padding-left: 578px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-20 {
  padding-right: 578px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-20 {
  padding-left: 560px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-20 {
  padding-right: 560px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-20 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-20 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-21 {
  padding-left: 606px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-21 {
  padding-right: 606px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-21 {
  padding-left: 588px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-21 {
  padding-right: 588px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-21 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-21 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-22 {
  padding-left: 634px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-22 {
  padding-right: 634px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-22 {
  padding-left: 616px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-22 {
  padding-right: 616px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-22 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-22 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-23 {
  padding-left: 662px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-23 {
  padding-right: 662px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-23 {
  padding-left: 644px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-23 {
  padding-right: 644px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-23 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-23 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-24 {
  padding-left: 690px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-24 {
  padding-right: 690px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-24 {
  padding-left: 672px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-24 {
  padding-right: 672px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-24 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-24 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-25 {
  padding-left: 718px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-25 {
  padding-right: 718px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-25 {
  padding-left: 700px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-25 {
  padding-right: 700px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-25 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-25 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-26 {
  padding-left: 746px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-26 {
  padding-right: 746px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-26 {
  padding-left: 728px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-26 {
  padding-right: 728px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-26 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-26 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-27 {
  padding-left: 774px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-27 {
  padding-right: 774px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-27 {
  padding-left: 756px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-27 {
  padding-right: 756px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-27 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-27 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-28 {
  padding-left: 802px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-28 {
  padding-right: 802px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-28 {
  padding-left: 784px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-28 {
  padding-right: 784px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-28 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-28 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-29 {
  padding-left: 830px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-29 {
  padding-right: 830px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-29 {
  padding-left: 812px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-29 {
  padding-right: 812px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-29 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-29 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-30 {
  padding-left: 858px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-30 {
  padding-right: 858px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-30 {
  padding-left: 840px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-30 {
  padding-right: 840px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-30 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-30 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-31 {
  padding-left: 886px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-31 {
  padding-right: 886px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-31 {
  padding-left: 868px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-31 {
  padding-right: 868px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-31 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-31 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-32 {
  padding-left: 914px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-32 {
  padding-right: 914px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-32 {
  padding-left: 896px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-32 {
  padding-right: 896px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-32 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-32 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-33 {
  padding-left: 942px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-33 {
  padding-right: 942px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-33 {
  padding-left: 924px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-33 {
  padding-right: 924px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-33 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-33 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-34 {
  padding-left: 970px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-34 {
  padding-right: 970px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-34 {
  padding-left: 952px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-34 {
  padding-right: 952px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-34 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-34 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-35 {
  padding-left: 998px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-35 {
  padding-right: 998px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-35 {
  padding-left: 980px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-35 {
  padding-right: 980px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-35 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-35 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-36 {
  padding-left: 1026px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-36 {
  padding-right: 1026px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-36 {
  padding-left: 1008px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-36 {
  padding-right: 1008px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-36 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-36 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-37 {
  padding-left: 1054px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-37 {
  padding-right: 1054px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-37 {
  padding-left: 1036px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-37 {
  padding-right: 1036px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-37 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-37 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-38 {
  padding-left: 1082px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-38 {
  padding-right: 1082px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-38 {
  padding-left: 1064px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-38 {
  padding-right: 1064px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-38 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-38 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-39 {
  padding-left: 1110px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-39 {
  padding-right: 1110px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-39 {
  padding-left: 1092px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-39 {
  padding-right: 1092px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-39 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-39 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-40 {
  padding-left: 1138px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-40 {
  padding-right: 1138px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-40 {
  padding-left: 1120px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-40 {
  padding-right: 1120px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-40 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-40 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-41 {
  padding-left: 1166px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-41 {
  padding-right: 1166px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-41 {
  padding-left: 1148px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-41 {
  padding-right: 1148px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-41 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-41 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-42 {
  padding-left: 1194px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-42 {
  padding-right: 1194px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-42 {
  padding-left: 1176px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-42 {
  padding-right: 1176px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-42 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-42 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-43 {
  padding-left: 1222px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-43 {
  padding-right: 1222px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-43 {
  padding-left: 1204px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-43 {
  padding-right: 1204px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-43 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-43 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-44 {
  padding-left: 1250px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-44 {
  padding-right: 1250px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-44 {
  padding-left: 1232px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-44 {
  padding-right: 1232px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-44 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-44 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-45 {
  padding-left: 1278px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-45 {
  padding-right: 1278px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-45 {
  padding-left: 1260px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-45 {
  padding-right: 1260px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-45 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-45 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-46 {
  padding-left: 1306px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-46 {
  padding-right: 1306px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-46 {
  padding-left: 1288px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-46 {
  padding-right: 1288px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-46 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-46 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-47 {
  padding-left: 1334px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-47 {
  padding-right: 1334px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-47 {
  padding-left: 1316px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-47 {
  padding-right: 1316px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-47 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-47 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-48 {
  padding-left: 1362px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-48 {
  padding-right: 1362px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-48 {
  padding-left: 1344px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-48 {
  padding-right: 1344px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-48 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-48 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-49 {
  padding-left: 1390px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-49 {
  padding-right: 1390px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-49 {
  padding-left: 1372px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-49 {
  padding-right: 1372px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-49 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-49 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-50 {
  padding-left: 1418px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-50 {
  padding-right: 1418px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-50 {
  padding-left: 1400px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-50 {
  padding-right: 1400px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-50 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-50 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-51 {
  padding-left: 1446px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-51 {
  padding-right: 1446px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-51 {
  padding-left: 1428px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-51 {
  padding-right: 1428px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-51 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-51 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-52 {
  padding-left: 1474px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-52 {
  padding-right: 1474px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-52 {
  padding-left: 1456px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-52 {
  padding-right: 1456px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-52 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-52 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-53 {
  padding-left: 1502px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-53 {
  padding-right: 1502px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-53 {
  padding-left: 1484px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-53 {
  padding-right: 1484px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-53 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-53 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-54 {
  padding-left: 1530px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-54 {
  padding-right: 1530px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-54 {
  padding-left: 1512px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-54 {
  padding-right: 1512px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-54 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-54 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-55 {
  padding-left: 1558px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-55 {
  padding-right: 1558px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-55 {
  padding-left: 1540px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-55 {
  padding-right: 1540px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-55 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-55 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-56 {
  padding-left: 1586px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-56 {
  padding-right: 1586px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-56 {
  padding-left: 1568px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-56 {
  padding-right: 1568px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-56 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-56 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-57 {
  padding-left: 1614px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-57 {
  padding-right: 1614px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-57 {
  padding-left: 1596px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-57 {
  padding-right: 1596px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-57 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-57 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-58 {
  padding-left: 1642px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-58 {
  padding-right: 1642px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-58 {
  padding-left: 1624px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-58 {
  padding-right: 1624px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-58 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-58 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-59 {
  padding-left: 1670px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-59 {
  padding-right: 1670px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-59 {
  padding-left: 1652px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-59 {
  padding-right: 1652px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-59 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-59 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-60 {
  padding-left: 1698px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-60 {
  padding-right: 1698px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-60 {
  padding-left: 1680px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-60 {
  padding-right: 1680px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-60 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-60 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-61 {
  padding-left: 1726px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-61 {
  padding-right: 1726px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-61 {
  padding-left: 1708px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-61 {
  padding-right: 1708px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-61 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-61 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-62 {
  padding-left: 1754px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-62 {
  padding-right: 1754px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-62 {
  padding-left: 1736px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-62 {
  padding-right: 1736px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-62 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-62 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-63 {
  padding-left: 1782px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-63 {
  padding-right: 1782px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-63 {
  padding-left: 1764px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-63 {
  padding-right: 1764px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-63 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-63 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-64 {
  padding-left: 1810px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-64 {
  padding-right: 1810px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-64 {
  padding-left: 1792px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-64 {
  padding-right: 1792px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-64 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-64 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-65 {
  padding-left: 1838px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-65 {
  padding-right: 1838px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-65 {
  padding-left: 1820px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-65 {
  padding-right: 1820px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-65 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-65 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-66 {
  padding-left: 1866px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-66 {
  padding-right: 1866px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-66 {
  padding-left: 1848px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-66 {
  padding-right: 1848px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-66 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-66 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-67 {
  padding-left: 1894px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-67 {
  padding-right: 1894px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-67 {
  padding-left: 1876px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-67 {
  padding-right: 1876px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-67 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-67 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-68 {
  padding-left: 1922px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-68 {
  padding-right: 1922px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-68 {
  padding-left: 1904px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-68 {
  padding-right: 1904px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-68 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-68 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-69 {
  padding-left: 1950px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-69 {
  padding-right: 1950px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-69 {
  padding-left: 1932px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-69 {
  padding-right: 1932px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-69 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-69 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-70 {
  padding-left: 1978px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-70 {
  padding-right: 1978px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-70 {
  padding-left: 1960px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-70 {
  padding-right: 1960px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-70 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-70 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-71 {
  padding-left: 2006px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-71 {
  padding-right: 2006px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-71 {
  padding-left: 1988px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-71 {
  padding-right: 1988px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-71 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-71 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-72 {
  padding-left: 2034px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-72 {
  padding-right: 2034px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-72 {
  padding-left: 2016px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-72 {
  padding-right: 2016px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-72 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-72 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-73 {
  padding-left: 2062px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-73 {
  padding-right: 2062px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-73 {
  padding-left: 2044px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-73 {
  padding-right: 2044px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-73 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-73 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-74 {
  padding-left: 2090px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-74 {
  padding-right: 2090px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-74 {
  padding-left: 2072px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-74 {
  padding-right: 2072px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-74 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-74 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-75 {
  padding-left: 2118px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-75 {
  padding-right: 2118px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-75 {
  padding-left: 2100px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-75 {
  padding-right: 2100px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-75 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-75 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-76 {
  padding-left: 2146px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-76 {
  padding-right: 2146px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-76 {
  padding-left: 2128px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-76 {
  padding-right: 2128px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-76 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-76 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-77 {
  padding-left: 2174px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-77 {
  padding-right: 2174px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-77 {
  padding-left: 2156px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-77 {
  padding-right: 2156px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-77 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-77 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-78 {
  padding-left: 2202px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-78 {
  padding-right: 2202px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-78 {
  padding-left: 2184px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-78 {
  padding-right: 2184px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-78 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-78 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-79 {
  padding-left: 2230px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-79 {
  padding-right: 2230px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-79 {
  padding-left: 2212px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-79 {
  padding-right: 2212px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-79 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-79 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-80 {
  padding-left: 2258px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-80 {
  padding-right: 2258px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-80 {
  padding-left: 2240px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-80 {
  padding-right: 2240px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-80 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-80 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-81 {
  padding-left: 2286px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-81 {
  padding-right: 2286px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-81 {
  padding-left: 2268px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-81 {
  padding-right: 2268px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-81 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-81 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-82 {
  padding-left: 2314px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-82 {
  padding-right: 2314px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-82 {
  padding-left: 2296px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-82 {
  padding-right: 2296px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-82 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-82 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-83 {
  padding-left: 2342px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-83 {
  padding-right: 2342px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-83 {
  padding-left: 2324px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-83 {
  padding-right: 2324px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-83 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-83 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-84 {
  padding-left: 2370px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-84 {
  padding-right: 2370px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-84 {
  padding-left: 2352px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-84 {
  padding-right: 2352px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-84 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-84 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-85 {
  padding-left: 2398px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-85 {
  padding-right: 2398px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-85 {
  padding-left: 2380px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-85 {
  padding-right: 2380px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-85 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-85 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-86 {
  padding-left: 2426px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-86 {
  padding-right: 2426px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-86 {
  padding-left: 2408px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-86 {
  padding-right: 2408px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-86 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-86 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-87 {
  padding-left: 2454px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-87 {
  padding-right: 2454px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-87 {
  padding-left: 2436px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-87 {
  padding-right: 2436px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-87 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-87 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-88 {
  padding-left: 2482px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-88 {
  padding-right: 2482px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-88 {
  padding-left: 2464px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-88 {
  padding-right: 2464px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-88 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-88 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-89 {
  padding-left: 2510px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-89 {
  padding-right: 2510px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-89 {
  padding-left: 2492px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-89 {
  padding-right: 2492px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-89 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-89 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-90 {
  padding-left: 2538px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-90 {
  padding-right: 2538px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-90 {
  padding-left: 2520px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-90 {
  padding-right: 2520px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-90 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-90 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-91 {
  padding-left: 2566px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-91 {
  padding-right: 2566px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-91 {
  padding-left: 2548px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-91 {
  padding-right: 2548px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-91 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-91 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-92 {
  padding-left: 2594px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-92 {
  padding-right: 2594px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-92 {
  padding-left: 2576px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-92 {
  padding-right: 2576px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-92 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-92 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-93 {
  padding-left: 2622px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-93 {
  padding-right: 2622px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-93 {
  padding-left: 2604px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-93 {
  padding-right: 2604px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-93 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-93 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-94 {
  padding-left: 2650px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-94 {
  padding-right: 2650px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-94 {
  padding-left: 2632px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-94 {
  padding-right: 2632px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-94 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-94 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-95 {
  padding-left: 2678px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-95 {
  padding-right: 2678px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-95 {
  padding-left: 2660px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-95 {
  padding-right: 2660px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-95 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-95 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-96 {
  padding-left: 2706px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-96 {
  padding-right: 2706px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-96 {
  padding-left: 2688px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-96 {
  padding-right: 2688px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-96 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-96 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-97 {
  padding-left: 2734px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-97 {
  padding-right: 2734px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-97 {
  padding-left: 2716px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-97 {
  padding-right: 2716px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-97 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-97 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-98 {
  padding-left: 2762px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-98 {
  padding-right: 2762px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-98 {
  padding-left: 2744px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-98 {
  padding-right: 2744px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-98 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-98 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-99 {
  padding-left: 2790px;
}

.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-99 {
  padding-right: 2790px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-indent-99 {
  padding-left: 2772px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-indent-99 {
  padding-right: 2772px;
}

.ag-theme-alpine .ag-ltr .ag-row-level-99 .ag-pivot-leaf-group {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-level-99 .ag-pivot-leaf-group {
  margin-right: 28px;
}

.ag-theme-alpine .ag-ltr .ag-row-group-leaf-indent {
  margin-left: 28px;
}

.ag-theme-alpine .ag-rtl .ag-row-group-leaf-indent {
  margin-right: 28px;
}

.ag-theme-alpine .ag-value-change-delta {
  padding-right: 2px;
}
.ag-theme-alpine .ag-value-change-delta-up {
  color: #43a047;
  color: var(--ag-value-change-delta-up-color, #43a047);
}
.ag-theme-alpine .ag-value-change-delta-down {
  color: #e53935;
  color: var(--ag-value-change-delta-down-color, #e53935);
}
.ag-theme-alpine .ag-value-change-value {
  background-color: transparent;
  border-radius: 1px;
  padding-left: 1px;
  padding-right: 1px;
  -webkit-transition: background-color 1s;
  transition: background-color 1s;
}
.ag-theme-alpine .ag-value-change-value-highlight {
  background-color: rgba(22, 160, 133, 0.5);
  background-color: var(--ag-value-change-value-highlight-background-color, rgba(22, 160, 133, 0.5));
  -webkit-transition: background-color 0.1s;
  transition: background-color 0.1s;
}
.ag-theme-alpine .ag-cell-data-changed {
  background-color: rgba(22, 160, 133, 0.5) !important;
  background-color: var(--ag-value-change-value-highlight-background-color, rgba(22, 160, 133, 0.5)) !important;
}
.ag-theme-alpine .ag-cell-data-changed-animation {
  background-color: transparent;
}
.ag-theme-alpine .ag-cell-highlight {
  background-color: #2196f3 !important;
  background-color: var(--ag-range-selection-highlight-color, var(--ag-range-selection-border-color, #2196f3)) !important;
}
.ag-theme-alpine .ag-row {
  height: 42px;
  background-color: #fff;
  background-color: var(--ag-background-color, #fff);
  color: #181d1f;
  color: var(--ag-data-color, var(--ag-foreground-color, #181d1f));
  border-width: 1px;
  border-color: #dde2eb;
  border-color: var(--ag-row-border-color, var(--ag-secondary-border-color, #dde2eb));
  border-bottom-style: solid;
}
.ag-theme-alpine .ag-row-highlight-above::after, .ag-theme-alpine .ag-row-highlight-below::after {
  content: "";
  position: absolute;
  width: calc(100% - 1px);
  height: 1px;
  background-color: #2196f3;
  background-color: var(--ag-range-selection-border-color, #2196f3);
  left: 1px;
}
.ag-theme-alpine .ag-row-highlight-above::after {
  top: -1px;
}
.ag-theme-alpine .ag-row-highlight-above.ag-row-first::after {
  top: 0;
}
.ag-theme-alpine .ag-row-highlight-below::after {
  bottom: 0px;
}
.ag-theme-alpine .ag-row-odd {
  background-color: #fcfcfc;
  background-color: var(--ag-odd-row-background-color, #fcfcfc);
}
.ag-theme-alpine .ag-body-horizontal-scroll:not(.ag-scrollbar-invisible) .ag-horizontal-left-spacer:not(.ag-scroller-corner) {
  border-right: solid 1px;
  border-right-color: #babfc7;
  border-right-color: var(--ag-border-color, #babfc7);
}
.ag-theme-alpine .ag-body-horizontal-scroll:not(.ag-scrollbar-invisible) .ag-horizontal-right-spacer:not(.ag-scroller-corner) {
  border-left: solid 1px;
  border-left-color: #babfc7;
  border-left-color: var(--ag-border-color, #babfc7);
}
.ag-theme-alpine .ag-row-hover {
  background-color: rgba(33, 150, 243, 0.1);
  background-color: var(--ag-row-hover-color, rgba(33, 150, 243, 0.1));
}
.ag-theme-alpine .ag-column-hover {
  background-color: rgba(33, 150, 243, 0.1);
  background-color: var(--ag-column-hover-color, rgba(33, 150, 243, 0.1));
}
.ag-theme-alpine .ag-ltr .ag-right-aligned-cell {
  text-align: right;
}

.ag-theme-alpine .ag-rtl .ag-right-aligned-cell {
  text-align: left;
}

.ag-theme-alpine .ag-ltr .ag-right-aligned-cell .ag-cell-value, .ag-theme-alpine .ag-ltr .ag-right-aligned-cell .ag-group-value {
  margin-left: auto;
}

.ag-theme-alpine .ag-rtl .ag-right-aligned-cell .ag-cell-value, .ag-theme-alpine .ag-rtl .ag-right-aligned-cell .ag-group-value {
  margin-right: auto;
}

.ag-theme-alpine .ag-cell, .ag-theme-alpine .ag-full-width-row .ag-cell-wrapper.ag-row-group {
  border: 1px solid transparent;
  line-height: min(var(--ag-line-height, 40px), 40px);
  padding-left: 17px;
  padding-right: 17px;
  -webkit-font-smoothing: subpixel-antialiased;
}
.ag-theme-alpine .ag-row > .ag-cell-wrapper {
  padding-left: 17px;
  padding-right: 17px;
}
.ag-theme-alpine .ag-row-dragging {
  cursor: move;
  opacity: 0.5;
}
.ag-theme-alpine .ag-cell-inline-editing {
  border: solid 1px;
  border-color: #babfc7;
  border-color: var(--ag-border-color, #babfc7);
  background: #fff;
  background: var(--ag-background-color, #fff);
  border-radius: 3px;
  -webkit-box-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);
          box-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);
  padding: 6px;
  padding: 0;
  height: 42px;
  background-color: #f8f8f8;
  background-color: var(--ag-control-panel-background-color, #f8f8f8);
}
.ag-theme-alpine .ag-popup-editor {
  border: solid 1px;
  border-color: #babfc7;
  border-color: var(--ag-border-color, #babfc7);
  background: #fff;
  background: var(--ag-background-color, #fff);
  border-radius: 3px;
  -webkit-box-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);
          box-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);
  padding: 6px;
  background-color: #f8f8f8;
  background-color: var(--ag-control-panel-background-color, #f8f8f8);
  padding: 0;
}
.ag-theme-alpine .ag-large-text-input {
  height: auto;
  padding: 18px;
}
.ag-theme-alpine .ag-details-row {
  padding: 30px;
  background-color: #fff;
  background-color: var(--ag-background-color, #fff);
}
.ag-theme-alpine .ag-layout-auto-height .ag-center-cols-clipper, .ag-theme-alpine .ag-layout-auto-height .ag-center-cols-container, .ag-theme-alpine .ag-layout-print .ag-center-cols-clipper, .ag-theme-alpine .ag-layout-print .ag-center-cols-container {
  min-height: 50px;
}
.ag-theme-alpine .ag-overlay-loading-wrapper {
  background-color: rgba(255, 255, 255, 0.66);
  background-color: var(--ag-modal-overlay-background-color, rgba(255, 255, 255, 0.66));
}
.ag-theme-alpine .ag-overlay-loading-center {
  border: solid 1px;
  border-color: #babfc7;
  border-color: var(--ag-border-color, #babfc7);
  background: #fff;
  background: var(--ag-background-color, #fff);
  border-radius: 3px;
  -webkit-box-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);
          box-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);
  padding: 6px;
}
.ag-theme-alpine .ag-overlay-no-rows-wrapper.ag-layout-auto-height {
  padding-top: 30px;
}
.ag-theme-alpine .ag-loading {
  padding-left: 18px;
  display: -webkit-box;
  display: flex;
  height: 100%;
  -webkit-box-align: center;
          align-items: center;
}
.ag-theme-alpine .ag-loading-icon {
  padding-right: 12px;
}
.ag-theme-alpine .ag-icon-loading {
  -webkit-animation-name: spin;
          animation-name: spin;
  -webkit-animation-duration: 1000ms;
          animation-duration: 1000ms;
  -webkit-animation-iteration-count: infinite;
          animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;
          animation-timing-function: linear;
}
@-webkit-keyframes spin {
  from {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
@keyframes spin {
  from {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
.ag-theme-alpine .ag-floating-top {
  border-bottom: solid 1px;
  border-bottom-color: #babfc7;
  border-bottom-color: var(--ag-border-color, #babfc7);
}
.ag-theme-alpine .ag-floating-bottom {
  border-top: solid 1px;
  border-top-color: #babfc7;
  border-top-color: var(--ag-border-color, #babfc7);
}
.ag-theme-alpine .ag-ltr .ag-cell {
  border-right: solid transparent;
}

.ag-theme-alpine .ag-rtl .ag-cell {
  border-left: solid transparent;
}

.ag-theme-alpine .ag-ltr .ag-cell {
  border-right-width: 1px;
}

.ag-theme-alpine .ag-rtl .ag-cell {
  border-left-width: 1px;
}

.ag-theme-alpine .ag-cell.ag-cell-first-right-pinned:not(.ag-cell-range-left):not(.ag-cell-range-single-cell) {
  border-left: solid 1px;
  border-left-color: #babfc7;
  border-left-color: var(--ag-border-color, #babfc7);
}
.ag-theme-alpine .ag-cell.ag-cell-last-left-pinned:not(.ag-cell-range-right):not(.ag-cell-range-single-cell) {
  border-right: solid 1px;
  border-right-color: #babfc7;
  border-right-color: var(--ag-border-color, #babfc7);
}
.ag-theme-alpine .ag-row-selected {
  background-color: rgba(33, 150, 243, 0.3);
  background-color: var(--ag-selected-row-background-color, rgba(33, 150, 243, 0.3));
}
.ag-theme-alpine .ag-cell-range-selected:not(.ag-cell-focus),
.ag-theme-alpine .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing) {
  background-color: rgba(33, 150, 243, 0.2);
  background-color: var(--ag-range-selection-background-color, rgba(33, 150, 243, 0.2));
}
.ag-theme-alpine .ag-cell-range-selected:not(.ag-cell-focus).ag-cell-range-chart,
.ag-theme-alpine .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing).ag-cell-range-chart {
  background-color: rgba(0, 88, 255, 0.1) !important;
  background-color: var(--ag-range-selection-chart-background-color, rgba(0, 88, 255, 0.1)) !important;
}
.ag-theme-alpine .ag-cell-range-selected:not(.ag-cell-focus).ag-cell-range-chart.ag-cell-range-chart-category,
.ag-theme-alpine .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing).ag-cell-range-chart.ag-cell-range-chart-category {
  background-color: rgba(0, 255, 132, 0.1) !important;
  background-color: var(--ag-range-selection-chart-category-background-color, rgba(0, 255, 132, 0.1)) !important;
}
.ag-theme-alpine .ag-cell-range-selected-1:not(.ag-cell-focus),
.ag-theme-alpine .ag-root:not(.ag-context-menu-open) .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-1:not(.ag-cell-inline-editing) {
  background-color: rgba(33, 150, 243, 0.2);
  background-color: var(--ag-range-selection-background-color-1, var(--ag-range-selection-background-color, rgba(33, 150, 243, 0.2)));
}
.ag-theme-alpine .ag-cell-range-selected-2:not(.ag-cell-focus),
.ag-theme-alpine .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-2 {
  background-color: rgba(33, 150, 243, 0.36);
  background-color: var(--ag-range-selection-background-color-2, rgba(33, 150, 243, 0.36));
}
.ag-theme-alpine .ag-cell-range-selected-3:not(.ag-cell-focus),
.ag-theme-alpine .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-3 {
  background-color: rgba(33, 150, 243, 0.488);
  background-color: var(--ag-range-selection-background-color-3, rgba(33, 150, 243, 0.488));
}
.ag-theme-alpine .ag-cell-range-selected-4:not(.ag-cell-focus),
.ag-theme-alpine .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-4 {
  background-color: rgba(33, 150, 243, 0.5904);
  background-color: var(--ag-range-selection-background-color-4, rgba(33, 150, 243, 0.5904));
}
.ag-theme-alpine .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-top {
  border-top-color: #2196f3;
  border-top-color: var(--ag-range-selection-border-color, #2196f3);
}
.ag-theme-alpine .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-right {
  border-right-color: #2196f3;
  border-right-color: var(--ag-range-selection-border-color, #2196f3);
}
.ag-theme-alpine .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-bottom {
  border-bottom-color: #2196f3;
  border-bottom-color: var(--ag-range-selection-border-color, #2196f3);
}
.ag-theme-alpine .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-left {
  border-left-color: #2196f3;
  border-left-color: var(--ag-range-selection-border-color, #2196f3);
}
.ag-theme-alpine .ag-ltr .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected),
.ag-theme-alpine .ag-ltr .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),
.ag-theme-alpine .ag-ltr .ag-has-focus .ag-full-width-row.ag-row-focus .ag-cell-wrapper.ag-row-group,
.ag-theme-alpine .ag-ltr .ag-cell-range-single-cell,
.ag-theme-alpine .ag-ltr .ag-cell-range-single-cell.ag-cell-range-handle, .ag-theme-alpine .ag-rtl .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected),
.ag-theme-alpine .ag-rtl .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),
.ag-theme-alpine .ag-rtl .ag-has-focus .ag-full-width-row.ag-row-focus .ag-cell-wrapper.ag-row-group,
.ag-theme-alpine .ag-rtl .ag-cell-range-single-cell,
.ag-theme-alpine .ag-rtl .ag-cell-range-single-cell.ag-cell-range-handle {
  border: 1px solid;
  border-color: #2196f3;
  border-color: var(--ag-range-selection-border-color, #2196f3);
  outline: initial;
}
.ag-theme-alpine .ag-cell.ag-selection-fill-top,
.ag-theme-alpine .ag-cell.ag-selection-fill-top.ag-cell-range-selected {
  border-top: 1px dashed;
  border-top-color: #2196f3;
  border-top-color: var(--ag-range-selection-border-color, #2196f3);
}
.ag-theme-alpine .ag-ltr .ag-cell.ag-selection-fill-right, .ag-theme-alpine .ag-ltr .ag-cell.ag-selection-fill-right.ag-cell-range-selected {
  border-right: 1px dashed;
  border-right-color: #2196f3;
  border-right-color: var(--ag-range-selection-border-color, #2196f3);
}

.ag-theme-alpine .ag-rtl .ag-cell.ag-selection-fill-right, .ag-theme-alpine .ag-rtl .ag-cell.ag-selection-fill-right.ag-cell-range-selected {
  border-left: 1px dashed;
  border-left-color: #2196f3;
  border-left-color: var(--ag-range-selection-border-color, #2196f3);
}

.ag-theme-alpine .ag-cell.ag-selection-fill-bottom,
.ag-theme-alpine .ag-cell.ag-selection-fill-bottom.ag-cell-range-selected {
  border-bottom: 1px dashed;
  border-bottom-color: #2196f3;
  border-bottom-color: var(--ag-range-selection-border-color, #2196f3);
}
.ag-theme-alpine .ag-ltr .ag-cell.ag-selection-fill-left, .ag-theme-alpine .ag-ltr .ag-cell.ag-selection-fill-left.ag-cell-range-selected {
  border-left: 1px dashed;
  border-left-color: #2196f3;
  border-left-color: var(--ag-range-selection-border-color, #2196f3);
}

.ag-theme-alpine .ag-rtl .ag-cell.ag-selection-fill-left, .ag-theme-alpine .ag-rtl .ag-cell.ag-selection-fill-left.ag-cell-range-selected {
  border-right: 1px dashed;
  border-right-color: #2196f3;
  border-right-color: var(--ag-range-selection-border-color, #2196f3);
}

.ag-theme-alpine .ag-range-handle, .ag-theme-alpine .ag-fill-handle {
  position: absolute;
  width: 6px;
  height: 6px;
  bottom: -1px;
  background-color: #2196f3;
  background-color: var(--ag-range-selection-border-color, #2196f3);
}
.ag-theme-alpine .ag-ltr .ag-range-handle, .ag-theme-alpine .ag-ltr .ag-fill-handle {
  right: -1px;
}

.ag-theme-alpine .ag-rtl .ag-range-handle, .ag-theme-alpine .ag-rtl .ag-fill-handle {
  left: -1px;
}

.ag-theme-alpine .ag-fill-handle {
  cursor: cell;
}
.ag-theme-alpine .ag-range-handle {
  cursor: nwse-resize;
}
.ag-theme-alpine .ag-cell-inline-editing {
  border-color: rgba(33, 150, 243, 0.4) !important;
  border-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4)) !important;
}
.ag-theme-alpine .ag-menu {
  border: solid 1px;
  border-color: #babfc7;
  border-color: var(--ag-border-color, #babfc7);
  background: #fff;
  background: var(--ag-background-color, #fff);
  border-radius: 3px;
  -webkit-box-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);
          box-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);
  padding: 6px;
  padding: 0;
}
.ag-theme-alpine .ag-menu-list {
  cursor: default;
  padding: 6px 0;
}
.ag-theme-alpine .ag-menu-separator {
  height: 13px;
}
.ag-theme-alpine .ag-menu-separator-part::after {
  content: "";
  display: block;
  border-top: solid 1px;
  border-top-color: #babfc7;
  border-top-color: var(--ag-border-color, #babfc7);
}
.ag-theme-alpine .ag-menu-option-active, .ag-theme-alpine .ag-compact-menu-option-active {
  background-color: rgba(33, 150, 243, 0.1);
  background-color: var(--ag-row-hover-color, rgba(33, 150, 243, 0.1));
}
.ag-theme-alpine .ag-menu-option-part, .ag-theme-alpine .ag-compact-menu-option-part {
  line-height: 16px;
  padding: 8px 0;
}
.ag-theme-alpine .ag-menu-option-disabled, .ag-theme-alpine .ag-compact-menu-option-disabled {
  opacity: 0.5;
}
.ag-theme-alpine .ag-menu-option-icon, .ag-theme-alpine .ag-compact-menu-option-icon {
  width: 16px;
}
.ag-theme-alpine .ag-ltr .ag-menu-option-icon, .ag-theme-alpine .ag-ltr .ag-compact-menu-option-icon {
  padding-left: 12px;
}

.ag-theme-alpine .ag-rtl .ag-menu-option-icon, .ag-theme-alpine .ag-rtl .ag-compact-menu-option-icon {
  padding-right: 12px;
}

.ag-theme-alpine .ag-menu-option-text, .ag-theme-alpine .ag-compact-menu-option-text {
  padding-left: 12px;
  padding-right: 12px;
}
.ag-theme-alpine .ag-ltr .ag-menu-option-shortcut, .ag-theme-alpine .ag-ltr .ag-compact-menu-option-shortcut {
  padding-right: 6px;
}

.ag-theme-alpine .ag-rtl .ag-menu-option-shortcut, .ag-theme-alpine .ag-rtl .ag-compact-menu-option-shortcut {
  padding-left: 6px;
}

.ag-theme-alpine .ag-menu-option-popup-pointer, .ag-theme-alpine .ag-compact-menu-option-popup-pointer {
  padding-right: 6px;
}
.ag-theme-alpine .ag-tabs {
  min-width: 240px;
}
.ag-theme-alpine .ag-tabs-header {
  width: 100%;
  display: -webkit-box;
  display: flex;
}
.ag-theme-alpine .ag-tab {
  border-bottom: 2px solid transparent;
  display: -webkit-box;
  display: flex;
  -webkit-box-flex: 0;
          flex: none;
  -webkit-box-align: center;
          align-items: center;
  -webkit-box-pack: center;
          justify-content: center;
  cursor: pointer;
  -webkit-box-flex: 1;
          flex: 1 1 auto;
  -webkit-transition: border-bottom 0.3s;
  transition: border-bottom 0.3s;
}
.ag-theme-alpine .ag-keyboard-focus .ag-tab:focus {
  outline: none;
}
.ag-theme-alpine .ag-keyboard-focus .ag-tab:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: rgba(33, 150, 243, 0.4);
  border-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));
}
.ag-theme-alpine .ag-tab-selected {
  border-bottom-color: #2196f3;
  border-bottom-color: var(--ag-selected-tab-underline-color, var(--ag-alpine-active-color, #2196f3));
}
.ag-theme-alpine .ag-menu-header {
  color: #181d1f;
  color: var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f));
}
.ag-theme-alpine .ag-filter-separator {
  border-top: solid 1px;
  border-top-color: #babfc7;
  border-top-color: var(--ag-border-color, #babfc7);
}
.ag-theme-alpine .ag-menu:not(.ag-tabs) .ag-filter-select {
  min-width: 155px;
}
.ag-theme-alpine .ag-tabs .ag-filter-select {
  min-width: 214px;
}
.ag-theme-alpine .ag-filter-select .ag-picker-field-wrapper {
  width: 0;
}
.ag-theme-alpine .ag-filter-condition-operator {
  height: 17px;
}
.ag-theme-alpine .ag-ltr .ag-filter-condition-operator-or {
  margin-left: 12px;
}

.ag-theme-alpine .ag-rtl .ag-filter-condition-operator-or {
  margin-right: 12px;
}

.ag-theme-alpine .ag-set-filter-select-all {
  padding-top: 12px;
}
.ag-theme-alpine .ag-set-filter-list, .ag-theme-alpine .ag-filter-no-matches {
  height: 144px;
}
.ag-theme-alpine .ag-set-filter-filter {
  margin-top: 12px;
  margin-left: 12px;
  margin-right: 12px;
}
.ag-theme-alpine .ag-filter-to {
  margin-top: 9px;
}
.ag-theme-alpine .ag-mini-filter {
  margin: 12px 12px;
}
.ag-theme-alpine .ag-set-filter-item {
  margin: 0px 12px;
}
.ag-theme-alpine .ag-ltr .ag-set-filter-item-value {
  margin-left: 12px;
}

.ag-theme-alpine .ag-rtl .ag-set-filter-item-value {
  margin-right: 12px;
}

.ag-theme-alpine .ag-filter-apply-panel {
  padding: 12px 12px;
  border-top: solid 1px;
  border-top-color: #dde2eb;
  border-top-color: var(--ag-secondary-border-color, #dde2eb);
}
.ag-theme-alpine .ag-filter-apply-panel-button {
  line-height: 1.5;
}
.ag-theme-alpine .ag-ltr .ag-filter-apply-panel-button {
  margin-left: 12px;
}

.ag-theme-alpine .ag-rtl .ag-filter-apply-panel-button {
  margin-right: 12px;
}

.ag-theme-alpine .ag-simple-filter-body-wrapper {
  padding: 12px 12px;
  padding-bottom: 3px;
}
.ag-theme-alpine .ag-simple-filter-body-wrapper > * {
  margin-bottom: 9px;
}
.ag-theme-alpine .ag-filter-no-matches {
  padding: 12px 12px;
}
.ag-theme-alpine .ag-multi-filter-menu-item {
  margin: 6px 0;
}
.ag-theme-alpine .ag-multi-filter-group-title-bar {
  padding: 12px 6px;
  background-color: transparent;
}
.ag-theme-alpine .ag-keyboard-focus .ag-multi-filter-group-title-bar:focus {
  outline: none;
}
.ag-theme-alpine .ag-keyboard-focus .ag-multi-filter-group-title-bar:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: rgba(33, 150, 243, 0.4);
  border-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));
}
.ag-theme-alpine .ag-side-bar {
  position: relative;
}
.ag-theme-alpine .ag-tool-panel-wrapper {
  width: 250px;
  background-color: #f8f8f8;
  background-color: var(--ag-control-panel-background-color, #f8f8f8);
}
.ag-theme-alpine .ag-side-buttons {
  padding-top: 24px;
  width: 20px;
  position: relative;
  color: #181d1f;
  color: var(--ag-foreground-color, #181d1f);
  overflow: hidden;
}
.ag-theme-alpine button.ag-side-button-button {
  color: inherit;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  background: transparent;
  padding: 12px 0 12px 0;
  width: 100%;
  margin: 0;
  min-height: 108px;
  background-position-y: center;
  background-position-x: center;
  background-repeat: no-repeat;
  border: none;
}
.ag-theme-alpine button.ag-side-button-button:focus {
  -webkit-box-shadow: none;
          box-shadow: none;
}
.ag-theme-alpine .ag-keyboard-focus .ag-side-button-button:focus {
  outline: none;
}
.ag-theme-alpine .ag-keyboard-focus .ag-side-button-button:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: rgba(33, 150, 243, 0.4);
  border-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));
}
.ag-theme-alpine .ag-side-button-icon-wrapper {
  margin-bottom: 3px;
}
.ag-theme-alpine .ag-ltr .ag-side-bar-left,
.ag-theme-alpine .ag-rtl .ag-side-bar-right {
  border-right: solid 1px;
  border-right-color: #babfc7;
  border-right-color: var(--ag-border-color, #babfc7);
}
.ag-theme-alpine .ag-ltr .ag-side-bar-left .ag-tool-panel-wrapper,
.ag-theme-alpine .ag-rtl .ag-side-bar-right .ag-tool-panel-wrapper {
  border-left: solid 1px;
  border-left-color: #babfc7;
  border-left-color: var(--ag-border-color, #babfc7);
}
.ag-theme-alpine .ag-ltr .ag-side-bar-left .ag-side-button-button,
.ag-theme-alpine .ag-rtl .ag-side-bar-right .ag-side-button-button {
  border-right: 2px solid transparent;
  -webkit-transition: border-right 0.3s;
  transition: border-right 0.3s;
}
.ag-theme-alpine .ag-ltr .ag-side-bar-left .ag-selected .ag-side-button-button,
.ag-theme-alpine .ag-rtl .ag-side-bar-right .ag-selected .ag-side-button-button {
  border-right-color: #2196f3;
  border-right-color: var(--ag-selected-tab-underline-color, var(--ag-alpine-active-color, #2196f3));
}
.ag-theme-alpine .ag-rtl .ag-side-bar-left,
.ag-theme-alpine .ag-ltr .ag-side-bar-right {
  border-left: solid 1px;
  border-left-color: #babfc7;
  border-left-color: var(--ag-border-color, #babfc7);
}
.ag-theme-alpine .ag-rtl .ag-side-bar-left .ag-tool-panel-wrapper,
.ag-theme-alpine .ag-ltr .ag-side-bar-right .ag-tool-panel-wrapper {
  border-right: solid 1px;
  border-right-color: #babfc7;
  border-right-color: var(--ag-border-color, #babfc7);
}
.ag-theme-alpine .ag-rtl .ag-side-bar-left .ag-side-button-button,
.ag-theme-alpine .ag-ltr .ag-side-bar-right .ag-side-button-button {
  border-left: 2px solid transparent;
  -webkit-transition: border-left 0.3s;
  transition: border-left 0.3s;
}
.ag-theme-alpine .ag-rtl .ag-side-bar-left .ag-selected .ag-side-button-button,
.ag-theme-alpine .ag-ltr .ag-side-bar-right .ag-selected .ag-side-button-button {
  border-left-color: #2196f3;
  border-left-color: var(--ag-selected-tab-underline-color, var(--ag-alpine-active-color, #2196f3));
}
.ag-theme-alpine .ag-filter-toolpanel-header {
  height: 36px;
}
.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-header, .ag-theme-alpine .ag-ltr .ag-filter-toolpanel-search {
  padding-left: 6px;
}

.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-header, .ag-theme-alpine .ag-rtl .ag-filter-toolpanel-search {
  padding-right: 6px;
}

.ag-theme-alpine .ag-keyboard-focus .ag-filter-toolpanel-header:focus {
  outline: none;
}
.ag-theme-alpine .ag-keyboard-focus .ag-filter-toolpanel-header:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: rgba(33, 150, 243, 0.4);
  border-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));
}
.ag-theme-alpine .ag-filter-toolpanel-group.ag-has-filter > .ag-group-title-bar .ag-group-title::after {
  font-family: "agGridAlpine";
  font-size: 16px;
  line-height: 16px;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\\f114";
  position: absolute;
}
.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-group.ag-has-filter > .ag-group-title-bar .ag-group-title::after {
  padding-left: 6px;
}

.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-group.ag-has-filter > .ag-group-title-bar .ag-group-title::after {
  padding-right: 6px;
}

.ag-theme-alpine .ag-filter-toolpanel-group-level-0-header {
  height: 48px;
}
.ag-theme-alpine .ag-filter-toolpanel-group-item {
  margin-top: 3px;
  margin-bottom: 3px;
}
.ag-theme-alpine .ag-filter-toolpanel-search {
  height: 48px;
}
.ag-theme-alpine .ag-filter-toolpanel-search-input {
  -webkit-box-flex: 1;
          flex-grow: 1;
  height: 24px;
}
.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-search-input {
  margin-right: 6px;
}

.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-search-input {
  margin-left: 6px;
}

.ag-theme-alpine .ag-filter-toolpanel-group-level-0 {
  border-top: solid 1px;
  border-top-color: #dde2eb;
  border-top-color: var(--ag-secondary-border-color, #dde2eb);
}
.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-expand, .ag-theme-alpine .ag-ltr .ag-filter-toolpanel-group-title-bar-icon {
  margin-right: 6px;
}

.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-expand, .ag-theme-alpine .ag-rtl .ag-filter-toolpanel-group-title-bar-icon {
  margin-left: 6px;
}

.ag-theme-alpine .ag-filter-toolpanel-group-level-1 .ag-filter-toolpanel-group-level-1-header.ag-filter-toolpanel-group-title-bar {
  background-color: transparent;
}
.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-group-level-1 .ag-filter-toolpanel-group-level-2-header {
  padding-left: 22px;
}

.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-group-level-1 .ag-filter-toolpanel-group-level-2-header {
  padding-right: 22px;
}

.ag-theme-alpine .ag-filter-toolpanel-group-level-2 .ag-filter-toolpanel-group-level-2-header.ag-filter-toolpanel-group-title-bar {
  background-color: transparent;
}
.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-group-level-2 .ag-filter-toolpanel-group-level-3-header {
  padding-left: 38px;
}

.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-group-level-2 .ag-filter-toolpanel-group-level-3-header {
  padding-right: 38px;
}

.ag-theme-alpine .ag-filter-toolpanel-group-level-3 .ag-filter-toolpanel-group-level-3-header.ag-filter-toolpanel-group-title-bar {
  background-color: transparent;
}
.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-group-level-3 .ag-filter-toolpanel-group-level-4-header {
  padding-left: 54px;
}

.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-group-level-3 .ag-filter-toolpanel-group-level-4-header {
  padding-right: 54px;
}

.ag-theme-alpine .ag-filter-toolpanel-group-level-4 .ag-filter-toolpanel-group-level-4-header.ag-filter-toolpanel-group-title-bar {
  background-color: transparent;
}
.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-group-level-4 .ag-filter-toolpanel-group-level-5-header {
  padding-left: 70px;
}

.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-group-level-4 .ag-filter-toolpanel-group-level-5-header {
  padding-right: 70px;
}

.ag-theme-alpine .ag-filter-toolpanel-group-level-5 .ag-filter-toolpanel-group-level-5-header.ag-filter-toolpanel-group-title-bar {
  background-color: transparent;
}
.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-group-level-5 .ag-filter-toolpanel-group-level-6-header {
  padding-left: 86px;
}

.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-group-level-5 .ag-filter-toolpanel-group-level-6-header {
  padding-right: 86px;
}

.ag-theme-alpine .ag-filter-toolpanel-group-level-6 .ag-filter-toolpanel-group-level-6-header.ag-filter-toolpanel-group-title-bar {
  background-color: transparent;
}
.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-group-level-6 .ag-filter-toolpanel-group-level-7-header {
  padding-left: 102px;
}

.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-group-level-6 .ag-filter-toolpanel-group-level-7-header {
  padding-right: 102px;
}

.ag-theme-alpine .ag-filter-toolpanel-group-level-7 .ag-filter-toolpanel-group-level-7-header.ag-filter-toolpanel-group-title-bar {
  background-color: transparent;
}
.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-group-level-7 .ag-filter-toolpanel-group-level-8-header {
  padding-left: 118px;
}

.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-group-level-7 .ag-filter-toolpanel-group-level-8-header {
  padding-right: 118px;
}

.ag-theme-alpine .ag-filter-toolpanel-group-level-8 .ag-filter-toolpanel-group-level-8-header.ag-filter-toolpanel-group-title-bar {
  background-color: transparent;
}
.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-group-level-8 .ag-filter-toolpanel-group-level-9-header {
  padding-left: 134px;
}

.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-group-level-8 .ag-filter-toolpanel-group-level-9-header {
  padding-right: 134px;
}

.ag-theme-alpine .ag-filter-toolpanel-group-level-9 .ag-filter-toolpanel-group-level-9-header.ag-filter-toolpanel-group-title-bar {
  background-color: transparent;
}
.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-group-level-9 .ag-filter-toolpanel-group-level-10-header {
  padding-left: 150px;
}

.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-group-level-9 .ag-filter-toolpanel-group-level-10-header {
  padding-right: 150px;
}

.ag-theme-alpine .ag-filter-toolpanel-group-level-10 .ag-filter-toolpanel-group-level-10-header.ag-filter-toolpanel-group-title-bar {
  background-color: transparent;
}
.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-group-level-10 .ag-filter-toolpanel-group-level-11-header {
  padding-left: 166px;
}

.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-group-level-10 .ag-filter-toolpanel-group-level-11-header {
  padding-right: 166px;
}

.ag-theme-alpine .ag-filter-toolpanel-instance-header.ag-filter-toolpanel-group-level-1-header {
  padding-left: 6px;
}
.ag-theme-alpine .ag-filter-toolpanel-instance-filter {
  border-top: solid 1px;
  border-top-color: #babfc7;
  border-top-color: var(--ag-border-color, #babfc7);
  border-bottom: solid 1px;
  border-bottom-color: #babfc7;
  border-bottom-color: var(--ag-border-color, #babfc7);
  margin-top: 6px;
}
.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-instance-header-icon {
  margin-left: 6px;
}

.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-instance-header-icon {
  margin-right: 6px;
}

.ag-theme-alpine .ag-pivot-mode-panel {
  min-height: 48px;
  height: 48px;
  display: -webkit-box;
  display: flex;
}
.ag-theme-alpine .ag-pivot-mode-select {
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
          align-items: center;
}
.ag-theme-alpine .ag-ltr .ag-pivot-mode-select {
  margin-left: 12px;
}

.ag-theme-alpine .ag-rtl .ag-pivot-mode-select {
  margin-right: 12px;
}

.ag-theme-alpine .ag-keyboard-focus .ag-column-select-header:focus {
  outline: none;
}
.ag-theme-alpine .ag-keyboard-focus .ag-column-select-header:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: rgba(33, 150, 243, 0.4);
  border-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));
}
.ag-theme-alpine .ag-column-select-header {
  height: 48px;
  -webkit-box-align: center;
          align-items: center;
  padding: 0 12px;
  border-bottom: solid 1px;
  border-bottom-color: #dde2eb;
  border-bottom-color: var(--ag-secondary-border-color, #dde2eb);
}
.ag-theme-alpine .ag-column-panel-column-select {
  border-bottom: solid 1px;
  border-bottom-color: #dde2eb;
  border-bottom-color: var(--ag-secondary-border-color, #dde2eb);
  border-top: solid 1px;
  border-top-color: #dde2eb;
  border-top-color: var(--ag-secondary-border-color, #dde2eb);
}
.ag-theme-alpine .ag-column-group-icons,
.ag-theme-alpine .ag-column-select-header-icon {
  color: #181d1f;
  color: var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f));
}
.ag-theme-alpine .ag-column-select-list .ag-list-item-hovered::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
  background-color: #2196f3;
  background-color: var(--ag-range-selection-border-color, #2196f3);
}
.ag-theme-alpine .ag-column-select-list .ag-item-highlight-top::after {
  top: 0;
}
.ag-theme-alpine .ag-column-select-list .ag-item-highlight-bottom::after {
  bottom: 0;
}
.ag-theme-alpine .ag-header {
  background-color: #f8f8f8;
  background-color: var(--ag-header-background-color, #f8f8f8);
  border-bottom: solid 1px;
  border-bottom-color: #babfc7;
  border-bottom-color: var(--ag-border-color, #babfc7);
}
.ag-theme-alpine .ag-header-row {
  color: #181d1f;
  color: var(--ag-header-foreground-color, var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f)));
  height: 48px;
}
.ag-theme-alpine .ag-pinned-right-header {
  border-left: solid 1px;
  border-left-color: #babfc7;
  border-left-color: var(--ag-border-color, #babfc7);
}
.ag-theme-alpine .ag-pinned-left-header {
  border-right: solid 1px;
  border-right-color: #babfc7;
  border-right-color: var(--ag-border-color, #babfc7);
}
.ag-theme-alpine .ag-ltr .ag-header-cell:not(.ag-right-aligned-header) .ag-header-label-icon {
  margin-left: 6px;
}

.ag-theme-alpine .ag-rtl .ag-header-cell:not(.ag-right-aligned-header) .ag-header-label-icon {
  margin-right: 6px;
}

.ag-theme-alpine .ag-ltr .ag-header-cell.ag-right-aligned-header .ag-header-label-icon {
  margin-right: 6px;
}

.ag-theme-alpine .ag-rtl .ag-header-cell.ag-right-aligned-header .ag-header-label-icon {
  margin-left: 6px;
}

.ag-theme-alpine .ag-header-cell,
.ag-theme-alpine .ag-header-group-cell {
  padding-left: 18px;
  padding-right: 18px;
}
.ag-theme-alpine .ag-header-cell.ag-header-cell-moving,
.ag-theme-alpine .ag-header-group-cell.ag-header-cell-moving {
  background-color: #fff;
  background-color: var(--ag-header-cell-moving-background-color, var(--ag-background-color, #fff));
}
.ag-theme-alpine .ag-keyboard-focus .ag-header-cell:focus {
  outline: none;
}
.ag-theme-alpine .ag-keyboard-focus .ag-header-cell:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: rgba(33, 150, 243, 0.4);
  border-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));
}
.ag-theme-alpine .ag-keyboard-focus .ag-header-group-cell:focus {
  outline: none;
}
.ag-theme-alpine .ag-keyboard-focus .ag-header-group-cell:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: rgba(33, 150, 243, 0.4);
  border-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));
}
.ag-theme-alpine .ag-header-icon {
  color: #181d1f;
  color: var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f));
}
.ag-theme-alpine .ag-header-expand-icon {
  cursor: pointer;
}
.ag-theme-alpine .ag-ltr .ag-header-expand-icon {
  padding-left: 4px;
}

.ag-theme-alpine .ag-rtl .ag-header-expand-icon {
  padding-right: 4px;
}

.ag-theme-alpine .ag-header-row:not(:first-child) .ag-header-cell,
.ag-theme-alpine .ag-header-row:not(:first-child) .ag-header-group-cell.ag-header-group-cell-with-group {
  border-top: solid 1px;
  border-top-color: #babfc7;
  border-top-color: var(--ag-border-color, #babfc7);
}
.ag-theme-alpine .ag-header-cell-resize {
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
          align-items: center;
}
.ag-theme-alpine .ag-header-cell-resize::after {
  content: "";
  position: absolute;
  z-index: 1;
  display: block;
  left: calc(50% - 1px);
  width: 2px;
  height: 30%;
  top: calc(50% - 15%);
  background-color: rgba(186, 191, 199, 0.5);
  background-color: var(--ag-header-column-resize-handle-color, rgba(186, 191, 199, 0.5));
}
.ag-theme-alpine .ag-pinned-right-header .ag-header-cell-resize::after {
  left: calc(50% - 2px);
}
.ag-theme-alpine .ag-ltr .ag-header-select-all {
  margin-right: 18px;
}

.ag-theme-alpine .ag-rtl .ag-header-select-all {
  margin-left: 18px;
}

.ag-theme-alpine .ag-ltr .ag-floating-filter-button {
  margin-left: 18px;
}

.ag-theme-alpine .ag-rtl .ag-floating-filter-button {
  margin-right: 18px;
}

.ag-theme-alpine .ag-floating-filter-button-button {
  color: inherit;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background: transparent;
  border: none;
  height: 16px;
  padding: 0;
  width: 16px;
}
.ag-theme-alpine .ag-filter-loading {
  background-color: #f8f8f8;
  background-color: var(--ag-control-panel-background-color, #f8f8f8);
  height: 100%;
  padding: 12px 12px;
  position: absolute;
  width: 100%;
  z-index: 1;
}
.ag-theme-alpine .ag-paging-panel {
  border-top: 1px solid;
  border-top-color: #babfc7;
  border-top-color: var(--ag-border-color, #babfc7);
  color: #181d1f;
  color: var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f));
  height: 48px;
}
.ag-theme-alpine .ag-paging-panel > * {
  margin: 0 18px;
}
.ag-theme-alpine .ag-paging-button {
  cursor: pointer;
}
.ag-theme-alpine .ag-paging-button.ag-disabled {
  cursor: default;
  color: rgba(24, 29, 31, 0.5);
  color: var(--ag-disabled-foreground-color, rgba(24, 29, 31, 0.5));
}
.ag-theme-alpine .ag-keyboard-focus .ag-paging-button:focus {
  outline: none;
}
.ag-theme-alpine .ag-keyboard-focus .ag-paging-button:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 0px;
  left: 0px;
  display: block;
  width: calc(100% - 0px);
  height: calc(100% - 0px);
  border: 1px solid;
  border-color: rgba(33, 150, 243, 0.4);
  border-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));
}
.ag-theme-alpine .ag-paging-button, .ag-theme-alpine .ag-paging-description {
  margin: 0 6px;
}
.ag-theme-alpine .ag-status-bar {
  border-top: solid 1px;
  border-top-color: #babfc7;
  border-top-color: var(--ag-border-color, #babfc7);
  color: rgba(24, 29, 31, 0.5);
  color: var(--ag-disabled-foreground-color, rgba(24, 29, 31, 0.5));
  padding-right: 24px;
  padding-left: 24px;
  line-height: 1.5;
}
.ag-theme-alpine .ag-status-name-value-value {
  color: #181d1f;
  color: var(--ag-foreground-color, #181d1f);
}
.ag-theme-alpine .ag-status-bar-center {
  text-align: center;
}
.ag-theme-alpine .ag-status-name-value {
  margin-left: 6px;
  margin-right: 6px;
  padding-top: 12px;
  padding-bottom: 12px;
}
.ag-theme-alpine .ag-column-drop-cell {
  background: rgba(24, 29, 31, 0.07);
  background: var(--ag-chip-background-color, rgba(24, 29, 31, 0.07));
  border-radius: 24px;
  height: 24px;
  padding: 0 3px;
  border: 1px solid transparent;
}
.ag-theme-alpine .ag-keyboard-focus .ag-column-drop-cell:focus {
  outline: none;
}
.ag-theme-alpine .ag-keyboard-focus .ag-column-drop-cell:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 2px;
  left: 2px;
  display: block;
  width: calc(100% - 4px);
  height: calc(100% - 4px);
  border: 1px solid;
  border-color: rgba(33, 150, 243, 0.4);
  border-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));
}
.ag-theme-alpine .ag-column-drop-cell-text {
  margin: 0 6px;
}
.ag-theme-alpine .ag-column-drop-cell-button {
  min-width: 24px;
  margin: 0 3px;
  color: #181d1f;
  color: var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f));
}
.ag-theme-alpine .ag-column-drop-cell-drag-handle {
  margin-left: 12px;
}
.ag-theme-alpine .ag-column-drop-cell-ghost {
  opacity: 0.5;
}
.ag-theme-alpine .ag-column-drop-horizontal {
  background-color: #f8f8f8;
  background-color: var(--ag-control-panel-background-color, #f8f8f8);
  color: #181d1f;
  color: var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f));
  height: 42px;
  border-bottom: solid 1px;
  border-bottom-color: #babfc7;
  border-bottom-color: var(--ag-border-color, #babfc7);
}
.ag-theme-alpine .ag-ltr .ag-column-drop-horizontal {
  padding-left: 18px;
}

.ag-theme-alpine .ag-rtl .ag-column-drop-horizontal {
  padding-right: 18px;
}

.ag-theme-alpine .ag-ltr .ag-column-drop-horizontal-half-width:not(:last-child) {
  border-right: solid 1px;
  border-right-color: #babfc7;
  border-right-color: var(--ag-border-color, #babfc7);
}

.ag-theme-alpine .ag-rtl .ag-column-drop-horizontal-half-width:not(:last-child) {
  border-left: solid 1px;
  border-left-color: #babfc7;
  border-left-color: var(--ag-border-color, #babfc7);
}

.ag-theme-alpine .ag-column-drop-horizontal-cell-separator {
  margin: 0 6px;
  color: #181d1f;
  color: var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f));
}
.ag-theme-alpine .ag-column-drop-horizontal-empty-message {
  color: rgba(24, 29, 31, 0.5);
  color: var(--ag-disabled-foreground-color, rgba(24, 29, 31, 0.5));
}
.ag-theme-alpine .ag-ltr .ag-column-drop-horizontal-icon {
  margin-right: 18px;
}

.ag-theme-alpine .ag-rtl .ag-column-drop-horizontal-icon {
  margin-left: 18px;
}

.ag-theme-alpine .ag-column-drop-vertical-list {
  padding-bottom: 6px;
  padding-right: 6px;
  padding-left: 6px;
}
.ag-theme-alpine .ag-column-drop-vertical-cell {
  margin-top: 6px;
}
.ag-theme-alpine .ag-column-drop-vertical {
  min-height: 50px;
  border-bottom: solid 1px;
  border-bottom-color: #dde2eb;
  border-bottom-color: var(--ag-secondary-border-color, #dde2eb);
}
.ag-theme-alpine .ag-column-drop-vertical.ag-last-column-drop {
  border-bottom: none;
}
.ag-theme-alpine .ag-column-drop-vertical-icon {
  margin-left: 6px;
  margin-right: 6px;
}
.ag-theme-alpine .ag-column-drop-vertical-empty-message {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  color: rgba(24, 29, 31, 0.5);
  color: var(--ag-disabled-foreground-color, rgba(24, 29, 31, 0.5));
  margin-top: 6px;
}
.ag-theme-alpine .ag-select-agg-func-popup {
  border: solid 1px;
  border-color: #babfc7;
  border-color: var(--ag-border-color, #babfc7);
  background: #fff;
  background: var(--ag-background-color, #fff);
  border-radius: 3px;
  -webkit-box-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);
          box-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);
  padding: 6px;
  background: #fff;
  background: var(--ag-background-color, #fff);
  height: 105px;
  padding: 0;
}
.ag-theme-alpine .ag-select-agg-func-virtual-list-item {
  cursor: default;
  padding-left: 12px;
}
.ag-theme-alpine .ag-select-agg-func-virtual-list-item:hover {
  background-color: rgba(33, 150, 243, 0.3);
  background-color: var(--ag-selected-row-background-color, rgba(33, 150, 243, 0.3));
}
.ag-theme-alpine .ag-keyboard-focus .ag-select-agg-func-virtual-list-item:focus {
  outline: none;
}
.ag-theme-alpine .ag-keyboard-focus .ag-select-agg-func-virtual-list-item:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 1px;
  left: 1px;
  display: block;
  width: calc(100% - 2px);
  height: calc(100% - 2px);
  border: 1px solid;
  border-color: rgba(33, 150, 243, 0.4);
  border-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));
}
.ag-theme-alpine .ag-chart-menu {
  border-radius: 3px;
  background: #fff;
  background: var(--ag-background-color, #fff);
}
.ag-theme-alpine .ag-chart-menu-icon {
  opacity: 0.5;
  line-height: 24px;
  font-size: 24px;
  width: 24px;
  height: 24px;
  margin: 2px 0;
  cursor: pointer;
  border-radius: 3px;
  color: #181d1f;
  color: var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f));
}
.ag-theme-alpine .ag-chart-menu-icon:hover {
  opacity: 1;
}
.ag-theme-alpine .ag-chart-mini-thumbnail {
  border: 1px solid;
  border-color: #dde2eb;
  border-color: var(--ag-secondary-border-color, #dde2eb);
  border-radius: 5px;
  margin: 5px;
}
.ag-theme-alpine .ag-chart-mini-thumbnail:nth-last-child(3), .ag-theme-alpine .ag-chart-mini-thumbnail:nth-last-child(3) ~ .ag-chart-mini-thumbnail {
  margin-left: auto;
  margin-right: auto;
}
.ag-theme-alpine .ag-ltr .ag-chart-mini-thumbnail:first-child {
  margin-left: 0;
}

.ag-theme-alpine .ag-rtl .ag-chart-mini-thumbnail:first-child {
  margin-right: 0;
}

.ag-theme-alpine .ag-ltr .ag-chart-mini-thumbnail:last-child {
  margin-right: 0;
}

.ag-theme-alpine .ag-rtl .ag-chart-mini-thumbnail:last-child {
  margin-left: 0;
}

.ag-theme-alpine .ag-chart-mini-thumbnail.ag-selected {
  border-color: #2196f3;
  border-color: var(--ag-minichart-selected-chart-color, var(--ag-checkbox-checked-color, var(--ag-alpine-active-color, #2196f3)));
}
.ag-theme-alpine .ag-chart-settings-card-item {
  background: #181d1f;
  background: var(--ag-foreground-color, #181d1f);
  width: 8px;
  height: 8px;
  border-radius: 4px;
}
.ag-theme-alpine .ag-chart-settings-card-item.ag-selected {
  background-color: #2196f3;
  background-color: var(--ag-minichart-selected-page-color, var(--ag-checkbox-checked-color, var(--ag-alpine-active-color, #2196f3)));
}
.ag-theme-alpine .ag-chart-data-column-drag-handle {
  margin-left: 6px;
}
.ag-theme-alpine .ag-charts-settings-group-title-bar,
.ag-theme-alpine .ag-charts-data-group-title-bar,
.ag-theme-alpine .ag-charts-format-top-level-group-title-bar {
  border-top: solid 1px;
  border-top-color: #dde2eb;
  border-top-color: var(--ag-secondary-border-color, #dde2eb);
}
.ag-theme-alpine .ag-charts-settings-group-container {
  padding: 6px;
}
.ag-theme-alpine .ag-charts-data-group-container {
  padding: 6px 12px;
}
.ag-theme-alpine .ag-charts-data-group-container .ag-charts-data-group-item:not(.ag-charts-format-sub-level-group) {
  height: 24px;
}
.ag-theme-alpine .ag-charts-data-group-container .ag-list-item-hovered::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
  background-color: #2196f3;
  background-color: var(--ag-range-selection-border-color, #2196f3);
}
.ag-theme-alpine .ag-charts-data-group-container .ag-item-highlight-top::after {
  top: 0;
}
.ag-theme-alpine .ag-charts-data-group-container .ag-item-highlight-bottom::after {
  bottom: 0;
}
.ag-theme-alpine .ag-charts-format-top-level-group-container {
  margin-left: 12px;
  padding: 6px;
}
.ag-theme-alpine .ag-charts-format-top-level-group-item {
  margin: 6px 0;
}
.ag-theme-alpine .ag-charts-format-sub-level-group-container {
  padding: 12px 12px;
  padding-bottom: 3px;
}
.ag-theme-alpine .ag-charts-format-sub-level-group-container > * {
  margin-bottom: 9px;
}
.ag-theme-alpine .ag-charts-group-container.ag-group-container-horizontal {
  padding: 6px;
}
.ag-theme-alpine .ag-chart-data-section,
.ag-theme-alpine .ag-chart-format-section {
  display: -webkit-box;
  display: flex;
  margin: 0;
}
.ag-theme-alpine .ag-chart-menu-panel {
  background-color: #f8f8f8;
  background-color: var(--ag-control-panel-background-color, #f8f8f8);
}
.ag-theme-alpine .ag-ltr .ag-chart-menu-panel {
  border-left: solid 1px;
  border-left-color: #babfc7;
  border-left-color: var(--ag-border-color, #babfc7);
}

.ag-theme-alpine .ag-rtl .ag-chart-menu-panel {
  border-right: solid 1px;
  border-right-color: #babfc7;
  border-right-color: var(--ag-border-color, #babfc7);
}

.ag-theme-alpine .ag-date-time-list-page-title {
  -webkit-box-flex: 1;
          flex-grow: 1;
  text-align: center;
}
.ag-theme-alpine .ag-date-time-list-page-column-label {
  text-align: center;
}
.ag-theme-alpine .ag-date-time-list-page-entry {
  text-align: center;
}
.ag-theme-alpine .ag-checkbox-input-wrapper {
  font-family: "agGridAlpine";
  font-size: 16px;
  line-height: 16px;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 16px;
  height: 16px;
  background-color: #fff;
  background-color: var(--ag-checkbox-background-color, var(--ag-background-color, #fff));
  border-radius: 3px;
  display: inline-block;
  vertical-align: middle;
  -webkit-box-flex: 0;
          flex: none;
}
.ag-theme-alpine .ag-checkbox-input-wrapper input, .ag-theme-alpine .ag-checkbox-input-wrapper input {
  -webkit-appearance: none;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.ag-theme-alpine .ag-checkbox-input-wrapper:focus-within, .ag-theme-alpine .ag-checkbox-input-wrapper:active {
  outline: none;
  -webkit-box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);
          box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);
}
.ag-theme-alpine .ag-checkbox-input-wrapper.ag-disabled {
  opacity: 0.5;
}
.ag-theme-alpine .ag-checkbox-input-wrapper::after {
  content: "\\f108";
  color: #999;
  color: var(--ag-checkbox-unchecked-color, #999);
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}
.ag-theme-alpine .ag-checkbox-input-wrapper.ag-checked::after {
  content: "\\f106";
  color: #2196f3;
  color: var(--ag-checkbox-checked-color, var(--ag-alpine-active-color, #2196f3));
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}
.ag-theme-alpine .ag-checkbox-input-wrapper.ag-indeterminate::after {
  content: "\\f107";
  color: #999;
  color: var(--ag-checkbox-indeterminate-color, var(--ag-checkbox-unchecked-color, #999));
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}
.ag-theme-alpine .ag-toggle-button-input-wrapper {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  width: 28px;
  height: 18px;
  background-color: #999;
  background-color: var(--ag-toggle-button-off-background-color, var(--ag-checkbox-unchecked-color, #999));
  border-radius: 9px;
  position: relative;
  -webkit-box-flex: 0;
          flex: none;
  border: 1px solid;
  border-color: #999;
  border-color: var(--ag-toggle-button-off-border-color, var(--ag-checkbox-unchecked-color, #999));
}
.ag-theme-alpine .ag-toggle-button-input-wrapper input {
  opacity: 0;
  height: 100%;
  width: 100%;
}
.ag-theme-alpine .ag-toggle-button-input-wrapper:focus-within {
  outline: none;
  -webkit-box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);
          box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);
}
.ag-theme-alpine .ag-toggle-button-input-wrapper.ag-disabled {
  opacity: 0.5;
}
.ag-theme-alpine .ag-toggle-button-input-wrapper.ag-checked {
  background-color: #2196f3;
  background-color: var(--ag-toggle-button-on-background-color, var(--ag-checkbox-checked-color, var(--ag-alpine-active-color, #2196f3)));
  border-color: #2196f3;
  border-color: var(--ag-toggle-button-on-border-color, var(--ag-checkbox-checked-color, var(--ag-alpine-active-color, #2196f3)));
}
.ag-theme-alpine .ag-toggle-button-input-wrapper::before {
  content: " ";
  position: absolute;
  top: -1px;
  left: -1px;
  display: block;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  height: 18px;
  width: 18px;
  background-color: #fff;
  background-color: var(--ag-toggle-button-switch-background-color, var(--ag-background-color, #fff));
  border-radius: 9px;
  -webkit-transition: left 100ms;
  transition: left 100ms;
  border: 1px solid;
  border-color: #999;
  border-color: var(--ag-toggle-button-switch-border-color, var(--ag-toggle-button-off-border-color, var(--ag-checkbox-unchecked-color, #999)));
}
.ag-theme-alpine .ag-toggle-button-input-wrapper.ag-checked::before {
  left: calc(100% - 18px );
  border-color: #2196f3;
  border-color: var(--ag-toggle-button-on-border-color, var(--ag-checkbox-checked-color, var(--ag-alpine-active-color, #2196f3)));
}
.ag-theme-alpine .ag-radio-button-input-wrapper {
  font-family: "agGridAlpine";
  font-size: 16px;
  line-height: 16px;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 16px;
  height: 16px;
  background-color: #fff;
  background-color: var(--ag-checkbox-background-color, var(--ag-background-color, #fff));
  border-radius: 3px;
  display: inline-block;
  vertical-align: middle;
  -webkit-box-flex: 0;
          flex: none;
  border-radius: 16px;
}
.ag-theme-alpine .ag-radio-button-input-wrapper input, .ag-theme-alpine .ag-radio-button-input-wrapper input {
  -webkit-appearance: none;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.ag-theme-alpine .ag-radio-button-input-wrapper:focus-within, .ag-theme-alpine .ag-radio-button-input-wrapper:active {
  outline: none;
  -webkit-box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);
          box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);
}
.ag-theme-alpine .ag-radio-button-input-wrapper.ag-disabled {
  opacity: 0.5;
}
.ag-theme-alpine .ag-radio-button-input-wrapper::after {
  content: "\\f126";
  color: #999;
  color: var(--ag-checkbox-unchecked-color, #999);
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}
.ag-theme-alpine .ag-radio-button-input-wrapper.ag-checked::after {
  content: "\\f127";
  color: #2196f3;
  color: var(--ag-checkbox-checked-color, var(--ag-alpine-active-color, #2196f3));
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}
.ag-theme-alpine input[class^=ag-][type=range] {
  -webkit-appearance: none;
  width: 100%;
  height: 100%;
  background: none;
  overflow: visible;
}
.ag-theme-alpine input[class^=ag-][type=range]::-webkit-slider-runnable-track {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 3px;
  background-color: #babfc7;
  background-color: var(--ag-border-color, #babfc7);
  border-radius: 3px;
  border-radius: 3px;
}
.ag-theme-alpine input[class^=ag-][type=range]::-moz-range-track {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 3px;
  background-color: #babfc7;
  background-color: var(--ag-border-color, #babfc7);
  border-radius: 3px;
  border-radius: 3px;
}
.ag-theme-alpine input[class^=ag-][type=range]::-ms-track {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 3px;
  background-color: #babfc7;
  background-color: var(--ag-border-color, #babfc7);
  border-radius: 3px;
  border-radius: 3px;
  color: transparent;
  width: calc(100% - 2px);
}
.ag-theme-alpine input[class^=ag-][type=range]::-webkit-slider-thumb {
  margin: 0;
  padding: 0;
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  background-color: #fff;
  background-color: var(--ag-background-color, #fff);
  border: 1px solid;
  border-color: #999;
  border-color: var(--ag-checkbox-unchecked-color, #999);
  border-radius: 16px;
  -webkit-transform: translateY(-6.5px);
          transform: translateY(-6.5px);
}
.ag-theme-alpine input[class^=ag-][type=range]::-ms-thumb {
  margin: 0;
  padding: 0;
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  background-color: #fff;
  background-color: var(--ag-background-color, #fff);
  border: 1px solid;
  border-color: #999;
  border-color: var(--ag-checkbox-unchecked-color, #999);
  border-radius: 16px;
}
.ag-theme-alpine input[class^=ag-][type=range]::-moz-ag-range-thumb {
  margin: 0;
  padding: 0;
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  background-color: #fff;
  background-color: var(--ag-background-color, #fff);
  border: 1px solid;
  border-color: #999;
  border-color: var(--ag-checkbox-unchecked-color, #999);
  border-radius: 16px;
}
.ag-theme-alpine input[class^=ag-][type=range]:focus {
  outline: none;
}
.ag-theme-alpine input[class^=ag-][type=range]:focus::-webkit-slider-thumb {
  -webkit-box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);
          box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);
  border-color: #2196f3;
  border-color: var(--ag-checkbox-checked-color, var(--ag-alpine-active-color, #2196f3));
}
.ag-theme-alpine input[class^=ag-][type=range]:focus::-ms-thumb {
  box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);
  border-color: #2196f3;
  border-color: var(--ag-checkbox-checked-color, var(--ag-alpine-active-color, #2196f3));
}
.ag-theme-alpine input[class^=ag-][type=range]:focus::-moz-ag-range-thumb {
  box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);
  border-color: #2196f3;
  border-color: var(--ag-checkbox-checked-color, var(--ag-alpine-active-color, #2196f3));
}
.ag-theme-alpine input[class^=ag-][type=range]:active::-webkit-slider-runnable-track {
  background-color: rgba(33, 150, 243, 0.4);
  background-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));
}
.ag-theme-alpine input[class^=ag-][type=range]:active::-moz-ag-range-track {
  background-color: rgba(33, 150, 243, 0.4);
  background-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));
}
.ag-theme-alpine input[class^=ag-][type=range]:active::-ms-track {
  background-color: rgba(33, 150, 243, 0.4);
  background-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));
}
.ag-theme-alpine input[class^=ag-][type=range]:disabled {
  opacity: 0.5;
}
.ag-theme-alpine .ag-filter-toolpanel-header,
.ag-theme-alpine .ag-filter-toolpanel-search,
.ag-theme-alpine .ag-status-bar,
.ag-theme-alpine .ag-header-row,
.ag-theme-alpine .ag-panel-title-bar-title,
.ag-theme-alpine .ag-multi-filter-group-title-bar {
  font-weight: 700;
  color: #181d1f;
  color: var(--ag-header-foreground-color, var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f)));
}
.ag-theme-alpine .ag-rtl .ag-pinned-left-header .ag-header-row::before, .ag-theme-alpine .ag-ltr .ag-pinned-right-header .ag-header-row::after {
  content: "";
  position: absolute;
  height: calc(100% - 20px);
  top: 10px;
  width: 1px;
  background-color: #babfc7;
  background-color: var(--ag-border-color, #babfc7);
}
.ag-theme-alpine .ag-ltr .ag-pinned-right-header .ag-header-row::after {
  right: 0;
}
.ag-theme-alpine .ag-rtl .ag-pinned-left-header .ag-header-row::before {
  left: 0;
}
.ag-theme-alpine .ag-row {
  font-size: 14px;
}
.ag-theme-alpine input[class^=ag-]:not([type]),
.ag-theme-alpine input[class^=ag-][type=text],
.ag-theme-alpine input[class^=ag-][type=number],
.ag-theme-alpine input[class^=ag-][type=tel],
.ag-theme-alpine input[class^=ag-][type=date],
.ag-theme-alpine input[class^=ag-][type=datetime-local],
.ag-theme-alpine textarea[class^=ag-] {
  min-height: 24px;
  border-radius: 3px;
}
.ag-theme-alpine .ag-ltr input[class^=ag-]:not([type]),
.ag-theme-alpine .ag-ltr input[class^=ag-][type=text],
.ag-theme-alpine .ag-ltr input[class^=ag-][type=number],
.ag-theme-alpine .ag-ltr input[class^=ag-][type=tel],
.ag-theme-alpine .ag-ltr input[class^=ag-][type=date],
.ag-theme-alpine .ag-ltr input[class^=ag-][type=datetime-local],
.ag-theme-alpine .ag-ltr textarea[class^=ag-] {
  padding-left: 6px;
}

.ag-theme-alpine .ag-rtl input[class^=ag-]:not([type]),
.ag-theme-alpine .ag-rtl input[class^=ag-][type=text],
.ag-theme-alpine .ag-rtl input[class^=ag-][type=number],
.ag-theme-alpine .ag-rtl input[class^=ag-][type=tel],
.ag-theme-alpine .ag-rtl input[class^=ag-][type=date],
.ag-theme-alpine .ag-rtl input[class^=ag-][type=datetime-local],
.ag-theme-alpine .ag-rtl textarea[class^=ag-] {
  padding-right: 6px;
}

.ag-theme-alpine .ag-tab {
  padding: 9px;
  -webkit-transition: color 0.4s;
  transition: color 0.4s;
}
.ag-theme-alpine .ag-tab-selected {
  color: #2196f3;
  color: var(--ag-alpine-active-color, #2196f3);
}
.ag-theme-alpine .ag-menu {
  background-color: #f8f8f8;
  background-color: var(--ag-control-panel-background-color, #f8f8f8);
}
.ag-theme-alpine .ag-menu-header {
  background-color: #f8f8f8;
  background-color: var(--ag-control-panel-background-color, #f8f8f8);
  padding-top: 1px;
}
.ag-theme-alpine .ag-tabs-header {
  border-bottom: solid 1px;
  border-bottom-color: #babfc7;
  border-bottom-color: var(--ag-border-color, #babfc7);
}
.ag-theme-alpine .ag-charts-settings-group-title-bar,
.ag-theme-alpine .ag-charts-data-group-title-bar,
.ag-theme-alpine .ag-charts-format-top-level-group-title-bar {
  padding: 6px 12px;
  line-height: 20px;
}
.ag-theme-alpine .ag-chart-mini-thumbnail {
  background-color: #fff;
  background-color: var(--ag-background-color, #fff);
}
.ag-theme-alpine .ag-chart-settings-nav-bar {
  border-top: solid 1px;
  border-top-color: #dde2eb;
  border-top-color: var(--ag-secondary-border-color, #dde2eb);
}
.ag-theme-alpine .ag-ltr .ag-group-title-bar-icon {
  margin-right: 6px;
}

.ag-theme-alpine .ag-rtl .ag-group-title-bar-icon {
  margin-left: 6px;
}

.ag-theme-alpine .ag-charts-format-top-level-group-toolbar {
  margin-top: 6px;
}
.ag-theme-alpine .ag-ltr .ag-charts-format-top-level-group-toolbar {
  padding-left: 20px;
}

.ag-theme-alpine .ag-rtl .ag-charts-format-top-level-group-toolbar {
  padding-right: 20px;
}

.ag-theme-alpine .ag-charts-format-sub-level-group {
  border-left: dashed 1px;
  border-left-color: #babfc7;
  border-left-color: var(--ag-border-color, #babfc7);
  padding-left: 6px;
  margin-bottom: 12px;
}
.ag-theme-alpine .ag-charts-format-sub-level-group-title-bar {
  padding-top: 0;
  padding-bottom: 0;
  background: none;
  font-weight: 700;
}
.ag-theme-alpine .ag-charts-format-sub-level-group-container {
  padding-bottom: 0;
}
.ag-theme-alpine .ag-charts-format-sub-level-group-item:last-child {
  margin-bottom: 0;
}
.ag-theme-alpine .ag-dnd-ghost {
  font-size: 12px;
  font-weight: 700;
}
.ag-theme-alpine .ag-side-buttons {
  width: 30px;
}
.ag-theme-alpine .ag-standard-button {
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none;
  border-radius: 3px;
  border: 1px solid;
  border-color: #2196f3;
  border-color: var(--ag-alpine-active-color, #2196f3);
  color: #2196f3;
  color: var(--ag-alpine-active-color, #2196f3);
  background-color: #fff;
  background-color: var(--ag-background-color, #fff);
  font-weight: 600;
  padding: 6px 12px;
}
.ag-theme-alpine .ag-standard-button:hover {
  border-color: #2196f3;
  border-color: var(--ag-alpine-active-color, #2196f3);
  background-color: rgba(33, 150, 243, 0.1);
  background-color: var(--ag-row-hover-color, rgba(33, 150, 243, 0.1));
}
.ag-theme-alpine .ag-standard-button:active {
  border-color: #2196f3;
  border-color: var(--ag-alpine-active-color, #2196f3);
  background-color: #2196f3;
  background-color: var(--ag-alpine-active-color, #2196f3);
  color: #fff;
  color: var(--ag-background-color, #fff);
}
.ag-theme-alpine .ag-standard-button:disabled {
  color: rgba(24, 29, 31, 0.5);
  color: var(--ag-disabled-foreground-color, rgba(24, 29, 31, 0.5));
  background-color: #f1f2f4;
  background-color: var(--ag-input-disabled-background-color, #f1f2f4);
  border-color: rgba(186, 191, 199, 0.3);
  border-color: var(--ag-input-disabled-border-color, rgba(186, 191, 199, 0.3));
}
.ag-theme-alpine .ag-column-drop-vertical {
  min-height: 75px;
}
.ag-theme-alpine .ag-column-drop-vertical-title-bar {
  padding: 12px;
  padding-bottom: 0px;
}
.ag-theme-alpine .ag-column-drop-vertical-empty-message {
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
          align-items: center;
  border: dashed 1px;
  border-color: #babfc7;
  border-color: var(--ag-border-color, #babfc7);
  margin: 12px;
  padding: 12px;
}
.ag-theme-alpine .ag-column-drop-empty-message {
  color: #181d1f;
  color: var(--ag-foreground-color, #181d1f);
  opacity: 0.75;
}
.ag-theme-alpine .ag-status-bar {
  font-weight: normal;
}
.ag-theme-alpine .ag-status-name-value-value {
  font-weight: 700;
}
.ag-theme-alpine .ag-paging-number, .ag-theme-alpine .ag-paging-row-summary-panel-number {
  font-weight: 700;
}
.ag-theme-alpine .ag-column-drop-cell-button {
  opacity: 0.5;
}
.ag-theme-alpine .ag-column-drop-cell-button:hover {
  opacity: 0.75;
}
.ag-theme-alpine .ag-header-cell-menu-button:hover,
.ag-theme-alpine .ag-side-button-button:hover,
.ag-theme-alpine .ag-tab:hover,
.ag-theme-alpine .ag-panel-title-bar-button:hover,
.ag-theme-alpine .ag-header-expand-icon:hover,
.ag-theme-alpine .ag-column-group-icons:hover,
.ag-theme-alpine .ag-group-expanded .ag-icon:hover,
.ag-theme-alpine .ag-group-contracted .ag-icon:hover,
.ag-theme-alpine .ag-chart-settings-prev:hover,
.ag-theme-alpine .ag-chart-settings-next:hover,
.ag-theme-alpine .ag-group-title-bar-icon:hover,
.ag-theme-alpine .ag-column-select-header-icon:hover,
.ag-theme-alpine .ag-floating-filter-button-button:hover,
.ag-theme-alpine .ag-filter-toolpanel-expand:hover,
.ag-theme-alpine .ag-chart-menu-icon:hover {
  color: #2196f3;
  color: var(--ag-alpine-active-color, #2196f3);
}
.ag-theme-alpine .ag-chart-settings-card-item.ag-not-selected:hover {
  opacity: 0.35;
}
.ag-theme-alpine .ag-ltr .ag-panel-title-bar-button {
  margin-left: 12px;
  margin-right: 6px;
}

.ag-theme-alpine .ag-rtl .ag-panel-title-bar-button {
  margin-right: 12px;
  margin-left: 6px;
}

.ag-theme-alpine .ag-filter-toolpanel-group-container {
  padding-left: 6px;
}
.ag-theme-alpine .ag-filter-toolpanel-instance-filter {
  border: none;
  background-color: #f8f8f8;
  background-color: var(--ag-control-panel-background-color, #f8f8f8);
  border-left: dashed 1px;
  border-left-color: #babfc7;
  border-left-color: var(--ag-border-color, #babfc7);
  margin-left: 8px;
  padding-left: 8px;
  margin-right: 12px;
}
.ag-theme-alpine .ag-set-filter-list {
  padding-top: 3px;
  padding-bottom: 3px;
}
.ag-theme-alpine .ag-layout-auto-height .ag-center-cols-clipper, .ag-theme-alpine .ag-layout-auto-height .ag-center-cols-container, .ag-theme-alpine .ag-layout-print .ag-center-cols-clipper, .ag-theme-alpine .ag-layout-print .ag-center-cols-container {
  min-height: 150px;
}
.ag-theme-alpine .ag-overlay-no-rows-wrapper.ag-layout-auto-height {
  padding-top: 60px;
}
.ag-theme-alpine .ag-date-time-list-page-entry-is-current {
  background-color: #2196f3;
  background-color: var(--ag-alpine-active-color, #2196f3);
}
`, "",{"version":3,"sources":["webpack://./node_modules/ag-grid-community/dist/styles/ag-theme-alpine.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,cAAc;EACd,0CAA0C;EAC1C,gIAAgI;EAChI,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,2DAA2yO;EAC3yO,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,kDAAkD;AACpD;AACA;EACE,8BAA8B;UACtB,sBAAsB;EAC9B,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;UACX,UAAU;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,kDAAkD;AACpD;AACA;;EAEE,sBAAsB;EACtB,kDAAkD;AACpD;AACA;;;;;;;EAOE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,2EAA2E;AAC7E;AACA;;;;;;;EAOE,4BAA4B;EAC5B,iEAAiE;EACjE,yBAAyB;EACzB,oEAAoE;EACpE,sCAAsC;EACtC,6EAA6E;AAC/E;AACA;;;;;;;EAOE,aAAa;EACb,0DAA0D;UAClD,kDAAkD;EAC1D,qCAAqC;EACrC,yEAAyE;AAC3E;AACA;;;;;;;EAOE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,oFAAoF;AACtF;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,0DAA0D;UAClD,kDAAkD;AAC5D;AACA;EACE,cAAc;EACd,gFAAgF;AAClF;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qCAAqC;EACrC,yEAAyE;AAC3E;AACA;EACE,sBAAsB;EACtB,kDAAkD;EAClD,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,yBAAyB;UACjB,mBAAmB;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,yCAAyC;EACzC,oEAAoE;AACtE;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,kDAAkD;EAClD,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,wBAAwB;UAChB,gBAAgB;AAC1B;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,yBAAyB;UACjB,mBAAmB;AAC7B;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,mEAAmE;AACrE;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,wBAAwB;EACxB,4BAA4B;EAC5B,8DAA8D;AAChE;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,yCAAyC;EACzC,oEAAoE;AACtE;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yCAAyC;EACzC,kFAAkF;AACpF;AACA;;;;EAIE,cAAc;EACd,gFAAgF;AAClF;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8CAA8C;EAC9C,oBAAoB;EACpB,aAAa;EACb,yBAAyB;UACjB,mBAAmB;EAC3B,mBAAmB;UACX,UAAU;AACpB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,eAAe;EACf,mBAAmB;UACX,UAAU;EAClB,cAAc;EACd,gFAAgF;AAClF;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,4DAA4D;EAC5D,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;EAC7C,sBAAsB;EACtB,kDAAkD;AACpD;AACA;EACE,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,2FAA2F;AAC7F;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;EAC7C,kBAAkB;AACpB;AACA;EACE,0DAA0D;UAClD,kDAAkD;AAC5D;AACA;EACE,sBAAsB;EACtB,kDAAkD;EAClD,cAAc;EACd,gFAAgF;AAClF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,wGAAwG;EACxG,0EAA0E;AAC5E;AACA;EACE,0GAA0G;EAC1G,wEAAwE;AAC1E;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,mDAAmD;UAC3C,2CAA2C;AACrD;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,mDAAmD;UAC3C,2CAA2C;AACrD;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;EAC7C,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;EAClB,0DAA0D;UAClD,kDAAkD;EAC1D,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,qBAAqB;EACrB,uDAAuD;EACvD,cAAc;EACd,gFAAgF;EAChF,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;EACT,eAAe;EACf,mCAAmC;UAC3B,2BAA2B;AACrC;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,0CAA0C;AAC5C;AACA;EACE,0DAA0D;UAClD,kDAAkD;AAC5D;AACA;EACE,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;EACE,sBAAsB;EACtB,kDAAkD;AACpD;AACA;EACE,yBAAyB;EACzB,4DAA4D;EAC5D,cAAc;EACd,mHAAmH;EACnH,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB,4BAA4B;EAC5B,oDAAoD;AACtD;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,4DAA4D;EAC5D,cAAc;EACd,0CAA0C;EAC1C,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;EAC7C,kBAAkB;EAClB,8BAA8B;EAC9B,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qCAAqC;EACrC,yEAAyE;AAC3E;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qCAAqC;EACrC,yEAAyE;AAC3E;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,4BAA4B;EAC5B,iEAAiE;EACjE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,qDAAqD;AACvD;AACA;EACE,cAAc;EACd,uDAAuD;AACzD;AACA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,uCAAuC;EACvC,+BAA+B;AACjC;AACA;EACE,yCAAyC;EACzC,kGAAkG;EAClG,yCAAyC;EACzC,iCAAiC;AACnC;AACA;EACE,oDAAoD;EACpD,6GAA6G;AAC/G;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,oCAAoC;EACpC,uHAAuH;AACzH;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,kDAAkD;EAClD,cAAc;EACd,gEAAgE;EAChE,iBAAiB;EACjB,qBAAqB;EACrB,mFAAmF;EACnF,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,iEAAiE;EACjE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,MAAM;AACR;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,6DAA6D;AAC/D;AACA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,mDAAmD;AACrD;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,kDAAkD;AACpD;AACA;EACE,yCAAyC;EACzC,oEAAoE;AACtE;AACA;EACE,yCAAyC;EACzC,uEAAuE;AACzE;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,mDAAmD;EACnD,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;EAC7C,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;EAClB,0DAA0D;UAClD,kDAAkD;EAC1D,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,mEAAmE;AACrE;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;EAC7C,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;EAClB,0DAA0D;UAClD,kDAAkD;EAC1D,YAAY;EACZ,yBAAyB;EACzB,mEAAmE;EACnE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kDAAkD;AACpD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,2CAA2C;EAC3C,qFAAqF;AACvF;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;EAC7C,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;EAClB,0DAA0D;UAClD,kDAAkD;EAC1D,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,yBAAyB;UACjB,mBAAmB;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,4BAA4B;UACpB,oBAAoB;EAC5B,kCAAkC;UAC1B,0BAA0B;EAClC,2CAA2C;UACnC,mCAAmC;EAC3C,yCAAyC;UACjC,iCAAiC;AAC3C;AACA;EACE;IACE,+BAA+B;YACvB,uBAAuB;EACjC;EACA;IACE,iCAAiC;YACzB,yBAAyB;EACnC;AACF;AACA;EACE;IACE,+BAA+B;YACvB,uBAAuB;EACjC;EACA;IACE,iCAAiC;YACzB,yBAAyB;EACnC;AACF;AACA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,oDAAoD;AACtD;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,iDAAiD;AACnD;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,kDAAkD;AACpD;AACA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,mDAAmD;AACrD;AACA;EACE,yCAAyC;EACzC,kFAAkF;AACpF;AACA;;EAEE,yCAAyC;EACzC,qFAAqF;AACvF;AACA;;EAEE,kDAAkD;EAClD,oGAAoG;AACtG;AACA;;EAEE,mDAAmD;EACnD,8GAA8G;AAChH;AACA;;EAEE,yCAAyC;EACzC,mIAAmI;AACrI;AACA;;EAEE,0CAA0C;EAC1C,wFAAwF;AAC1F;AACA;;EAEE,2CAA2C;EAC3C,yFAAyF;AAC3F;AACA;;EAEE,4CAA4C;EAC5C,0FAA0F;AAC5F;AACA;EACE,yBAAyB;EACzB,iEAAiE;AACnE;AACA;EACE,2BAA2B;EAC3B,mEAAmE;AACrE;AACA;EACE,4BAA4B;EAC5B,oEAAoE;AACtE;AACA;EACE,0BAA0B;EAC1B,kEAAkE;AACpE;AACA;;;;;;;;;EASE,iBAAiB;EACjB,qBAAqB;EACrB,6DAA6D;EAC7D,gBAAgB;AAClB;AACA;;EAEE,sBAAsB;EACtB,yBAAyB;EACzB,iEAAiE;AACnE;AACA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,mEAAmE;AACrE;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,kEAAkE;AACpE;;AAEA;;EAEE,yBAAyB;EACzB,4BAA4B;EAC5B,oEAAoE;AACtE;AACA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,kEAAkE;AACpE;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,mEAAmE;AACrE;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iEAAiE;AACnE;AACA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gDAAgD;EAChD,oFAAoF;AACtF;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;EAC7C,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;EAClB,0DAA0D;UAClD,kDAAkD;EAC1D,YAAY;EACZ,UAAU;AACZ;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,iDAAiD;AACnD;AACA;EACE,yCAAyC;EACzC,oEAAoE;AACtE;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,oCAAoC;EACpC,oBAAoB;EACpB,aAAa;EACb,mBAAmB;UACX,UAAU;EAClB,yBAAyB;UACjB,mBAAmB;EAC3B,wBAAwB;UAChB,uBAAuB;EAC/B,eAAe;EACf,mBAAmB;UACX,cAAc;EACtB,sCAAsC;EACtC,8BAA8B;AAChC;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qCAAqC;EACrC,yEAAyE;AAC3E;AACA;EACE,4BAA4B;EAC5B,mGAAmG;AACrG;AACA;EACE,cAAc;EACd,gFAAgF;AAClF;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,iDAAiD;AACnD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,QAAQ;AACV;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,2DAA2D;AAC7D;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qCAAqC;EACrC,yEAAyE;AAC3E;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,mEAAmE;AACrE;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,0CAA0C;EAC1C,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,YAAY;AACd;AACA;EACE,wBAAwB;UAChB,gBAAgB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qCAAqC;EACrC,yEAAyE;AAC3E;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,mDAAmD;AACrD;AACA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,kDAAkD;AACpD;AACA;;EAEE,mCAAmC;EACnC,qCAAqC;EACrC,6BAA6B;AAC/B;AACA;;EAEE,2BAA2B;EAC3B,kGAAkG;AACpG;AACA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,kDAAkD;AACpD;AACA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,mDAAmD;AACrD;AACA;;EAEE,kCAAkC;EAClC,oCAAoC;EACpC,4BAA4B;AAC9B;AACA;;EAEE,0BAA0B;EAC1B,iGAAiG;AACnG;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qCAAqC;EACrC,yEAAyE;AAC3E;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;UACX,YAAY;EACpB,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,2DAA2D;AAC7D;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,iDAAiD;EACjD,wBAAwB;EACxB,4BAA4B;EAC5B,oDAAoD;EACpD,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,yBAAyB;UACjB,mBAAmB;AAC7B;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qCAAqC;EACrC,yEAAyE;AAC3E;AACA;EACE,YAAY;EACZ,yBAAyB;UACjB,mBAAmB;EAC3B,eAAe;EACf,wBAAwB;EACxB,4BAA4B;EAC5B,8DAA8D;AAChE;AACA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,8DAA8D;EAC9D,qBAAqB;EACrB,yBAAyB;EACzB,2DAA2D;AAC7D;AACA;;EAEE,cAAc;EACd,gFAAgF;AAClF;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,iEAAiE;AACnE;AACA;EACE,MAAM;AACR;AACA;EACE,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,4DAA4D;EAC5D,wBAAwB;EACxB,4BAA4B;EAC5B,oDAAoD;AACtD;AACA;EACE,cAAc;EACd,mHAAmH;EACnH,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,kDAAkD;AACpD;AACA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,mDAAmD;AACrD;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,sBAAsB;EACtB,iGAAiG;AACnG;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qCAAqC;EACrC,yEAAyE;AAC3E;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qCAAqC;EACrC,yEAAyE;AAC3E;AACA;EACE,cAAc;EACd,gFAAgF;AAClF;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;EACzB,iDAAiD;AACnD;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,yBAAyB;UACjB,mBAAmB;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,0CAA0C;EAC1C,uFAAuF;AACzF;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,wBAAwB;KACrB,qBAAqB;UAChB,gBAAgB;EACxB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,mEAAmE;EACnE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,iDAAiD;EACjD,cAAc;EACd,gFAAgF;EAChF,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,iEAAiE;AACnE;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qCAAqC;EACrC,yEAAyE;AAC3E;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,iDAAiD;EACjD,4BAA4B;EAC5B,iEAAiE;EACjE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,0CAA0C;AAC5C;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kCAAkC;EAClC,mEAAmE;EACnE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qCAAqC;EACrC,yEAAyE;AAC3E;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,aAAa;EACb,cAAc;EACd,gFAAgF;AAClF;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,mEAAmE;EACnE,cAAc;EACd,gFAAgF;EAChF,YAAY;EACZ,wBAAwB;EACxB,4BAA4B;EAC5B,oDAAoD;AACtD;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gFAAgF;AAClF;AACA;EACE,4BAA4B;EAC5B,iEAAiE;AACnE;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,4BAA4B;EAC5B,8DAA8D;AAChE;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,4BAA4B;EAC5B,iEAAiE;EACjE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;EAC7C,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;EAClB,0DAA0D;UAClD,kDAAkD;EAC1D,YAAY;EACZ,gBAAgB;EAChB,4CAA4C;EAC5C,aAAa;EACb,UAAU;AACZ;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,yCAAyC;EACzC,kFAAkF;AACpF;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qCAAqC;EACrC,yEAAyE;AAC3E;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;AAC9C;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gFAAgF;AAClF;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,uDAAuD;EACvD,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gIAAgI;AAClI;AACA;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,mIAAmI;AACrI;AACA;EACE,gBAAgB;AAClB;AACA;;;EAGE,qBAAqB;EACrB,yBAAyB;EACzB,2DAA2D;AAC7D;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,iEAAiE;AACnE;AACA;EACE,MAAM;AACR;AACA;EACE,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;;EAEE,oBAAoB;EACpB,aAAa;EACb,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,mEAAmE;AACrE;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,kDAAkD;AACpD;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;UACX,YAAY;EACpB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,uFAAuF;EACvF,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;UACX,UAAU;AACpB;AACA;EACE,wBAAwB;EACxB,UAAU;EACV,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,0DAA0D;UAClD,kDAAkD;AAC5D;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,+CAA+C;EAC/C,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,+EAA+E;EAC/E,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,uFAAuF;EACvF,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oBAAoB;AACtB;AACA;EACE,8BAA8B;UACtB,sBAAsB;EAC9B,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,wGAAwG;EACxG,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;UACX,UAAU;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gGAAgG;AAClG;AACA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;EACb,0DAA0D;UAClD,kDAAkD;AAC5D;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,uIAAuI;EACvI,qBAAqB;EACrB,+HAA+H;AACjI;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,cAAc;EACd,8BAA8B;UACtB,sBAAsB;EAC9B,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,mGAAmG;EACnG,kBAAkB;EAClB,8BAA8B;EAC9B,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,6IAA6I;AAC/I;AACA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,+HAA+H;AACjI;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,uFAAuF;EACvF,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;UACX,UAAU;EAClB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,UAAU;EACV,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,0DAA0D;UAClD,kDAAkD;AAC5D;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,+CAA+C;EAC/C,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,+EAA+E;EAC/E,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oBAAoB;AACtB;AACA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,iDAAiD;EACjD,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,iDAAiD;EACjD,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,iDAAiD;EACjD,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kDAAkD;EAClD,iBAAiB;EACjB,kBAAkB;EAClB,sDAAsD;EACtD,mBAAmB;EACnB,qCAAqC;UAC7B,6BAA6B;AACvC;AACA;EACE,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kDAAkD;EAClD,iBAAiB;EACjB,kBAAkB;EAClB,sDAAsD;EACtD,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kDAAkD;EAClD,iBAAiB;EACjB,kBAAkB;EAClB,sDAAsD;EACtD,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,0DAA0D;UAClD,kDAAkD;EAC1D,qBAAqB;EACrB,sFAAsF;AACxF;AACA;EACE,kDAAkD;EAClD,qBAAqB;EACrB,sFAAsF;AACxF;AACA;EACE,kDAAkD;EAClD,qBAAqB;EACrB,sFAAsF;AACxF;AACA;EACE,yCAAyC;EACzC,6EAA6E;AAC/E;AACA;EACE,yCAAyC;EACzC,6EAA6E;AAC/E;AACA;EACE,yCAAyC;EACzC,6EAA6E;AAC/E;AACA;EACE,YAAY;AACd;AACA;;;;;;EAME,gBAAgB;EAChB,cAAc;EACd,mHAAmH;AACrH;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,iDAAiD;AACnD;AACA;EACE,QAAQ;AACV;AACA;EACE,OAAO;AACT;AACA;EACE,eAAe;AACjB;AACA;;;;;;;EAOE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;;;;;EAOE,iBAAiB;AACnB;;AAEA;;;;;;;EAOE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,yBAAyB;EACzB,mEAAmE;AACrE;AACA;EACE,yBAAyB;EACzB,mEAAmE;EACnE,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,oDAAoD;AACtD;AACA;;;EAGE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,kDAAkD;AACpD;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,2DAA2D;AAC7D;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,kDAAkD;EAClD,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;OAChB,gBAAgB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,oDAAoD;EACpD,cAAc;EACd,6CAA6C;EAC7C,sBAAsB;EACtB,kDAAkD;EAClD,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,oDAAoD;EACpD,yCAAyC;EACzC,oEAAoE;AACtE;AACA;EACE,qBAAqB;EACrB,oDAAoD;EACpD,yBAAyB;EACzB,wDAAwD;EACxD,WAAW;EACX,uCAAuC;AACzC;AACA;EACE,4BAA4B;EAC5B,iEAAiE;EACjE,yBAAyB;EACzB,oEAAoE;EACpE,sCAAsC;EACtC,6EAA6E;AAC/E;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,yBAAyB;UACjB,mBAAmB;EAC3B,kBAAkB;EAClB,qBAAqB;EACrB,6CAA6C;EAC7C,YAAY;EACZ,aAAa;AACf;AACA;EACE,cAAc;EACd,0CAA0C;EAC1C,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;;;;;;;;;;;;;;;EAeE,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,mEAAmE;EACnE,uBAAuB;EACvB,0BAA0B;EAC1B,kDAAkD;EAClD,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,wDAAwD;AAC1D","sourcesContent":[".ag-theme-alpine {\n  -webkit-font-smoothing: antialiased;\n  color: #181d1f;\n  color: var(--ag-foreground-color, #181d1f);\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\n  font-size: 13px;\n  line-height: normal;\n}\n@font-face {\n  font-family: \"agGridAlpine\";\n  src: url(\"data:application/font-woff;charset=utf-8;base64,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\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n.ag-theme-alpine .ag-icon {\n  font-family: \"agGridAlpine\";\n  font-size: 16px;\n  line-height: 16px;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.ag-theme-alpine .ag-icon-aggregation::before {\n  content: \"\\f101\";\n}\n.ag-theme-alpine .ag-icon-arrows::before {\n  content: \"\\f102\";\n}\n.ag-theme-alpine .ag-icon-asc::before {\n  content: \"\\f103\";\n}\n.ag-theme-alpine .ag-icon-cancel::before {\n  content: \"\\f104\";\n}\n.ag-theme-alpine .ag-icon-chart::before {\n  content: \"\\f105\";\n}\n.ag-theme-alpine .ag-icon-color-picker::before {\n  content: \"\\f109\";\n}\n.ag-theme-alpine .ag-icon-columns::before {\n  content: \"\\f10a\";\n}\n.ag-theme-alpine .ag-icon-contracted::before {\n  content: \"\\f10b\";\n}\n.ag-theme-alpine .ag-icon-copy::before {\n  content: \"\\f10c\";\n}\n.ag-theme-alpine .ag-icon-cross::before {\n  content: \"\\f10d\";\n}\n.ag-theme-alpine .ag-icon-csv::before {\n  content: \"\\f10e\";\n}\n.ag-theme-alpine .ag-icon-desc::before {\n  content: \"\\f10f\";\n}\n.ag-theme-alpine .ag-icon-excel::before {\n  content: \"\\f110\";\n}\n.ag-theme-alpine .ag-icon-expanded::before {\n  content: \"\\f111\";\n}\n.ag-theme-alpine .ag-icon-eye-slash::before {\n  content: \"\\f112\";\n}\n.ag-theme-alpine .ag-icon-eye::before {\n  content: \"\\f113\";\n}\n.ag-theme-alpine .ag-icon-filter::before {\n  content: \"\\f114\";\n}\n.ag-theme-alpine .ag-icon-first::before {\n  content: \"\\f115\";\n}\n.ag-theme-alpine .ag-icon-grip::before {\n  content: \"\\f116\";\n}\n.ag-theme-alpine .ag-icon-group::before {\n  content: \"\\f117\";\n}\n.ag-theme-alpine .ag-icon-last::before {\n  content: \"\\f118\";\n}\n.ag-theme-alpine .ag-icon-left::before {\n  content: \"\\f119\";\n}\n.ag-theme-alpine .ag-icon-linked::before {\n  content: \"\\f11a\";\n}\n.ag-theme-alpine .ag-icon-loading::before {\n  content: \"\\f11b\";\n}\n.ag-theme-alpine .ag-icon-maximize::before {\n  content: \"\\f11c\";\n}\n.ag-theme-alpine .ag-icon-menu::before {\n  content: \"\\f11d\";\n}\n.ag-theme-alpine .ag-icon-minimize::before {\n  content: \"\\f11e\";\n}\n.ag-theme-alpine .ag-icon-next::before {\n  content: \"\\f11f\";\n}\n.ag-theme-alpine .ag-icon-none::before {\n  content: \"\\f120\";\n}\n.ag-theme-alpine .ag-icon-not-allowed::before {\n  content: \"\\f121\";\n}\n.ag-theme-alpine .ag-icon-paste::before {\n  content: \"\\f122\";\n}\n.ag-theme-alpine .ag-icon-pin::before {\n  content: \"\\f123\";\n}\n.ag-theme-alpine .ag-icon-pivot::before {\n  content: \"\\f124\";\n}\n.ag-theme-alpine .ag-icon-previous::before {\n  content: \"\\f125\";\n}\n.ag-theme-alpine .ag-icon-right::before {\n  content: \"\\f128\";\n}\n.ag-theme-alpine .ag-icon-save::before {\n  content: \"\\f129\";\n}\n.ag-theme-alpine .ag-icon-small-down::before {\n  content: \"\\f12a\";\n}\n.ag-theme-alpine .ag-icon-small-left::before {\n  content: \"\\f12b\";\n}\n.ag-theme-alpine .ag-icon-small-right::before {\n  content: \"\\f12c\";\n}\n.ag-theme-alpine .ag-icon-small-up::before {\n  content: \"\\f12d\";\n}\n.ag-theme-alpine .ag-icon-tick::before {\n  content: \"\\f12e\";\n}\n.ag-theme-alpine .ag-icon-tree-closed::before {\n  content: \"\\f12f\";\n}\n.ag-theme-alpine .ag-icon-tree-indeterminate::before {\n  content: \"\\f130\";\n}\n.ag-theme-alpine .ag-icon-tree-open::before {\n  content: \"\\f131\";\n}\n.ag-theme-alpine .ag-icon-unlinked::before {\n  content: \"\\f132\";\n}\n.ag-theme-alpine .ag-icon-row-drag::before {\n  content: \"\\f116\";\n}\n.ag-theme-alpine .ag-left-arrow::before {\n  content: \"\\f119\";\n}\n.ag-theme-alpine .ag-right-arrow::before {\n  content: \"\\f128\";\n}\n.ag-theme-alpine .ag-root-wrapper {\n  background-color: #fff;\n  background-color: var(--ag-background-color, #fff);\n}\n.ag-theme-alpine [class^=ag-], .ag-theme-alpine [class^=ag-]:focus, .ag-theme-alpine [class^=ag-]:after, .ag-theme-alpine [class^=ag-]:before {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  outline: none;\n}\n.ag-theme-alpine [class^=ag-]::-ms-clear {\n  display: none;\n}\n.ag-theme-alpine .ag-checkbox .ag-input-wrapper,\n.ag-theme-alpine .ag-radio-button .ag-input-wrapper {\n  overflow: visible;\n}\n.ag-theme-alpine .ag-range-field .ag-input-wrapper {\n  height: 100%;\n}\n.ag-theme-alpine .ag-toggle-button {\n  -webkit-box-flex: 0;\n          flex: none;\n  width: unset;\n  min-width: unset;\n}\n.ag-theme-alpine .ag-ltr .ag-label-align-right .ag-label {\n  margin-left: 6px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-label-align-right .ag-label {\n  margin-right: 6px;\n}\n\n.ag-theme-alpine input[class^=ag-] {\n  margin: 0;\n  background-color: #fff;\n  background-color: var(--ag-background-color, #fff);\n}\n.ag-theme-alpine textarea[class^=ag-],\n.ag-theme-alpine select[class^=ag-] {\n  background-color: #fff;\n  background-color: var(--ag-background-color, #fff);\n}\n.ag-theme-alpine input[class^=ag-]:not([type]),\n.ag-theme-alpine input[class^=ag-][type=text],\n.ag-theme-alpine input[class^=ag-][type=number],\n.ag-theme-alpine input[class^=ag-][type=tel],\n.ag-theme-alpine input[class^=ag-][type=date],\n.ag-theme-alpine input[class^=ag-][type=datetime-local],\n.ag-theme-alpine textarea[class^=ag-] {\n  font-size: inherit;\n  line-height: inherit;\n  color: inherit;\n  border-width: 1px;\n  border-style: solid;\n  border-color: #babfc7;\n  border-color: var(--ag-input-border-color, var(--ag-border-color, #babfc7));\n}\n.ag-theme-alpine input[class^=ag-]:not([type]):disabled,\n.ag-theme-alpine input[class^=ag-][type=text]:disabled,\n.ag-theme-alpine input[class^=ag-][type=number]:disabled,\n.ag-theme-alpine input[class^=ag-][type=tel]:disabled,\n.ag-theme-alpine input[class^=ag-][type=date]:disabled,\n.ag-theme-alpine input[class^=ag-][type=datetime-local]:disabled,\n.ag-theme-alpine textarea[class^=ag-]:disabled {\n  color: rgba(24, 29, 31, 0.5);\n  color: var(--ag-disabled-foreground-color, rgba(24, 29, 31, 0.5));\n  background-color: #f1f2f4;\n  background-color: var(--ag-input-disabled-background-color, #f1f2f4);\n  border-color: rgba(186, 191, 199, 0.3);\n  border-color: var(--ag-input-disabled-border-color, rgba(186, 191, 199, 0.3));\n}\n.ag-theme-alpine input[class^=ag-]:not([type]):focus,\n.ag-theme-alpine input[class^=ag-][type=text]:focus,\n.ag-theme-alpine input[class^=ag-][type=number]:focus,\n.ag-theme-alpine input[class^=ag-][type=tel]:focus,\n.ag-theme-alpine input[class^=ag-][type=date]:focus,\n.ag-theme-alpine input[class^=ag-][type=datetime-local]:focus,\n.ag-theme-alpine textarea[class^=ag-]:focus {\n  outline: none;\n  -webkit-box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);\n          box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);\n  border-color: rgba(33, 150, 243, 0.4);\n  border-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));\n}\n.ag-theme-alpine input[class^=ag-]:not([type]):invalid,\n.ag-theme-alpine input[class^=ag-][type=text]:invalid,\n.ag-theme-alpine input[class^=ag-][type=number]:invalid,\n.ag-theme-alpine input[class^=ag-][type=tel]:invalid,\n.ag-theme-alpine input[class^=ag-][type=date]:invalid,\n.ag-theme-alpine input[class^=ag-][type=datetime-local]:invalid,\n.ag-theme-alpine textarea[class^=ag-]:invalid {\n  border-width: 2px;\n  border-style: solid;\n  border-color: #e02525;\n  border-color: var(--ag-input-border-color-invalid, var(--ag-invalid-color, #e02525));\n}\n.ag-theme-alpine input[class^=ag-][type=number] {\n  -moz-appearance: textfield;\n}\n.ag-theme-alpine input[class^=ag-][type=number]::-webkit-outer-spin-button, .ag-theme-alpine input[class^=ag-][type=number]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.ag-theme-alpine input[class^=ag-][type=range] {\n  padding: 0;\n}\n.ag-theme-alpine input[class^=ag-][type=button]:focus, .ag-theme-alpine button[class^=ag-]:focus {\n  -webkit-box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);\n          box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);\n}\n.ag-theme-alpine .ag-drag-handle {\n  color: #181d1f;\n  color: var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f));\n}\n.ag-theme-alpine .ag-list-item, .ag-theme-alpine .ag-virtual-list-item {\n  height: 24px;\n}\n.ag-theme-alpine .ag-keyboard-focus .ag-virtual-list-item:focus {\n  outline: none;\n}\n.ag-theme-alpine .ag-keyboard-focus .ag-virtual-list-item:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: rgba(33, 150, 243, 0.4);\n  border-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));\n}\n.ag-theme-alpine .ag-select-list {\n  background-color: #fff;\n  background-color: var(--ag-background-color, #fff);\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n.ag-theme-alpine .ag-list-item {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-align: center;\n          align-items: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ag-theme-alpine .ag-list-item.ag-active-item {\n  background-color: rgba(33, 150, 243, 0.1);\n  background-color: var(--ag-row-hover-color, rgba(33, 150, 243, 0.1));\n}\n.ag-theme-alpine .ag-select-list-item {\n  padding-left: 4px;\n  padding-right: 4px;\n  cursor: default;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  user-select: none;\n}\n.ag-theme-alpine .ag-select-list-item span {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.ag-theme-alpine .ag-select .ag-picker-field-wrapper {\n  background-color: #fff;\n  background-color: var(--ag-background-color, #fff);\n  min-height: 24px;\n  cursor: default;\n}\n.ag-theme-alpine .ag-select.ag-disabled .ag-picker-field-wrapper:focus {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.ag-theme-alpine .ag-select:not(.ag-cell-editor) {\n  height: 24px;\n}\n.ag-theme-alpine .ag-select .ag-picker-field-display {\n  margin: 4px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ag-theme-alpine .ag-select .ag-picker-field-icon {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-align: center;\n          align-items: center;\n}\n.ag-theme-alpine .ag-select.ag-disabled {\n  opacity: 0.5;\n}\n.ag-theme-alpine .ag-rich-select {\n  background-color: #f8f8f8;\n  background-color: var(--ag-control-panel-background-color, #f8f8f8);\n}\n.ag-theme-alpine .ag-rich-select-list {\n  width: 100%;\n  min-width: 200px;\n  height: 273px;\n}\n.ag-theme-alpine .ag-rich-select-value {\n  padding: 0 6px 0 18px;\n  height: 42px;\n  border-bottom: solid 1px;\n  border-bottom-color: #dde2eb;\n  border-bottom-color: var(--ag-secondary-border-color, #dde2eb);\n}\n.ag-theme-alpine .ag-rich-select-virtual-list-item {\n  cursor: default;\n  height: 24px;\n}\n.ag-theme-alpine .ag-rich-select-virtual-list-item:hover {\n  background-color: rgba(33, 150, 243, 0.1);\n  background-color: var(--ag-row-hover-color, rgba(33, 150, 243, 0.1));\n}\n.ag-theme-alpine .ag-rich-select-row {\n  padding-left: 18px;\n}\n.ag-theme-alpine .ag-rich-select-row-selected {\n  background-color: rgba(33, 150, 243, 0.3);\n  background-color: var(--ag-selected-row-background-color, rgba(33, 150, 243, 0.3));\n}\n.ag-theme-alpine .ag-row-drag,\n.ag-theme-alpine .ag-selection-checkbox,\n.ag-theme-alpine .ag-group-expanded,\n.ag-theme-alpine .ag-group-contracted {\n  color: #181d1f;\n  color: var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f));\n}\n.ag-theme-alpine .ag-ltr .ag-row-drag, .ag-theme-alpine .ag-ltr .ag-selection-checkbox, .ag-theme-alpine .ag-ltr .ag-group-expanded, .ag-theme-alpine .ag-ltr .ag-group-contracted {\n  margin-right: 12px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-drag, .ag-theme-alpine .ag-rtl .ag-selection-checkbox, .ag-theme-alpine .ag-rtl .ag-group-expanded, .ag-theme-alpine .ag-rtl .ag-group-contracted {\n  margin-left: 12px;\n}\n\n.ag-theme-alpine .ag-cell-wrapper > *:not(.ag-cell-value):not(.ag-group-value) {\n  height: min(var(--ag-line-height, 40px), 40px);\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-align: center;\n          align-items: center;\n  -webkit-box-flex: 0;\n          flex: none;\n}\n.ag-theme-alpine .ag-group-expanded,\n.ag-theme-alpine .ag-group-contracted {\n  cursor: pointer;\n}\n.ag-theme-alpine .ag-group-title-bar-icon {\n  cursor: pointer;\n  -webkit-box-flex: 0;\n          flex: none;\n  color: #181d1f;\n  color: var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f));\n}\n.ag-theme-alpine .ag-ltr .ag-group-child-count {\n  margin-left: 2px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-group-child-count {\n  margin-right: 2px;\n}\n\n.ag-theme-alpine .ag-group-title-bar {\n  background-color: #fff;\n  background-color: var(--ag-subheader-background-color, #fff);\n  padding: 6px;\n}\n.ag-theme-alpine .ag-group-toolbar {\n  padding: 6px;\n}\n.ag-theme-alpine .ag-disabled-group-title-bar, .ag-theme-alpine .ag-disabled-group-container {\n  opacity: 0.5;\n}\n.ag-theme-alpine .group-item {\n  margin: 3px 0;\n}\n.ag-theme-alpine .ag-label {\n  white-space: nowrap;\n}\n.ag-theme-alpine .ag-ltr .ag-label {\n  margin-right: 6px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-label {\n  margin-left: 6px;\n}\n\n.ag-theme-alpine .ag-label-align-top .ag-label {\n  margin-bottom: 3px;\n}\n.ag-theme-alpine .ag-ltr .ag-slider-field, .ag-theme-alpine .ag-ltr .ag-angle-select-field {\n  margin-right: 12px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-slider-field, .ag-theme-alpine .ag-rtl .ag-angle-select-field {\n  margin-left: 12px;\n}\n\n.ag-theme-alpine .ag-angle-select-parent-circle {\n  width: 24px;\n  height: 24px;\n  border-radius: 12px;\n  border: solid 1px;\n  border-color: #babfc7;\n  border-color: var(--ag-border-color, #babfc7);\n  background-color: #fff;\n  background-color: var(--ag-background-color, #fff);\n}\n.ag-theme-alpine .ag-angle-select-child-circle {\n  top: 4px;\n  left: 12px;\n  width: 6px;\n  height: 6px;\n  margin-left: -3px;\n  margin-top: -4px;\n  border-radius: 3px;\n  background-color: #181d1f;\n  background-color: var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f));\n}\n.ag-theme-alpine .ag-picker-field-wrapper {\n  border: 1px solid;\n  border-color: #babfc7;\n  border-color: var(--ag-border-color, #babfc7);\n  border-radius: 5px;\n}\n.ag-theme-alpine .ag-picker-field-wrapper:focus {\n  -webkit-box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);\n          box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);\n}\n.ag-theme-alpine .ag-picker-field-button {\n  background-color: #fff;\n  background-color: var(--ag-background-color, #fff);\n  color: #181d1f;\n  color: var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f));\n}\n.ag-theme-alpine .ag-dialog.ag-color-dialog {\n  border-radius: 5px;\n}\n.ag-theme-alpine .ag-color-picker .ag-picker-field-display {\n  height: 16px;\n}\n.ag-theme-alpine .ag-color-panel {\n  padding: 6px;\n}\n.ag-theme-alpine .ag-spectrum-color {\n  background-color: rgb(255, 0, 0);\n  border-radius: 2px;\n}\n.ag-theme-alpine .ag-spectrum-tools {\n  padding: 10px;\n}\n.ag-theme-alpine .ag-spectrum-sat {\n  background-image: -webkit-gradient(linear, left top, right top, from(white), to(rgba(204, 154, 129, 0)));\n  background-image: linear-gradient(to right, white, rgba(204, 154, 129, 0));\n}\n.ag-theme-alpine .ag-spectrum-val {\n  background-image: -webkit-gradient(linear, left bottom, left top, from(black), to(rgba(204, 154, 129, 0)));\n  background-image: linear-gradient(to top, black, rgba(204, 154, 129, 0));\n}\n.ag-theme-alpine .ag-spectrum-dragger {\n  border-radius: 12px;\n  height: 12px;\n  width: 12px;\n  border: 1px solid white;\n  background: black;\n  -webkit-box-shadow: 0 0 2px 0px rgba(0, 0, 0, 0.24);\n          box-shadow: 0 0 2px 0px rgba(0, 0, 0, 0.24);\n}\n.ag-theme-alpine .ag-spectrum-hue-background {\n  border-radius: 2px;\n}\n.ag-theme-alpine .ag-spectrum-alpha-background {\n  border-radius: 2px;\n}\n.ag-theme-alpine .ag-spectrum-tool {\n  margin-bottom: 10px;\n  height: 11px;\n  border-radius: 2px;\n}\n.ag-theme-alpine .ag-spectrum-slider {\n  margin-top: -12px;\n  width: 13px;\n  height: 13px;\n  border-radius: 13px;\n  background-color: rgb(248, 248, 248);\n  -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);\n          box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);\n}\n.ag-theme-alpine .ag-recent-color {\n  margin: 0 3px;\n}\n.ag-theme-alpine .ag-recent-color:first-child {\n  margin-left: 0;\n}\n.ag-theme-alpine .ag-recent-color:last-child {\n  margin-right: 0;\n}\n.ag-theme-alpine.ag-dnd-ghost {\n  border: solid 1px;\n  border-color: #babfc7;\n  border-color: var(--ag-border-color, #babfc7);\n  background: #fff;\n  background: var(--ag-background-color, #fff);\n  border-radius: 3px;\n  -webkit-box-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);\n          box-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);\n  padding: 6px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  border: solid 1px;\n  border-color: #dde2eb;\n  border-color: var(--ag-secondary-border-color, #dde2eb);\n  color: #181d1f;\n  color: var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f));\n  height: 48px !important;\n  line-height: 48px;\n  margin: 0;\n  padding: 0 12px;\n  -webkit-transform: translateY(12px);\n          transform: translateY(12px);\n}\n.ag-theme-alpine .ag-dnd-ghost-icon {\n  margin-right: 6px;\n  color: #181d1f;\n  color: var(--ag-foreground-color, #181d1f);\n}\n.ag-theme-alpine .ag-popup-child:not(.ag-tooltip-custom) {\n  -webkit-box-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);\n          box-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);\n}\n.ag-dragging-range-handle .ag-theme-alpine .ag-dialog, .ag-dragging-fill-handle .ag-theme-alpine .ag-dialog {\n  opacity: 0.7;\n  pointer-events: none;\n}\n.ag-theme-alpine .ag-dialog {\n  border-radius: 3px;\n  border: solid 1px;\n  border-color: #babfc7;\n  border-color: var(--ag-border-color, #babfc7);\n}\n.ag-theme-alpine .ag-panel {\n  background-color: #fff;\n  background-color: var(--ag-background-color, #fff);\n}\n.ag-theme-alpine .ag-panel-title-bar {\n  background-color: #f8f8f8;\n  background-color: var(--ag-header-background-color, #f8f8f8);\n  color: #181d1f;\n  color: var(--ag-header-foreground-color, var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f)));\n  height: 48px;\n  padding: 6px 18px;\n  border-bottom: solid 1px;\n  border-bottom-color: #babfc7;\n  border-bottom-color: var(--ag-border-color, #babfc7);\n}\n.ag-theme-alpine .ag-ltr .ag-panel-title-bar-button {\n  margin-left: 6px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-panel-title-bar-button {\n  margin-right: 6px;\n}\n\n.ag-theme-alpine .ag-tooltip {\n  background-color: #f8f8f8;\n  background-color: var(--ag-header-background-color, #f8f8f8);\n  color: #181d1f;\n  color: var(--ag-foreground-color, #181d1f);\n  padding: 6px;\n  border: solid 1px;\n  border-color: #babfc7;\n  border-color: var(--ag-border-color, #babfc7);\n  border-radius: 3px;\n  -webkit-transition: opacity 1s;\n  transition: opacity 1s;\n  white-space: normal;\n}\n.ag-theme-alpine .ag-tooltip.ag-tooltip-hiding {\n  opacity: 0;\n}\n.ag-theme-alpine .ag-tooltip-custom {\n  -webkit-transition: opacity 1s;\n  transition: opacity 1s;\n}\n.ag-theme-alpine .ag-tooltip-custom.ag-tooltip-hiding {\n  opacity: 0;\n}\n.ag-theme-alpine .ag-ltr .ag-column-select-indent-1 {\n  padding-left: 16px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-column-select-indent-1 {\n  padding-right: 16px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-column-select-indent-2 {\n  padding-left: 32px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-column-select-indent-2 {\n  padding-right: 32px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-column-select-indent-3 {\n  padding-left: 48px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-column-select-indent-3 {\n  padding-right: 48px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-column-select-indent-4 {\n  padding-left: 64px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-column-select-indent-4 {\n  padding-right: 64px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-column-select-indent-5 {\n  padding-left: 80px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-column-select-indent-5 {\n  padding-right: 80px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-column-select-indent-6 {\n  padding-left: 96px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-column-select-indent-6 {\n  padding-right: 96px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-column-select-indent-7 {\n  padding-left: 112px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-column-select-indent-7 {\n  padding-right: 112px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-column-select-indent-8 {\n  padding-left: 128px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-column-select-indent-8 {\n  padding-right: 128px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-column-select-indent-9 {\n  padding-left: 144px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-column-select-indent-9 {\n  padding-right: 144px;\n}\n\n.ag-theme-alpine .ag-column-select-header-icon {\n  cursor: pointer;\n}\n.ag-theme-alpine .ag-keyboard-focus .ag-column-select-header-icon:focus {\n  outline: none;\n}\n.ag-theme-alpine .ag-keyboard-focus .ag-column-select-header-icon:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 0px;\n  left: 0px;\n  display: block;\n  width: calc(100% - 0px);\n  height: calc(100% - 0px);\n  border: 1px solid;\n  border-color: rgba(33, 150, 243, 0.4);\n  border-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));\n}\n.ag-theme-alpine .ag-ltr .ag-column-group-icons:not(:last-child), .ag-theme-alpine .ag-ltr .ag-column-select-header-icon:not(:last-child), .ag-theme-alpine .ag-ltr .ag-column-select-header-checkbox:not(:last-child), .ag-theme-alpine .ag-ltr .ag-column-select-header-filter-wrapper:not(:last-child), .ag-theme-alpine .ag-ltr .ag-column-select-checkbox:not(:last-child), .ag-theme-alpine .ag-ltr .ag-column-select-column-drag-handle:not(:last-child), .ag-theme-alpine .ag-ltr .ag-column-select-column-group-drag-handle:not(:last-child), .ag-theme-alpine .ag-ltr .ag-column-select-column-label:not(:last-child) {\n  margin-right: 12px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-column-group-icons:not(:last-child), .ag-theme-alpine .ag-rtl .ag-column-select-header-icon:not(:last-child), .ag-theme-alpine .ag-rtl .ag-column-select-header-checkbox:not(:last-child), .ag-theme-alpine .ag-rtl .ag-column-select-header-filter-wrapper:not(:last-child), .ag-theme-alpine .ag-rtl .ag-column-select-checkbox:not(:last-child), .ag-theme-alpine .ag-rtl .ag-column-select-column-drag-handle:not(:last-child), .ag-theme-alpine .ag-rtl .ag-column-select-column-group-drag-handle:not(:last-child), .ag-theme-alpine .ag-rtl .ag-column-select-column-label:not(:last-child) {\n  margin-left: 12px;\n}\n\n.ag-theme-alpine .ag-keyboard-focus .ag-column-select-virtual-list-item:focus {\n  outline: none;\n}\n.ag-theme-alpine .ag-keyboard-focus .ag-column-select-virtual-list-item:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 1px;\n  left: 1px;\n  display: block;\n  width: calc(100% - 2px);\n  height: calc(100% - 2px);\n  border: 1px solid;\n  border-color: rgba(33, 150, 243, 0.4);\n  border-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));\n}\n.ag-theme-alpine .ag-column-select-column-group:not(:last-child),\n.ag-theme-alpine .ag-column-select-column:not(:last-child) {\n  margin-bottom: 9px;\n}\n.ag-theme-alpine .ag-column-select-column-readonly,\n.ag-theme-alpine .ag-column-select-column-group-readonly {\n  color: rgba(24, 29, 31, 0.5);\n  color: var(--ag-disabled-foreground-color, rgba(24, 29, 31, 0.5));\n  pointer-events: none;\n}\n.ag-theme-alpine .ag-ltr .ag-column-select-add-group-indent {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-column-select-add-group-indent {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-column-select-virtual-list-viewport {\n  padding: 6px 0px;\n}\n.ag-theme-alpine .ag-column-select-virtual-list-item {\n  padding: 0 12px;\n}\n.ag-theme-alpine .ag-rtl {\n  text-align: right;\n}\n.ag-theme-alpine .ag-root-wrapper {\n  border: solid 1px;\n  border-color: #babfc7;\n  border-color: var(--ag-border-color, #babfc7);\n}\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-1 {\n  padding-left: 46px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-1 {\n  padding-right: 46px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-1 {\n  padding-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-1 {\n  padding-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-1 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-1 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-2 {\n  padding-left: 74px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-2 {\n  padding-right: 74px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-2 {\n  padding-left: 56px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-2 {\n  padding-right: 56px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-2 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-2 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-3 {\n  padding-left: 102px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-3 {\n  padding-right: 102px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-3 {\n  padding-left: 84px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-3 {\n  padding-right: 84px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-3 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-3 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-4 {\n  padding-left: 130px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-4 {\n  padding-right: 130px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-4 {\n  padding-left: 112px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-4 {\n  padding-right: 112px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-4 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-4 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-5 {\n  padding-left: 158px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-5 {\n  padding-right: 158px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-5 {\n  padding-left: 140px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-5 {\n  padding-right: 140px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-5 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-5 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-6 {\n  padding-left: 186px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-6 {\n  padding-right: 186px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-6 {\n  padding-left: 168px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-6 {\n  padding-right: 168px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-6 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-6 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-7 {\n  padding-left: 214px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-7 {\n  padding-right: 214px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-7 {\n  padding-left: 196px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-7 {\n  padding-right: 196px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-7 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-7 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-8 {\n  padding-left: 242px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-8 {\n  padding-right: 242px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-8 {\n  padding-left: 224px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-8 {\n  padding-right: 224px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-8 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-8 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-9 {\n  padding-left: 270px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-9 {\n  padding-right: 270px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-9 {\n  padding-left: 252px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-9 {\n  padding-right: 252px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-9 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-9 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-10 {\n  padding-left: 298px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-10 {\n  padding-right: 298px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-10 {\n  padding-left: 280px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-10 {\n  padding-right: 280px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-10 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-10 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-11 {\n  padding-left: 326px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-11 {\n  padding-right: 326px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-11 {\n  padding-left: 308px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-11 {\n  padding-right: 308px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-11 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-11 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-12 {\n  padding-left: 354px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-12 {\n  padding-right: 354px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-12 {\n  padding-left: 336px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-12 {\n  padding-right: 336px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-12 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-12 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-13 {\n  padding-left: 382px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-13 {\n  padding-right: 382px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-13 {\n  padding-left: 364px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-13 {\n  padding-right: 364px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-13 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-13 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-14 {\n  padding-left: 410px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-14 {\n  padding-right: 410px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-14 {\n  padding-left: 392px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-14 {\n  padding-right: 392px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-14 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-14 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-15 {\n  padding-left: 438px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-15 {\n  padding-right: 438px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-15 {\n  padding-left: 420px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-15 {\n  padding-right: 420px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-15 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-15 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-16 {\n  padding-left: 466px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-16 {\n  padding-right: 466px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-16 {\n  padding-left: 448px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-16 {\n  padding-right: 448px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-16 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-16 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-17 {\n  padding-left: 494px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-17 {\n  padding-right: 494px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-17 {\n  padding-left: 476px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-17 {\n  padding-right: 476px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-17 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-17 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-18 {\n  padding-left: 522px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-18 {\n  padding-right: 522px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-18 {\n  padding-left: 504px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-18 {\n  padding-right: 504px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-18 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-18 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-19 {\n  padding-left: 550px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-19 {\n  padding-right: 550px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-19 {\n  padding-left: 532px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-19 {\n  padding-right: 532px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-19 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-19 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-20 {\n  padding-left: 578px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-20 {\n  padding-right: 578px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-20 {\n  padding-left: 560px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-20 {\n  padding-right: 560px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-20 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-20 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-21 {\n  padding-left: 606px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-21 {\n  padding-right: 606px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-21 {\n  padding-left: 588px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-21 {\n  padding-right: 588px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-21 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-21 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-22 {\n  padding-left: 634px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-22 {\n  padding-right: 634px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-22 {\n  padding-left: 616px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-22 {\n  padding-right: 616px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-22 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-22 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-23 {\n  padding-left: 662px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-23 {\n  padding-right: 662px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-23 {\n  padding-left: 644px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-23 {\n  padding-right: 644px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-23 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-23 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-24 {\n  padding-left: 690px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-24 {\n  padding-right: 690px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-24 {\n  padding-left: 672px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-24 {\n  padding-right: 672px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-24 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-24 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-25 {\n  padding-left: 718px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-25 {\n  padding-right: 718px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-25 {\n  padding-left: 700px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-25 {\n  padding-right: 700px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-25 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-25 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-26 {\n  padding-left: 746px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-26 {\n  padding-right: 746px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-26 {\n  padding-left: 728px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-26 {\n  padding-right: 728px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-26 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-26 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-27 {\n  padding-left: 774px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-27 {\n  padding-right: 774px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-27 {\n  padding-left: 756px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-27 {\n  padding-right: 756px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-27 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-27 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-28 {\n  padding-left: 802px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-28 {\n  padding-right: 802px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-28 {\n  padding-left: 784px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-28 {\n  padding-right: 784px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-28 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-28 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-29 {\n  padding-left: 830px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-29 {\n  padding-right: 830px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-29 {\n  padding-left: 812px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-29 {\n  padding-right: 812px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-29 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-29 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-30 {\n  padding-left: 858px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-30 {\n  padding-right: 858px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-30 {\n  padding-left: 840px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-30 {\n  padding-right: 840px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-30 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-30 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-31 {\n  padding-left: 886px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-31 {\n  padding-right: 886px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-31 {\n  padding-left: 868px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-31 {\n  padding-right: 868px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-31 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-31 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-32 {\n  padding-left: 914px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-32 {\n  padding-right: 914px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-32 {\n  padding-left: 896px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-32 {\n  padding-right: 896px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-32 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-32 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-33 {\n  padding-left: 942px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-33 {\n  padding-right: 942px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-33 {\n  padding-left: 924px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-33 {\n  padding-right: 924px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-33 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-33 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-34 {\n  padding-left: 970px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-34 {\n  padding-right: 970px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-34 {\n  padding-left: 952px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-34 {\n  padding-right: 952px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-34 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-34 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-35 {\n  padding-left: 998px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-35 {\n  padding-right: 998px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-35 {\n  padding-left: 980px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-35 {\n  padding-right: 980px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-35 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-35 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-36 {\n  padding-left: 1026px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-36 {\n  padding-right: 1026px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-36 {\n  padding-left: 1008px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-36 {\n  padding-right: 1008px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-36 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-36 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-37 {\n  padding-left: 1054px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-37 {\n  padding-right: 1054px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-37 {\n  padding-left: 1036px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-37 {\n  padding-right: 1036px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-37 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-37 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-38 {\n  padding-left: 1082px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-38 {\n  padding-right: 1082px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-38 {\n  padding-left: 1064px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-38 {\n  padding-right: 1064px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-38 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-38 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-39 {\n  padding-left: 1110px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-39 {\n  padding-right: 1110px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-39 {\n  padding-left: 1092px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-39 {\n  padding-right: 1092px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-39 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-39 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-40 {\n  padding-left: 1138px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-40 {\n  padding-right: 1138px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-40 {\n  padding-left: 1120px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-40 {\n  padding-right: 1120px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-40 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-40 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-41 {\n  padding-left: 1166px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-41 {\n  padding-right: 1166px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-41 {\n  padding-left: 1148px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-41 {\n  padding-right: 1148px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-41 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-41 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-42 {\n  padding-left: 1194px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-42 {\n  padding-right: 1194px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-42 {\n  padding-left: 1176px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-42 {\n  padding-right: 1176px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-42 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-42 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-43 {\n  padding-left: 1222px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-43 {\n  padding-right: 1222px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-43 {\n  padding-left: 1204px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-43 {\n  padding-right: 1204px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-43 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-43 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-44 {\n  padding-left: 1250px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-44 {\n  padding-right: 1250px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-44 {\n  padding-left: 1232px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-44 {\n  padding-right: 1232px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-44 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-44 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-45 {\n  padding-left: 1278px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-45 {\n  padding-right: 1278px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-45 {\n  padding-left: 1260px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-45 {\n  padding-right: 1260px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-45 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-45 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-46 {\n  padding-left: 1306px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-46 {\n  padding-right: 1306px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-46 {\n  padding-left: 1288px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-46 {\n  padding-right: 1288px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-46 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-46 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-47 {\n  padding-left: 1334px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-47 {\n  padding-right: 1334px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-47 {\n  padding-left: 1316px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-47 {\n  padding-right: 1316px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-47 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-47 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-48 {\n  padding-left: 1362px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-48 {\n  padding-right: 1362px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-48 {\n  padding-left: 1344px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-48 {\n  padding-right: 1344px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-48 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-48 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-49 {\n  padding-left: 1390px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-49 {\n  padding-right: 1390px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-49 {\n  padding-left: 1372px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-49 {\n  padding-right: 1372px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-49 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-49 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-50 {\n  padding-left: 1418px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-50 {\n  padding-right: 1418px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-50 {\n  padding-left: 1400px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-50 {\n  padding-right: 1400px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-50 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-50 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-51 {\n  padding-left: 1446px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-51 {\n  padding-right: 1446px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-51 {\n  padding-left: 1428px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-51 {\n  padding-right: 1428px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-51 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-51 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-52 {\n  padding-left: 1474px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-52 {\n  padding-right: 1474px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-52 {\n  padding-left: 1456px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-52 {\n  padding-right: 1456px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-52 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-52 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-53 {\n  padding-left: 1502px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-53 {\n  padding-right: 1502px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-53 {\n  padding-left: 1484px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-53 {\n  padding-right: 1484px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-53 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-53 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-54 {\n  padding-left: 1530px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-54 {\n  padding-right: 1530px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-54 {\n  padding-left: 1512px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-54 {\n  padding-right: 1512px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-54 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-54 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-55 {\n  padding-left: 1558px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-55 {\n  padding-right: 1558px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-55 {\n  padding-left: 1540px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-55 {\n  padding-right: 1540px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-55 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-55 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-56 {\n  padding-left: 1586px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-56 {\n  padding-right: 1586px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-56 {\n  padding-left: 1568px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-56 {\n  padding-right: 1568px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-56 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-56 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-57 {\n  padding-left: 1614px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-57 {\n  padding-right: 1614px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-57 {\n  padding-left: 1596px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-57 {\n  padding-right: 1596px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-57 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-57 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-58 {\n  padding-left: 1642px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-58 {\n  padding-right: 1642px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-58 {\n  padding-left: 1624px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-58 {\n  padding-right: 1624px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-58 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-58 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-59 {\n  padding-left: 1670px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-59 {\n  padding-right: 1670px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-59 {\n  padding-left: 1652px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-59 {\n  padding-right: 1652px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-59 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-59 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-60 {\n  padding-left: 1698px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-60 {\n  padding-right: 1698px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-60 {\n  padding-left: 1680px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-60 {\n  padding-right: 1680px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-60 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-60 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-61 {\n  padding-left: 1726px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-61 {\n  padding-right: 1726px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-61 {\n  padding-left: 1708px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-61 {\n  padding-right: 1708px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-61 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-61 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-62 {\n  padding-left: 1754px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-62 {\n  padding-right: 1754px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-62 {\n  padding-left: 1736px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-62 {\n  padding-right: 1736px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-62 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-62 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-63 {\n  padding-left: 1782px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-63 {\n  padding-right: 1782px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-63 {\n  padding-left: 1764px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-63 {\n  padding-right: 1764px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-63 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-63 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-64 {\n  padding-left: 1810px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-64 {\n  padding-right: 1810px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-64 {\n  padding-left: 1792px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-64 {\n  padding-right: 1792px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-64 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-64 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-65 {\n  padding-left: 1838px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-65 {\n  padding-right: 1838px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-65 {\n  padding-left: 1820px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-65 {\n  padding-right: 1820px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-65 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-65 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-66 {\n  padding-left: 1866px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-66 {\n  padding-right: 1866px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-66 {\n  padding-left: 1848px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-66 {\n  padding-right: 1848px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-66 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-66 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-67 {\n  padding-left: 1894px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-67 {\n  padding-right: 1894px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-67 {\n  padding-left: 1876px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-67 {\n  padding-right: 1876px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-67 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-67 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-68 {\n  padding-left: 1922px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-68 {\n  padding-right: 1922px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-68 {\n  padding-left: 1904px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-68 {\n  padding-right: 1904px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-68 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-68 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-69 {\n  padding-left: 1950px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-69 {\n  padding-right: 1950px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-69 {\n  padding-left: 1932px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-69 {\n  padding-right: 1932px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-69 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-69 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-70 {\n  padding-left: 1978px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-70 {\n  padding-right: 1978px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-70 {\n  padding-left: 1960px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-70 {\n  padding-right: 1960px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-70 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-70 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-71 {\n  padding-left: 2006px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-71 {\n  padding-right: 2006px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-71 {\n  padding-left: 1988px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-71 {\n  padding-right: 1988px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-71 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-71 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-72 {\n  padding-left: 2034px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-72 {\n  padding-right: 2034px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-72 {\n  padding-left: 2016px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-72 {\n  padding-right: 2016px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-72 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-72 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-73 {\n  padding-left: 2062px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-73 {\n  padding-right: 2062px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-73 {\n  padding-left: 2044px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-73 {\n  padding-right: 2044px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-73 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-73 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-74 {\n  padding-left: 2090px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-74 {\n  padding-right: 2090px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-74 {\n  padding-left: 2072px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-74 {\n  padding-right: 2072px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-74 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-74 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-75 {\n  padding-left: 2118px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-75 {\n  padding-right: 2118px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-75 {\n  padding-left: 2100px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-75 {\n  padding-right: 2100px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-75 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-75 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-76 {\n  padding-left: 2146px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-76 {\n  padding-right: 2146px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-76 {\n  padding-left: 2128px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-76 {\n  padding-right: 2128px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-76 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-76 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-77 {\n  padding-left: 2174px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-77 {\n  padding-right: 2174px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-77 {\n  padding-left: 2156px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-77 {\n  padding-right: 2156px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-77 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-77 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-78 {\n  padding-left: 2202px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-78 {\n  padding-right: 2202px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-78 {\n  padding-left: 2184px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-78 {\n  padding-right: 2184px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-78 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-78 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-79 {\n  padding-left: 2230px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-79 {\n  padding-right: 2230px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-79 {\n  padding-left: 2212px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-79 {\n  padding-right: 2212px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-79 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-79 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-80 {\n  padding-left: 2258px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-80 {\n  padding-right: 2258px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-80 {\n  padding-left: 2240px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-80 {\n  padding-right: 2240px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-80 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-80 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-81 {\n  padding-left: 2286px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-81 {\n  padding-right: 2286px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-81 {\n  padding-left: 2268px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-81 {\n  padding-right: 2268px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-81 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-81 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-82 {\n  padding-left: 2314px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-82 {\n  padding-right: 2314px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-82 {\n  padding-left: 2296px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-82 {\n  padding-right: 2296px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-82 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-82 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-83 {\n  padding-left: 2342px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-83 {\n  padding-right: 2342px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-83 {\n  padding-left: 2324px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-83 {\n  padding-right: 2324px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-83 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-83 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-84 {\n  padding-left: 2370px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-84 {\n  padding-right: 2370px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-84 {\n  padding-left: 2352px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-84 {\n  padding-right: 2352px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-84 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-84 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-85 {\n  padding-left: 2398px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-85 {\n  padding-right: 2398px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-85 {\n  padding-left: 2380px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-85 {\n  padding-right: 2380px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-85 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-85 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-86 {\n  padding-left: 2426px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-86 {\n  padding-right: 2426px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-86 {\n  padding-left: 2408px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-86 {\n  padding-right: 2408px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-86 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-86 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-87 {\n  padding-left: 2454px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-87 {\n  padding-right: 2454px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-87 {\n  padding-left: 2436px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-87 {\n  padding-right: 2436px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-87 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-87 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-88 {\n  padding-left: 2482px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-88 {\n  padding-right: 2482px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-88 {\n  padding-left: 2464px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-88 {\n  padding-right: 2464px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-88 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-88 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-89 {\n  padding-left: 2510px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-89 {\n  padding-right: 2510px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-89 {\n  padding-left: 2492px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-89 {\n  padding-right: 2492px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-89 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-89 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-90 {\n  padding-left: 2538px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-90 {\n  padding-right: 2538px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-90 {\n  padding-left: 2520px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-90 {\n  padding-right: 2520px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-90 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-90 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-91 {\n  padding-left: 2566px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-91 {\n  padding-right: 2566px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-91 {\n  padding-left: 2548px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-91 {\n  padding-right: 2548px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-91 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-91 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-92 {\n  padding-left: 2594px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-92 {\n  padding-right: 2594px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-92 {\n  padding-left: 2576px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-92 {\n  padding-right: 2576px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-92 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-92 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-93 {\n  padding-left: 2622px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-93 {\n  padding-right: 2622px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-93 {\n  padding-left: 2604px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-93 {\n  padding-right: 2604px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-93 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-93 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-94 {\n  padding-left: 2650px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-94 {\n  padding-right: 2650px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-94 {\n  padding-left: 2632px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-94 {\n  padding-right: 2632px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-94 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-94 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-95 {\n  padding-left: 2678px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-95 {\n  padding-right: 2678px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-95 {\n  padding-left: 2660px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-95 {\n  padding-right: 2660px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-95 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-95 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-96 {\n  padding-left: 2706px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-96 {\n  padding-right: 2706px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-96 {\n  padding-left: 2688px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-96 {\n  padding-right: 2688px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-96 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-96 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-97 {\n  padding-left: 2734px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-97 {\n  padding-right: 2734px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-97 {\n  padding-left: 2716px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-97 {\n  padding-right: 2716px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-97 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-97 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-98 {\n  padding-left: 2762px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-98 {\n  padding-right: 2762px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-98 {\n  padding-left: 2744px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-98 {\n  padding-right: 2744px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-98 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-98 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-99 {\n  padding-left: 2790px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-99 {\n  padding-right: 2790px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-indent-99 {\n  padding-left: 2772px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-indent-99 {\n  padding-right: 2772px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-level-99 .ag-pivot-leaf-group {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-level-99 .ag-pivot-leaf-group {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row-group-leaf-indent {\n  margin-left: 28px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-row-group-leaf-indent {\n  margin-right: 28px;\n}\n\n.ag-theme-alpine .ag-value-change-delta {\n  padding-right: 2px;\n}\n.ag-theme-alpine .ag-value-change-delta-up {\n  color: #43a047;\n  color: var(--ag-value-change-delta-up-color, #43a047);\n}\n.ag-theme-alpine .ag-value-change-delta-down {\n  color: #e53935;\n  color: var(--ag-value-change-delta-down-color, #e53935);\n}\n.ag-theme-alpine .ag-value-change-value {\n  background-color: transparent;\n  border-radius: 1px;\n  padding-left: 1px;\n  padding-right: 1px;\n  -webkit-transition: background-color 1s;\n  transition: background-color 1s;\n}\n.ag-theme-alpine .ag-value-change-value-highlight {\n  background-color: rgba(22, 160, 133, 0.5);\n  background-color: var(--ag-value-change-value-highlight-background-color, rgba(22, 160, 133, 0.5));\n  -webkit-transition: background-color 0.1s;\n  transition: background-color 0.1s;\n}\n.ag-theme-alpine .ag-cell-data-changed {\n  background-color: rgba(22, 160, 133, 0.5) !important;\n  background-color: var(--ag-value-change-value-highlight-background-color, rgba(22, 160, 133, 0.5)) !important;\n}\n.ag-theme-alpine .ag-cell-data-changed-animation {\n  background-color: transparent;\n}\n.ag-theme-alpine .ag-cell-highlight {\n  background-color: #2196f3 !important;\n  background-color: var(--ag-range-selection-highlight-color, var(--ag-range-selection-border-color, #2196f3)) !important;\n}\n.ag-theme-alpine .ag-row {\n  height: 42px;\n  background-color: #fff;\n  background-color: var(--ag-background-color, #fff);\n  color: #181d1f;\n  color: var(--ag-data-color, var(--ag-foreground-color, #181d1f));\n  border-width: 1px;\n  border-color: #dde2eb;\n  border-color: var(--ag-row-border-color, var(--ag-secondary-border-color, #dde2eb));\n  border-bottom-style: solid;\n}\n.ag-theme-alpine .ag-row-highlight-above::after, .ag-theme-alpine .ag-row-highlight-below::after {\n  content: \"\";\n  position: absolute;\n  width: calc(100% - 1px);\n  height: 1px;\n  background-color: #2196f3;\n  background-color: var(--ag-range-selection-border-color, #2196f3);\n  left: 1px;\n}\n.ag-theme-alpine .ag-row-highlight-above::after {\n  top: -1px;\n}\n.ag-theme-alpine .ag-row-highlight-above.ag-row-first::after {\n  top: 0;\n}\n.ag-theme-alpine .ag-row-highlight-below::after {\n  bottom: 0px;\n}\n.ag-theme-alpine .ag-row-odd {\n  background-color: #fcfcfc;\n  background-color: var(--ag-odd-row-background-color, #fcfcfc);\n}\n.ag-theme-alpine .ag-body-horizontal-scroll:not(.ag-scrollbar-invisible) .ag-horizontal-left-spacer:not(.ag-scroller-corner) {\n  border-right: solid 1px;\n  border-right-color: #babfc7;\n  border-right-color: var(--ag-border-color, #babfc7);\n}\n.ag-theme-alpine .ag-body-horizontal-scroll:not(.ag-scrollbar-invisible) .ag-horizontal-right-spacer:not(.ag-scroller-corner) {\n  border-left: solid 1px;\n  border-left-color: #babfc7;\n  border-left-color: var(--ag-border-color, #babfc7);\n}\n.ag-theme-alpine .ag-row-hover {\n  background-color: rgba(33, 150, 243, 0.1);\n  background-color: var(--ag-row-hover-color, rgba(33, 150, 243, 0.1));\n}\n.ag-theme-alpine .ag-column-hover {\n  background-color: rgba(33, 150, 243, 0.1);\n  background-color: var(--ag-column-hover-color, rgba(33, 150, 243, 0.1));\n}\n.ag-theme-alpine .ag-ltr .ag-right-aligned-cell {\n  text-align: right;\n}\n\n.ag-theme-alpine .ag-rtl .ag-right-aligned-cell {\n  text-align: left;\n}\n\n.ag-theme-alpine .ag-ltr .ag-right-aligned-cell .ag-cell-value, .ag-theme-alpine .ag-ltr .ag-right-aligned-cell .ag-group-value {\n  margin-left: auto;\n}\n\n.ag-theme-alpine .ag-rtl .ag-right-aligned-cell .ag-cell-value, .ag-theme-alpine .ag-rtl .ag-right-aligned-cell .ag-group-value {\n  margin-right: auto;\n}\n\n.ag-theme-alpine .ag-cell, .ag-theme-alpine .ag-full-width-row .ag-cell-wrapper.ag-row-group {\n  border: 1px solid transparent;\n  line-height: min(var(--ag-line-height, 40px), 40px);\n  padding-left: 17px;\n  padding-right: 17px;\n  -webkit-font-smoothing: subpixel-antialiased;\n}\n.ag-theme-alpine .ag-row > .ag-cell-wrapper {\n  padding-left: 17px;\n  padding-right: 17px;\n}\n.ag-theme-alpine .ag-row-dragging {\n  cursor: move;\n  opacity: 0.5;\n}\n.ag-theme-alpine .ag-cell-inline-editing {\n  border: solid 1px;\n  border-color: #babfc7;\n  border-color: var(--ag-border-color, #babfc7);\n  background: #fff;\n  background: var(--ag-background-color, #fff);\n  border-radius: 3px;\n  -webkit-box-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);\n          box-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);\n  padding: 6px;\n  padding: 0;\n  height: 42px;\n  background-color: #f8f8f8;\n  background-color: var(--ag-control-panel-background-color, #f8f8f8);\n}\n.ag-theme-alpine .ag-popup-editor {\n  border: solid 1px;\n  border-color: #babfc7;\n  border-color: var(--ag-border-color, #babfc7);\n  background: #fff;\n  background: var(--ag-background-color, #fff);\n  border-radius: 3px;\n  -webkit-box-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);\n          box-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);\n  padding: 6px;\n  background-color: #f8f8f8;\n  background-color: var(--ag-control-panel-background-color, #f8f8f8);\n  padding: 0;\n}\n.ag-theme-alpine .ag-large-text-input {\n  height: auto;\n  padding: 18px;\n}\n.ag-theme-alpine .ag-details-row {\n  padding: 30px;\n  background-color: #fff;\n  background-color: var(--ag-background-color, #fff);\n}\n.ag-theme-alpine .ag-layout-auto-height .ag-center-cols-clipper, .ag-theme-alpine .ag-layout-auto-height .ag-center-cols-container, .ag-theme-alpine .ag-layout-print .ag-center-cols-clipper, .ag-theme-alpine .ag-layout-print .ag-center-cols-container {\n  min-height: 50px;\n}\n.ag-theme-alpine .ag-overlay-loading-wrapper {\n  background-color: rgba(255, 255, 255, 0.66);\n  background-color: var(--ag-modal-overlay-background-color, rgba(255, 255, 255, 0.66));\n}\n.ag-theme-alpine .ag-overlay-loading-center {\n  border: solid 1px;\n  border-color: #babfc7;\n  border-color: var(--ag-border-color, #babfc7);\n  background: #fff;\n  background: var(--ag-background-color, #fff);\n  border-radius: 3px;\n  -webkit-box-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);\n          box-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);\n  padding: 6px;\n}\n.ag-theme-alpine .ag-overlay-no-rows-wrapper.ag-layout-auto-height {\n  padding-top: 30px;\n}\n.ag-theme-alpine .ag-loading {\n  padding-left: 18px;\n  display: -webkit-box;\n  display: flex;\n  height: 100%;\n  -webkit-box-align: center;\n          align-items: center;\n}\n.ag-theme-alpine .ag-loading-icon {\n  padding-right: 12px;\n}\n.ag-theme-alpine .ag-icon-loading {\n  -webkit-animation-name: spin;\n          animation-name: spin;\n  -webkit-animation-duration: 1000ms;\n          animation-duration: 1000ms;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n}\n@-webkit-keyframes spin {\n  from {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  from {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.ag-theme-alpine .ag-floating-top {\n  border-bottom: solid 1px;\n  border-bottom-color: #babfc7;\n  border-bottom-color: var(--ag-border-color, #babfc7);\n}\n.ag-theme-alpine .ag-floating-bottom {\n  border-top: solid 1px;\n  border-top-color: #babfc7;\n  border-top-color: var(--ag-border-color, #babfc7);\n}\n.ag-theme-alpine .ag-ltr .ag-cell {\n  border-right: solid transparent;\n}\n\n.ag-theme-alpine .ag-rtl .ag-cell {\n  border-left: solid transparent;\n}\n\n.ag-theme-alpine .ag-ltr .ag-cell {\n  border-right-width: 1px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-cell {\n  border-left-width: 1px;\n}\n\n.ag-theme-alpine .ag-cell.ag-cell-first-right-pinned:not(.ag-cell-range-left):not(.ag-cell-range-single-cell) {\n  border-left: solid 1px;\n  border-left-color: #babfc7;\n  border-left-color: var(--ag-border-color, #babfc7);\n}\n.ag-theme-alpine .ag-cell.ag-cell-last-left-pinned:not(.ag-cell-range-right):not(.ag-cell-range-single-cell) {\n  border-right: solid 1px;\n  border-right-color: #babfc7;\n  border-right-color: var(--ag-border-color, #babfc7);\n}\n.ag-theme-alpine .ag-row-selected {\n  background-color: rgba(33, 150, 243, 0.3);\n  background-color: var(--ag-selected-row-background-color, rgba(33, 150, 243, 0.3));\n}\n.ag-theme-alpine .ag-cell-range-selected:not(.ag-cell-focus),\n.ag-theme-alpine .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing) {\n  background-color: rgba(33, 150, 243, 0.2);\n  background-color: var(--ag-range-selection-background-color, rgba(33, 150, 243, 0.2));\n}\n.ag-theme-alpine .ag-cell-range-selected:not(.ag-cell-focus).ag-cell-range-chart,\n.ag-theme-alpine .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing).ag-cell-range-chart {\n  background-color: rgba(0, 88, 255, 0.1) !important;\n  background-color: var(--ag-range-selection-chart-background-color, rgba(0, 88, 255, 0.1)) !important;\n}\n.ag-theme-alpine .ag-cell-range-selected:not(.ag-cell-focus).ag-cell-range-chart.ag-cell-range-chart-category,\n.ag-theme-alpine .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing).ag-cell-range-chart.ag-cell-range-chart-category {\n  background-color: rgba(0, 255, 132, 0.1) !important;\n  background-color: var(--ag-range-selection-chart-category-background-color, rgba(0, 255, 132, 0.1)) !important;\n}\n.ag-theme-alpine .ag-cell-range-selected-1:not(.ag-cell-focus),\n.ag-theme-alpine .ag-root:not(.ag-context-menu-open) .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-1:not(.ag-cell-inline-editing) {\n  background-color: rgba(33, 150, 243, 0.2);\n  background-color: var(--ag-range-selection-background-color-1, var(--ag-range-selection-background-color, rgba(33, 150, 243, 0.2)));\n}\n.ag-theme-alpine .ag-cell-range-selected-2:not(.ag-cell-focus),\n.ag-theme-alpine .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-2 {\n  background-color: rgba(33, 150, 243, 0.36);\n  background-color: var(--ag-range-selection-background-color-2, rgba(33, 150, 243, 0.36));\n}\n.ag-theme-alpine .ag-cell-range-selected-3:not(.ag-cell-focus),\n.ag-theme-alpine .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-3 {\n  background-color: rgba(33, 150, 243, 0.488);\n  background-color: var(--ag-range-selection-background-color-3, rgba(33, 150, 243, 0.488));\n}\n.ag-theme-alpine .ag-cell-range-selected-4:not(.ag-cell-focus),\n.ag-theme-alpine .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-4 {\n  background-color: rgba(33, 150, 243, 0.5904);\n  background-color: var(--ag-range-selection-background-color-4, rgba(33, 150, 243, 0.5904));\n}\n.ag-theme-alpine .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-top {\n  border-top-color: #2196f3;\n  border-top-color: var(--ag-range-selection-border-color, #2196f3);\n}\n.ag-theme-alpine .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-right {\n  border-right-color: #2196f3;\n  border-right-color: var(--ag-range-selection-border-color, #2196f3);\n}\n.ag-theme-alpine .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-bottom {\n  border-bottom-color: #2196f3;\n  border-bottom-color: var(--ag-range-selection-border-color, #2196f3);\n}\n.ag-theme-alpine .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-left {\n  border-left-color: #2196f3;\n  border-left-color: var(--ag-range-selection-border-color, #2196f3);\n}\n.ag-theme-alpine .ag-ltr .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected),\n.ag-theme-alpine .ag-ltr .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),\n.ag-theme-alpine .ag-ltr .ag-has-focus .ag-full-width-row.ag-row-focus .ag-cell-wrapper.ag-row-group,\n.ag-theme-alpine .ag-ltr .ag-cell-range-single-cell,\n.ag-theme-alpine .ag-ltr .ag-cell-range-single-cell.ag-cell-range-handle, .ag-theme-alpine .ag-rtl .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected),\n.ag-theme-alpine .ag-rtl .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),\n.ag-theme-alpine .ag-rtl .ag-has-focus .ag-full-width-row.ag-row-focus .ag-cell-wrapper.ag-row-group,\n.ag-theme-alpine .ag-rtl .ag-cell-range-single-cell,\n.ag-theme-alpine .ag-rtl .ag-cell-range-single-cell.ag-cell-range-handle {\n  border: 1px solid;\n  border-color: #2196f3;\n  border-color: var(--ag-range-selection-border-color, #2196f3);\n  outline: initial;\n}\n.ag-theme-alpine .ag-cell.ag-selection-fill-top,\n.ag-theme-alpine .ag-cell.ag-selection-fill-top.ag-cell-range-selected {\n  border-top: 1px dashed;\n  border-top-color: #2196f3;\n  border-top-color: var(--ag-range-selection-border-color, #2196f3);\n}\n.ag-theme-alpine .ag-ltr .ag-cell.ag-selection-fill-right, .ag-theme-alpine .ag-ltr .ag-cell.ag-selection-fill-right.ag-cell-range-selected {\n  border-right: 1px dashed;\n  border-right-color: #2196f3;\n  border-right-color: var(--ag-range-selection-border-color, #2196f3);\n}\n\n.ag-theme-alpine .ag-rtl .ag-cell.ag-selection-fill-right, .ag-theme-alpine .ag-rtl .ag-cell.ag-selection-fill-right.ag-cell-range-selected {\n  border-left: 1px dashed;\n  border-left-color: #2196f3;\n  border-left-color: var(--ag-range-selection-border-color, #2196f3);\n}\n\n.ag-theme-alpine .ag-cell.ag-selection-fill-bottom,\n.ag-theme-alpine .ag-cell.ag-selection-fill-bottom.ag-cell-range-selected {\n  border-bottom: 1px dashed;\n  border-bottom-color: #2196f3;\n  border-bottom-color: var(--ag-range-selection-border-color, #2196f3);\n}\n.ag-theme-alpine .ag-ltr .ag-cell.ag-selection-fill-left, .ag-theme-alpine .ag-ltr .ag-cell.ag-selection-fill-left.ag-cell-range-selected {\n  border-left: 1px dashed;\n  border-left-color: #2196f3;\n  border-left-color: var(--ag-range-selection-border-color, #2196f3);\n}\n\n.ag-theme-alpine .ag-rtl .ag-cell.ag-selection-fill-left, .ag-theme-alpine .ag-rtl .ag-cell.ag-selection-fill-left.ag-cell-range-selected {\n  border-right: 1px dashed;\n  border-right-color: #2196f3;\n  border-right-color: var(--ag-range-selection-border-color, #2196f3);\n}\n\n.ag-theme-alpine .ag-range-handle, .ag-theme-alpine .ag-fill-handle {\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  bottom: -1px;\n  background-color: #2196f3;\n  background-color: var(--ag-range-selection-border-color, #2196f3);\n}\n.ag-theme-alpine .ag-ltr .ag-range-handle, .ag-theme-alpine .ag-ltr .ag-fill-handle {\n  right: -1px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-range-handle, .ag-theme-alpine .ag-rtl .ag-fill-handle {\n  left: -1px;\n}\n\n.ag-theme-alpine .ag-fill-handle {\n  cursor: cell;\n}\n.ag-theme-alpine .ag-range-handle {\n  cursor: nwse-resize;\n}\n.ag-theme-alpine .ag-cell-inline-editing {\n  border-color: rgba(33, 150, 243, 0.4) !important;\n  border-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4)) !important;\n}\n.ag-theme-alpine .ag-menu {\n  border: solid 1px;\n  border-color: #babfc7;\n  border-color: var(--ag-border-color, #babfc7);\n  background: #fff;\n  background: var(--ag-background-color, #fff);\n  border-radius: 3px;\n  -webkit-box-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);\n          box-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);\n  padding: 6px;\n  padding: 0;\n}\n.ag-theme-alpine .ag-menu-list {\n  cursor: default;\n  padding: 6px 0;\n}\n.ag-theme-alpine .ag-menu-separator {\n  height: 13px;\n}\n.ag-theme-alpine .ag-menu-separator-part::after {\n  content: \"\";\n  display: block;\n  border-top: solid 1px;\n  border-top-color: #babfc7;\n  border-top-color: var(--ag-border-color, #babfc7);\n}\n.ag-theme-alpine .ag-menu-option-active, .ag-theme-alpine .ag-compact-menu-option-active {\n  background-color: rgba(33, 150, 243, 0.1);\n  background-color: var(--ag-row-hover-color, rgba(33, 150, 243, 0.1));\n}\n.ag-theme-alpine .ag-menu-option-part, .ag-theme-alpine .ag-compact-menu-option-part {\n  line-height: 16px;\n  padding: 8px 0;\n}\n.ag-theme-alpine .ag-menu-option-disabled, .ag-theme-alpine .ag-compact-menu-option-disabled {\n  opacity: 0.5;\n}\n.ag-theme-alpine .ag-menu-option-icon, .ag-theme-alpine .ag-compact-menu-option-icon {\n  width: 16px;\n}\n.ag-theme-alpine .ag-ltr .ag-menu-option-icon, .ag-theme-alpine .ag-ltr .ag-compact-menu-option-icon {\n  padding-left: 12px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-menu-option-icon, .ag-theme-alpine .ag-rtl .ag-compact-menu-option-icon {\n  padding-right: 12px;\n}\n\n.ag-theme-alpine .ag-menu-option-text, .ag-theme-alpine .ag-compact-menu-option-text {\n  padding-left: 12px;\n  padding-right: 12px;\n}\n.ag-theme-alpine .ag-ltr .ag-menu-option-shortcut, .ag-theme-alpine .ag-ltr .ag-compact-menu-option-shortcut {\n  padding-right: 6px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-menu-option-shortcut, .ag-theme-alpine .ag-rtl .ag-compact-menu-option-shortcut {\n  padding-left: 6px;\n}\n\n.ag-theme-alpine .ag-menu-option-popup-pointer, .ag-theme-alpine .ag-compact-menu-option-popup-pointer {\n  padding-right: 6px;\n}\n.ag-theme-alpine .ag-tabs {\n  min-width: 240px;\n}\n.ag-theme-alpine .ag-tabs-header {\n  width: 100%;\n  display: -webkit-box;\n  display: flex;\n}\n.ag-theme-alpine .ag-tab {\n  border-bottom: 2px solid transparent;\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-flex: 0;\n          flex: none;\n  -webkit-box-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n          justify-content: center;\n  cursor: pointer;\n  -webkit-box-flex: 1;\n          flex: 1 1 auto;\n  -webkit-transition: border-bottom 0.3s;\n  transition: border-bottom 0.3s;\n}\n.ag-theme-alpine .ag-keyboard-focus .ag-tab:focus {\n  outline: none;\n}\n.ag-theme-alpine .ag-keyboard-focus .ag-tab:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: rgba(33, 150, 243, 0.4);\n  border-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));\n}\n.ag-theme-alpine .ag-tab-selected {\n  border-bottom-color: #2196f3;\n  border-bottom-color: var(--ag-selected-tab-underline-color, var(--ag-alpine-active-color, #2196f3));\n}\n.ag-theme-alpine .ag-menu-header {\n  color: #181d1f;\n  color: var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f));\n}\n.ag-theme-alpine .ag-filter-separator {\n  border-top: solid 1px;\n  border-top-color: #babfc7;\n  border-top-color: var(--ag-border-color, #babfc7);\n}\n.ag-theme-alpine .ag-menu:not(.ag-tabs) .ag-filter-select {\n  min-width: 155px;\n}\n.ag-theme-alpine .ag-tabs .ag-filter-select {\n  min-width: 214px;\n}\n.ag-theme-alpine .ag-filter-select .ag-picker-field-wrapper {\n  width: 0;\n}\n.ag-theme-alpine .ag-filter-condition-operator {\n  height: 17px;\n}\n.ag-theme-alpine .ag-ltr .ag-filter-condition-operator-or {\n  margin-left: 12px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-filter-condition-operator-or {\n  margin-right: 12px;\n}\n\n.ag-theme-alpine .ag-set-filter-select-all {\n  padding-top: 12px;\n}\n.ag-theme-alpine .ag-set-filter-list, .ag-theme-alpine .ag-filter-no-matches {\n  height: 144px;\n}\n.ag-theme-alpine .ag-set-filter-filter {\n  margin-top: 12px;\n  margin-left: 12px;\n  margin-right: 12px;\n}\n.ag-theme-alpine .ag-filter-to {\n  margin-top: 9px;\n}\n.ag-theme-alpine .ag-mini-filter {\n  margin: 12px 12px;\n}\n.ag-theme-alpine .ag-set-filter-item {\n  margin: 0px 12px;\n}\n.ag-theme-alpine .ag-ltr .ag-set-filter-item-value {\n  margin-left: 12px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-set-filter-item-value {\n  margin-right: 12px;\n}\n\n.ag-theme-alpine .ag-filter-apply-panel {\n  padding: 12px 12px;\n  border-top: solid 1px;\n  border-top-color: #dde2eb;\n  border-top-color: var(--ag-secondary-border-color, #dde2eb);\n}\n.ag-theme-alpine .ag-filter-apply-panel-button {\n  line-height: 1.5;\n}\n.ag-theme-alpine .ag-ltr .ag-filter-apply-panel-button {\n  margin-left: 12px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-filter-apply-panel-button {\n  margin-right: 12px;\n}\n\n.ag-theme-alpine .ag-simple-filter-body-wrapper {\n  padding: 12px 12px;\n  padding-bottom: 3px;\n}\n.ag-theme-alpine .ag-simple-filter-body-wrapper > * {\n  margin-bottom: 9px;\n}\n.ag-theme-alpine .ag-filter-no-matches {\n  padding: 12px 12px;\n}\n.ag-theme-alpine .ag-multi-filter-menu-item {\n  margin: 6px 0;\n}\n.ag-theme-alpine .ag-multi-filter-group-title-bar {\n  padding: 12px 6px;\n  background-color: transparent;\n}\n.ag-theme-alpine .ag-keyboard-focus .ag-multi-filter-group-title-bar:focus {\n  outline: none;\n}\n.ag-theme-alpine .ag-keyboard-focus .ag-multi-filter-group-title-bar:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: rgba(33, 150, 243, 0.4);\n  border-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));\n}\n.ag-theme-alpine .ag-side-bar {\n  position: relative;\n}\n.ag-theme-alpine .ag-tool-panel-wrapper {\n  width: 250px;\n  background-color: #f8f8f8;\n  background-color: var(--ag-control-panel-background-color, #f8f8f8);\n}\n.ag-theme-alpine .ag-side-buttons {\n  padding-top: 24px;\n  width: 20px;\n  position: relative;\n  color: #181d1f;\n  color: var(--ag-foreground-color, #181d1f);\n  overflow: hidden;\n}\n.ag-theme-alpine button.ag-side-button-button {\n  color: inherit;\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n  background: transparent;\n  padding: 12px 0 12px 0;\n  width: 100%;\n  margin: 0;\n  min-height: 108px;\n  background-position-y: center;\n  background-position-x: center;\n  background-repeat: no-repeat;\n  border: none;\n}\n.ag-theme-alpine button.ag-side-button-button:focus {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.ag-theme-alpine .ag-keyboard-focus .ag-side-button-button:focus {\n  outline: none;\n}\n.ag-theme-alpine .ag-keyboard-focus .ag-side-button-button:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: rgba(33, 150, 243, 0.4);\n  border-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));\n}\n.ag-theme-alpine .ag-side-button-icon-wrapper {\n  margin-bottom: 3px;\n}\n.ag-theme-alpine .ag-ltr .ag-side-bar-left,\n.ag-theme-alpine .ag-rtl .ag-side-bar-right {\n  border-right: solid 1px;\n  border-right-color: #babfc7;\n  border-right-color: var(--ag-border-color, #babfc7);\n}\n.ag-theme-alpine .ag-ltr .ag-side-bar-left .ag-tool-panel-wrapper,\n.ag-theme-alpine .ag-rtl .ag-side-bar-right .ag-tool-panel-wrapper {\n  border-left: solid 1px;\n  border-left-color: #babfc7;\n  border-left-color: var(--ag-border-color, #babfc7);\n}\n.ag-theme-alpine .ag-ltr .ag-side-bar-left .ag-side-button-button,\n.ag-theme-alpine .ag-rtl .ag-side-bar-right .ag-side-button-button {\n  border-right: 2px solid transparent;\n  -webkit-transition: border-right 0.3s;\n  transition: border-right 0.3s;\n}\n.ag-theme-alpine .ag-ltr .ag-side-bar-left .ag-selected .ag-side-button-button,\n.ag-theme-alpine .ag-rtl .ag-side-bar-right .ag-selected .ag-side-button-button {\n  border-right-color: #2196f3;\n  border-right-color: var(--ag-selected-tab-underline-color, var(--ag-alpine-active-color, #2196f3));\n}\n.ag-theme-alpine .ag-rtl .ag-side-bar-left,\n.ag-theme-alpine .ag-ltr .ag-side-bar-right {\n  border-left: solid 1px;\n  border-left-color: #babfc7;\n  border-left-color: var(--ag-border-color, #babfc7);\n}\n.ag-theme-alpine .ag-rtl .ag-side-bar-left .ag-tool-panel-wrapper,\n.ag-theme-alpine .ag-ltr .ag-side-bar-right .ag-tool-panel-wrapper {\n  border-right: solid 1px;\n  border-right-color: #babfc7;\n  border-right-color: var(--ag-border-color, #babfc7);\n}\n.ag-theme-alpine .ag-rtl .ag-side-bar-left .ag-side-button-button,\n.ag-theme-alpine .ag-ltr .ag-side-bar-right .ag-side-button-button {\n  border-left: 2px solid transparent;\n  -webkit-transition: border-left 0.3s;\n  transition: border-left 0.3s;\n}\n.ag-theme-alpine .ag-rtl .ag-side-bar-left .ag-selected .ag-side-button-button,\n.ag-theme-alpine .ag-ltr .ag-side-bar-right .ag-selected .ag-side-button-button {\n  border-left-color: #2196f3;\n  border-left-color: var(--ag-selected-tab-underline-color, var(--ag-alpine-active-color, #2196f3));\n}\n.ag-theme-alpine .ag-filter-toolpanel-header {\n  height: 36px;\n}\n.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-header, .ag-theme-alpine .ag-ltr .ag-filter-toolpanel-search {\n  padding-left: 6px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-header, .ag-theme-alpine .ag-rtl .ag-filter-toolpanel-search {\n  padding-right: 6px;\n}\n\n.ag-theme-alpine .ag-keyboard-focus .ag-filter-toolpanel-header:focus {\n  outline: none;\n}\n.ag-theme-alpine .ag-keyboard-focus .ag-filter-toolpanel-header:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: rgba(33, 150, 243, 0.4);\n  border-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));\n}\n.ag-theme-alpine .ag-filter-toolpanel-group.ag-has-filter > .ag-group-title-bar .ag-group-title::after {\n  font-family: \"agGridAlpine\";\n  font-size: 16px;\n  line-height: 16px;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  content: \"\\f114\";\n  position: absolute;\n}\n.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-group.ag-has-filter > .ag-group-title-bar .ag-group-title::after {\n  padding-left: 6px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-group.ag-has-filter > .ag-group-title-bar .ag-group-title::after {\n  padding-right: 6px;\n}\n\n.ag-theme-alpine .ag-filter-toolpanel-group-level-0-header {\n  height: 48px;\n}\n.ag-theme-alpine .ag-filter-toolpanel-group-item {\n  margin-top: 3px;\n  margin-bottom: 3px;\n}\n.ag-theme-alpine .ag-filter-toolpanel-search {\n  height: 48px;\n}\n.ag-theme-alpine .ag-filter-toolpanel-search-input {\n  -webkit-box-flex: 1;\n          flex-grow: 1;\n  height: 24px;\n}\n.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-search-input {\n  margin-right: 6px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-search-input {\n  margin-left: 6px;\n}\n\n.ag-theme-alpine .ag-filter-toolpanel-group-level-0 {\n  border-top: solid 1px;\n  border-top-color: #dde2eb;\n  border-top-color: var(--ag-secondary-border-color, #dde2eb);\n}\n.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-expand, .ag-theme-alpine .ag-ltr .ag-filter-toolpanel-group-title-bar-icon {\n  margin-right: 6px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-expand, .ag-theme-alpine .ag-rtl .ag-filter-toolpanel-group-title-bar-icon {\n  margin-left: 6px;\n}\n\n.ag-theme-alpine .ag-filter-toolpanel-group-level-1 .ag-filter-toolpanel-group-level-1-header.ag-filter-toolpanel-group-title-bar {\n  background-color: transparent;\n}\n.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-group-level-1 .ag-filter-toolpanel-group-level-2-header {\n  padding-left: 22px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-group-level-1 .ag-filter-toolpanel-group-level-2-header {\n  padding-right: 22px;\n}\n\n.ag-theme-alpine .ag-filter-toolpanel-group-level-2 .ag-filter-toolpanel-group-level-2-header.ag-filter-toolpanel-group-title-bar {\n  background-color: transparent;\n}\n.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-group-level-2 .ag-filter-toolpanel-group-level-3-header {\n  padding-left: 38px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-group-level-2 .ag-filter-toolpanel-group-level-3-header {\n  padding-right: 38px;\n}\n\n.ag-theme-alpine .ag-filter-toolpanel-group-level-3 .ag-filter-toolpanel-group-level-3-header.ag-filter-toolpanel-group-title-bar {\n  background-color: transparent;\n}\n.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-group-level-3 .ag-filter-toolpanel-group-level-4-header {\n  padding-left: 54px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-group-level-3 .ag-filter-toolpanel-group-level-4-header {\n  padding-right: 54px;\n}\n\n.ag-theme-alpine .ag-filter-toolpanel-group-level-4 .ag-filter-toolpanel-group-level-4-header.ag-filter-toolpanel-group-title-bar {\n  background-color: transparent;\n}\n.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-group-level-4 .ag-filter-toolpanel-group-level-5-header {\n  padding-left: 70px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-group-level-4 .ag-filter-toolpanel-group-level-5-header {\n  padding-right: 70px;\n}\n\n.ag-theme-alpine .ag-filter-toolpanel-group-level-5 .ag-filter-toolpanel-group-level-5-header.ag-filter-toolpanel-group-title-bar {\n  background-color: transparent;\n}\n.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-group-level-5 .ag-filter-toolpanel-group-level-6-header {\n  padding-left: 86px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-group-level-5 .ag-filter-toolpanel-group-level-6-header {\n  padding-right: 86px;\n}\n\n.ag-theme-alpine .ag-filter-toolpanel-group-level-6 .ag-filter-toolpanel-group-level-6-header.ag-filter-toolpanel-group-title-bar {\n  background-color: transparent;\n}\n.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-group-level-6 .ag-filter-toolpanel-group-level-7-header {\n  padding-left: 102px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-group-level-6 .ag-filter-toolpanel-group-level-7-header {\n  padding-right: 102px;\n}\n\n.ag-theme-alpine .ag-filter-toolpanel-group-level-7 .ag-filter-toolpanel-group-level-7-header.ag-filter-toolpanel-group-title-bar {\n  background-color: transparent;\n}\n.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-group-level-7 .ag-filter-toolpanel-group-level-8-header {\n  padding-left: 118px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-group-level-7 .ag-filter-toolpanel-group-level-8-header {\n  padding-right: 118px;\n}\n\n.ag-theme-alpine .ag-filter-toolpanel-group-level-8 .ag-filter-toolpanel-group-level-8-header.ag-filter-toolpanel-group-title-bar {\n  background-color: transparent;\n}\n.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-group-level-8 .ag-filter-toolpanel-group-level-9-header {\n  padding-left: 134px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-group-level-8 .ag-filter-toolpanel-group-level-9-header {\n  padding-right: 134px;\n}\n\n.ag-theme-alpine .ag-filter-toolpanel-group-level-9 .ag-filter-toolpanel-group-level-9-header.ag-filter-toolpanel-group-title-bar {\n  background-color: transparent;\n}\n.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-group-level-9 .ag-filter-toolpanel-group-level-10-header {\n  padding-left: 150px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-group-level-9 .ag-filter-toolpanel-group-level-10-header {\n  padding-right: 150px;\n}\n\n.ag-theme-alpine .ag-filter-toolpanel-group-level-10 .ag-filter-toolpanel-group-level-10-header.ag-filter-toolpanel-group-title-bar {\n  background-color: transparent;\n}\n.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-group-level-10 .ag-filter-toolpanel-group-level-11-header {\n  padding-left: 166px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-group-level-10 .ag-filter-toolpanel-group-level-11-header {\n  padding-right: 166px;\n}\n\n.ag-theme-alpine .ag-filter-toolpanel-instance-header.ag-filter-toolpanel-group-level-1-header {\n  padding-left: 6px;\n}\n.ag-theme-alpine .ag-filter-toolpanel-instance-filter {\n  border-top: solid 1px;\n  border-top-color: #babfc7;\n  border-top-color: var(--ag-border-color, #babfc7);\n  border-bottom: solid 1px;\n  border-bottom-color: #babfc7;\n  border-bottom-color: var(--ag-border-color, #babfc7);\n  margin-top: 6px;\n}\n.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-instance-header-icon {\n  margin-left: 6px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-instance-header-icon {\n  margin-right: 6px;\n}\n\n.ag-theme-alpine .ag-pivot-mode-panel {\n  min-height: 48px;\n  height: 48px;\n  display: -webkit-box;\n  display: flex;\n}\n.ag-theme-alpine .ag-pivot-mode-select {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-align: center;\n          align-items: center;\n}\n.ag-theme-alpine .ag-ltr .ag-pivot-mode-select {\n  margin-left: 12px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-pivot-mode-select {\n  margin-right: 12px;\n}\n\n.ag-theme-alpine .ag-keyboard-focus .ag-column-select-header:focus {\n  outline: none;\n}\n.ag-theme-alpine .ag-keyboard-focus .ag-column-select-header:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: rgba(33, 150, 243, 0.4);\n  border-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));\n}\n.ag-theme-alpine .ag-column-select-header {\n  height: 48px;\n  -webkit-box-align: center;\n          align-items: center;\n  padding: 0 12px;\n  border-bottom: solid 1px;\n  border-bottom-color: #dde2eb;\n  border-bottom-color: var(--ag-secondary-border-color, #dde2eb);\n}\n.ag-theme-alpine .ag-column-panel-column-select {\n  border-bottom: solid 1px;\n  border-bottom-color: #dde2eb;\n  border-bottom-color: var(--ag-secondary-border-color, #dde2eb);\n  border-top: solid 1px;\n  border-top-color: #dde2eb;\n  border-top-color: var(--ag-secondary-border-color, #dde2eb);\n}\n.ag-theme-alpine .ag-column-group-icons,\n.ag-theme-alpine .ag-column-select-header-icon {\n  color: #181d1f;\n  color: var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f));\n}\n.ag-theme-alpine .ag-column-select-list .ag-list-item-hovered::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background-color: #2196f3;\n  background-color: var(--ag-range-selection-border-color, #2196f3);\n}\n.ag-theme-alpine .ag-column-select-list .ag-item-highlight-top::after {\n  top: 0;\n}\n.ag-theme-alpine .ag-column-select-list .ag-item-highlight-bottom::after {\n  bottom: 0;\n}\n.ag-theme-alpine .ag-header {\n  background-color: #f8f8f8;\n  background-color: var(--ag-header-background-color, #f8f8f8);\n  border-bottom: solid 1px;\n  border-bottom-color: #babfc7;\n  border-bottom-color: var(--ag-border-color, #babfc7);\n}\n.ag-theme-alpine .ag-header-row {\n  color: #181d1f;\n  color: var(--ag-header-foreground-color, var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f)));\n  height: 48px;\n}\n.ag-theme-alpine .ag-pinned-right-header {\n  border-left: solid 1px;\n  border-left-color: #babfc7;\n  border-left-color: var(--ag-border-color, #babfc7);\n}\n.ag-theme-alpine .ag-pinned-left-header {\n  border-right: solid 1px;\n  border-right-color: #babfc7;\n  border-right-color: var(--ag-border-color, #babfc7);\n}\n.ag-theme-alpine .ag-ltr .ag-header-cell:not(.ag-right-aligned-header) .ag-header-label-icon {\n  margin-left: 6px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-header-cell:not(.ag-right-aligned-header) .ag-header-label-icon {\n  margin-right: 6px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-header-cell.ag-right-aligned-header .ag-header-label-icon {\n  margin-right: 6px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-header-cell.ag-right-aligned-header .ag-header-label-icon {\n  margin-left: 6px;\n}\n\n.ag-theme-alpine .ag-header-cell,\n.ag-theme-alpine .ag-header-group-cell {\n  padding-left: 18px;\n  padding-right: 18px;\n}\n.ag-theme-alpine .ag-header-cell.ag-header-cell-moving,\n.ag-theme-alpine .ag-header-group-cell.ag-header-cell-moving {\n  background-color: #fff;\n  background-color: var(--ag-header-cell-moving-background-color, var(--ag-background-color, #fff));\n}\n.ag-theme-alpine .ag-keyboard-focus .ag-header-cell:focus {\n  outline: none;\n}\n.ag-theme-alpine .ag-keyboard-focus .ag-header-cell:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: rgba(33, 150, 243, 0.4);\n  border-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));\n}\n.ag-theme-alpine .ag-keyboard-focus .ag-header-group-cell:focus {\n  outline: none;\n}\n.ag-theme-alpine .ag-keyboard-focus .ag-header-group-cell:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: rgba(33, 150, 243, 0.4);\n  border-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));\n}\n.ag-theme-alpine .ag-header-icon {\n  color: #181d1f;\n  color: var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f));\n}\n.ag-theme-alpine .ag-header-expand-icon {\n  cursor: pointer;\n}\n.ag-theme-alpine .ag-ltr .ag-header-expand-icon {\n  padding-left: 4px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-header-expand-icon {\n  padding-right: 4px;\n}\n\n.ag-theme-alpine .ag-header-row:not(:first-child) .ag-header-cell,\n.ag-theme-alpine .ag-header-row:not(:first-child) .ag-header-group-cell.ag-header-group-cell-with-group {\n  border-top: solid 1px;\n  border-top-color: #babfc7;\n  border-top-color: var(--ag-border-color, #babfc7);\n}\n.ag-theme-alpine .ag-header-cell-resize {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-align: center;\n          align-items: center;\n}\n.ag-theme-alpine .ag-header-cell-resize::after {\n  content: \"\";\n  position: absolute;\n  z-index: 1;\n  display: block;\n  left: calc(50% - 1px);\n  width: 2px;\n  height: 30%;\n  top: calc(50% - 15%);\n  background-color: rgba(186, 191, 199, 0.5);\n  background-color: var(--ag-header-column-resize-handle-color, rgba(186, 191, 199, 0.5));\n}\n.ag-theme-alpine .ag-pinned-right-header .ag-header-cell-resize::after {\n  left: calc(50% - 2px);\n}\n.ag-theme-alpine .ag-ltr .ag-header-select-all {\n  margin-right: 18px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-header-select-all {\n  margin-left: 18px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-floating-filter-button {\n  margin-left: 18px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-floating-filter-button {\n  margin-right: 18px;\n}\n\n.ag-theme-alpine .ag-floating-filter-button-button {\n  color: inherit;\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  background: transparent;\n  border: none;\n  height: 16px;\n  padding: 0;\n  width: 16px;\n}\n.ag-theme-alpine .ag-filter-loading {\n  background-color: #f8f8f8;\n  background-color: var(--ag-control-panel-background-color, #f8f8f8);\n  height: 100%;\n  padding: 12px 12px;\n  position: absolute;\n  width: 100%;\n  z-index: 1;\n}\n.ag-theme-alpine .ag-paging-panel {\n  border-top: 1px solid;\n  border-top-color: #babfc7;\n  border-top-color: var(--ag-border-color, #babfc7);\n  color: #181d1f;\n  color: var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f));\n  height: 48px;\n}\n.ag-theme-alpine .ag-paging-panel > * {\n  margin: 0 18px;\n}\n.ag-theme-alpine .ag-paging-button {\n  cursor: pointer;\n}\n.ag-theme-alpine .ag-paging-button.ag-disabled {\n  cursor: default;\n  color: rgba(24, 29, 31, 0.5);\n  color: var(--ag-disabled-foreground-color, rgba(24, 29, 31, 0.5));\n}\n.ag-theme-alpine .ag-keyboard-focus .ag-paging-button:focus {\n  outline: none;\n}\n.ag-theme-alpine .ag-keyboard-focus .ag-paging-button:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 0px;\n  left: 0px;\n  display: block;\n  width: calc(100% - 0px);\n  height: calc(100% - 0px);\n  border: 1px solid;\n  border-color: rgba(33, 150, 243, 0.4);\n  border-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));\n}\n.ag-theme-alpine .ag-paging-button, .ag-theme-alpine .ag-paging-description {\n  margin: 0 6px;\n}\n.ag-theme-alpine .ag-status-bar {\n  border-top: solid 1px;\n  border-top-color: #babfc7;\n  border-top-color: var(--ag-border-color, #babfc7);\n  color: rgba(24, 29, 31, 0.5);\n  color: var(--ag-disabled-foreground-color, rgba(24, 29, 31, 0.5));\n  padding-right: 24px;\n  padding-left: 24px;\n  line-height: 1.5;\n}\n.ag-theme-alpine .ag-status-name-value-value {\n  color: #181d1f;\n  color: var(--ag-foreground-color, #181d1f);\n}\n.ag-theme-alpine .ag-status-bar-center {\n  text-align: center;\n}\n.ag-theme-alpine .ag-status-name-value {\n  margin-left: 6px;\n  margin-right: 6px;\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n.ag-theme-alpine .ag-column-drop-cell {\n  background: rgba(24, 29, 31, 0.07);\n  background: var(--ag-chip-background-color, rgba(24, 29, 31, 0.07));\n  border-radius: 24px;\n  height: 24px;\n  padding: 0 3px;\n  border: 1px solid transparent;\n}\n.ag-theme-alpine .ag-keyboard-focus .ag-column-drop-cell:focus {\n  outline: none;\n}\n.ag-theme-alpine .ag-keyboard-focus .ag-column-drop-cell:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 2px;\n  left: 2px;\n  display: block;\n  width: calc(100% - 4px);\n  height: calc(100% - 4px);\n  border: 1px solid;\n  border-color: rgba(33, 150, 243, 0.4);\n  border-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));\n}\n.ag-theme-alpine .ag-column-drop-cell-text {\n  margin: 0 6px;\n}\n.ag-theme-alpine .ag-column-drop-cell-button {\n  min-width: 24px;\n  margin: 0 3px;\n  color: #181d1f;\n  color: var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f));\n}\n.ag-theme-alpine .ag-column-drop-cell-drag-handle {\n  margin-left: 12px;\n}\n.ag-theme-alpine .ag-column-drop-cell-ghost {\n  opacity: 0.5;\n}\n.ag-theme-alpine .ag-column-drop-horizontal {\n  background-color: #f8f8f8;\n  background-color: var(--ag-control-panel-background-color, #f8f8f8);\n  color: #181d1f;\n  color: var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f));\n  height: 42px;\n  border-bottom: solid 1px;\n  border-bottom-color: #babfc7;\n  border-bottom-color: var(--ag-border-color, #babfc7);\n}\n.ag-theme-alpine .ag-ltr .ag-column-drop-horizontal {\n  padding-left: 18px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-column-drop-horizontal {\n  padding-right: 18px;\n}\n\n.ag-theme-alpine .ag-ltr .ag-column-drop-horizontal-half-width:not(:last-child) {\n  border-right: solid 1px;\n  border-right-color: #babfc7;\n  border-right-color: var(--ag-border-color, #babfc7);\n}\n\n.ag-theme-alpine .ag-rtl .ag-column-drop-horizontal-half-width:not(:last-child) {\n  border-left: solid 1px;\n  border-left-color: #babfc7;\n  border-left-color: var(--ag-border-color, #babfc7);\n}\n\n.ag-theme-alpine .ag-column-drop-horizontal-cell-separator {\n  margin: 0 6px;\n  color: #181d1f;\n  color: var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f));\n}\n.ag-theme-alpine .ag-column-drop-horizontal-empty-message {\n  color: rgba(24, 29, 31, 0.5);\n  color: var(--ag-disabled-foreground-color, rgba(24, 29, 31, 0.5));\n}\n.ag-theme-alpine .ag-ltr .ag-column-drop-horizontal-icon {\n  margin-right: 18px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-column-drop-horizontal-icon {\n  margin-left: 18px;\n}\n\n.ag-theme-alpine .ag-column-drop-vertical-list {\n  padding-bottom: 6px;\n  padding-right: 6px;\n  padding-left: 6px;\n}\n.ag-theme-alpine .ag-column-drop-vertical-cell {\n  margin-top: 6px;\n}\n.ag-theme-alpine .ag-column-drop-vertical {\n  min-height: 50px;\n  border-bottom: solid 1px;\n  border-bottom-color: #dde2eb;\n  border-bottom-color: var(--ag-secondary-border-color, #dde2eb);\n}\n.ag-theme-alpine .ag-column-drop-vertical.ag-last-column-drop {\n  border-bottom: none;\n}\n.ag-theme-alpine .ag-column-drop-vertical-icon {\n  margin-left: 6px;\n  margin-right: 6px;\n}\n.ag-theme-alpine .ag-column-drop-vertical-empty-message {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  overflow: hidden;\n  color: rgba(24, 29, 31, 0.5);\n  color: var(--ag-disabled-foreground-color, rgba(24, 29, 31, 0.5));\n  margin-top: 6px;\n}\n.ag-theme-alpine .ag-select-agg-func-popup {\n  border: solid 1px;\n  border-color: #babfc7;\n  border-color: var(--ag-border-color, #babfc7);\n  background: #fff;\n  background: var(--ag-background-color, #fff);\n  border-radius: 3px;\n  -webkit-box-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);\n          box-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);\n  padding: 6px;\n  background: #fff;\n  background: var(--ag-background-color, #fff);\n  height: 105px;\n  padding: 0;\n}\n.ag-theme-alpine .ag-select-agg-func-virtual-list-item {\n  cursor: default;\n  padding-left: 12px;\n}\n.ag-theme-alpine .ag-select-agg-func-virtual-list-item:hover {\n  background-color: rgba(33, 150, 243, 0.3);\n  background-color: var(--ag-selected-row-background-color, rgba(33, 150, 243, 0.3));\n}\n.ag-theme-alpine .ag-keyboard-focus .ag-select-agg-func-virtual-list-item:focus {\n  outline: none;\n}\n.ag-theme-alpine .ag-keyboard-focus .ag-select-agg-func-virtual-list-item:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 1px;\n  left: 1px;\n  display: block;\n  width: calc(100% - 2px);\n  height: calc(100% - 2px);\n  border: 1px solid;\n  border-color: rgba(33, 150, 243, 0.4);\n  border-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));\n}\n.ag-theme-alpine .ag-chart-menu {\n  border-radius: 3px;\n  background: #fff;\n  background: var(--ag-background-color, #fff);\n}\n.ag-theme-alpine .ag-chart-menu-icon {\n  opacity: 0.5;\n  line-height: 24px;\n  font-size: 24px;\n  width: 24px;\n  height: 24px;\n  margin: 2px 0;\n  cursor: pointer;\n  border-radius: 3px;\n  color: #181d1f;\n  color: var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f));\n}\n.ag-theme-alpine .ag-chart-menu-icon:hover {\n  opacity: 1;\n}\n.ag-theme-alpine .ag-chart-mini-thumbnail {\n  border: 1px solid;\n  border-color: #dde2eb;\n  border-color: var(--ag-secondary-border-color, #dde2eb);\n  border-radius: 5px;\n  margin: 5px;\n}\n.ag-theme-alpine .ag-chart-mini-thumbnail:nth-last-child(3), .ag-theme-alpine .ag-chart-mini-thumbnail:nth-last-child(3) ~ .ag-chart-mini-thumbnail {\n  margin-left: auto;\n  margin-right: auto;\n}\n.ag-theme-alpine .ag-ltr .ag-chart-mini-thumbnail:first-child {\n  margin-left: 0;\n}\n\n.ag-theme-alpine .ag-rtl .ag-chart-mini-thumbnail:first-child {\n  margin-right: 0;\n}\n\n.ag-theme-alpine .ag-ltr .ag-chart-mini-thumbnail:last-child {\n  margin-right: 0;\n}\n\n.ag-theme-alpine .ag-rtl .ag-chart-mini-thumbnail:last-child {\n  margin-left: 0;\n}\n\n.ag-theme-alpine .ag-chart-mini-thumbnail.ag-selected {\n  border-color: #2196f3;\n  border-color: var(--ag-minichart-selected-chart-color, var(--ag-checkbox-checked-color, var(--ag-alpine-active-color, #2196f3)));\n}\n.ag-theme-alpine .ag-chart-settings-card-item {\n  background: #181d1f;\n  background: var(--ag-foreground-color, #181d1f);\n  width: 8px;\n  height: 8px;\n  border-radius: 4px;\n}\n.ag-theme-alpine .ag-chart-settings-card-item.ag-selected {\n  background-color: #2196f3;\n  background-color: var(--ag-minichart-selected-page-color, var(--ag-checkbox-checked-color, var(--ag-alpine-active-color, #2196f3)));\n}\n.ag-theme-alpine .ag-chart-data-column-drag-handle {\n  margin-left: 6px;\n}\n.ag-theme-alpine .ag-charts-settings-group-title-bar,\n.ag-theme-alpine .ag-charts-data-group-title-bar,\n.ag-theme-alpine .ag-charts-format-top-level-group-title-bar {\n  border-top: solid 1px;\n  border-top-color: #dde2eb;\n  border-top-color: var(--ag-secondary-border-color, #dde2eb);\n}\n.ag-theme-alpine .ag-charts-settings-group-container {\n  padding: 6px;\n}\n.ag-theme-alpine .ag-charts-data-group-container {\n  padding: 6px 12px;\n}\n.ag-theme-alpine .ag-charts-data-group-container .ag-charts-data-group-item:not(.ag-charts-format-sub-level-group) {\n  height: 24px;\n}\n.ag-theme-alpine .ag-charts-data-group-container .ag-list-item-hovered::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background-color: #2196f3;\n  background-color: var(--ag-range-selection-border-color, #2196f3);\n}\n.ag-theme-alpine .ag-charts-data-group-container .ag-item-highlight-top::after {\n  top: 0;\n}\n.ag-theme-alpine .ag-charts-data-group-container .ag-item-highlight-bottom::after {\n  bottom: 0;\n}\n.ag-theme-alpine .ag-charts-format-top-level-group-container {\n  margin-left: 12px;\n  padding: 6px;\n}\n.ag-theme-alpine .ag-charts-format-top-level-group-item {\n  margin: 6px 0;\n}\n.ag-theme-alpine .ag-charts-format-sub-level-group-container {\n  padding: 12px 12px;\n  padding-bottom: 3px;\n}\n.ag-theme-alpine .ag-charts-format-sub-level-group-container > * {\n  margin-bottom: 9px;\n}\n.ag-theme-alpine .ag-charts-group-container.ag-group-container-horizontal {\n  padding: 6px;\n}\n.ag-theme-alpine .ag-chart-data-section,\n.ag-theme-alpine .ag-chart-format-section {\n  display: -webkit-box;\n  display: flex;\n  margin: 0;\n}\n.ag-theme-alpine .ag-chart-menu-panel {\n  background-color: #f8f8f8;\n  background-color: var(--ag-control-panel-background-color, #f8f8f8);\n}\n.ag-theme-alpine .ag-ltr .ag-chart-menu-panel {\n  border-left: solid 1px;\n  border-left-color: #babfc7;\n  border-left-color: var(--ag-border-color, #babfc7);\n}\n\n.ag-theme-alpine .ag-rtl .ag-chart-menu-panel {\n  border-right: solid 1px;\n  border-right-color: #babfc7;\n  border-right-color: var(--ag-border-color, #babfc7);\n}\n\n.ag-theme-alpine .ag-date-time-list-page-title {\n  -webkit-box-flex: 1;\n          flex-grow: 1;\n  text-align: center;\n}\n.ag-theme-alpine .ag-date-time-list-page-column-label {\n  text-align: center;\n}\n.ag-theme-alpine .ag-date-time-list-page-entry {\n  text-align: center;\n}\n.ag-theme-alpine .ag-checkbox-input-wrapper {\n  font-family: \"agGridAlpine\";\n  font-size: 16px;\n  line-height: 16px;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  width: 16px;\n  height: 16px;\n  background-color: #fff;\n  background-color: var(--ag-checkbox-background-color, var(--ag-background-color, #fff));\n  border-radius: 3px;\n  display: inline-block;\n  vertical-align: middle;\n  -webkit-box-flex: 0;\n          flex: none;\n}\n.ag-theme-alpine .ag-checkbox-input-wrapper input, .ag-theme-alpine .ag-checkbox-input-wrapper input {\n  -webkit-appearance: none;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n}\n.ag-theme-alpine .ag-checkbox-input-wrapper:focus-within, .ag-theme-alpine .ag-checkbox-input-wrapper:active {\n  outline: none;\n  -webkit-box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);\n          box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);\n}\n.ag-theme-alpine .ag-checkbox-input-wrapper.ag-disabled {\n  opacity: 0.5;\n}\n.ag-theme-alpine .ag-checkbox-input-wrapper::after {\n  content: \"\\f108\";\n  color: #999;\n  color: var(--ag-checkbox-unchecked-color, #999);\n  position: absolute;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n}\n.ag-theme-alpine .ag-checkbox-input-wrapper.ag-checked::after {\n  content: \"\\f106\";\n  color: #2196f3;\n  color: var(--ag-checkbox-checked-color, var(--ag-alpine-active-color, #2196f3));\n  position: absolute;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n}\n.ag-theme-alpine .ag-checkbox-input-wrapper.ag-indeterminate::after {\n  content: \"\\f107\";\n  color: #999;\n  color: var(--ag-checkbox-indeterminate-color, var(--ag-checkbox-unchecked-color, #999));\n  position: absolute;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n}\n.ag-theme-alpine .ag-toggle-button-input-wrapper {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  width: 28px;\n  height: 18px;\n  background-color: #999;\n  background-color: var(--ag-toggle-button-off-background-color, var(--ag-checkbox-unchecked-color, #999));\n  border-radius: 9px;\n  position: relative;\n  -webkit-box-flex: 0;\n          flex: none;\n  border: 1px solid;\n  border-color: #999;\n  border-color: var(--ag-toggle-button-off-border-color, var(--ag-checkbox-unchecked-color, #999));\n}\n.ag-theme-alpine .ag-toggle-button-input-wrapper input {\n  opacity: 0;\n  height: 100%;\n  width: 100%;\n}\n.ag-theme-alpine .ag-toggle-button-input-wrapper:focus-within {\n  outline: none;\n  -webkit-box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);\n          box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);\n}\n.ag-theme-alpine .ag-toggle-button-input-wrapper.ag-disabled {\n  opacity: 0.5;\n}\n.ag-theme-alpine .ag-toggle-button-input-wrapper.ag-checked {\n  background-color: #2196f3;\n  background-color: var(--ag-toggle-button-on-background-color, var(--ag-checkbox-checked-color, var(--ag-alpine-active-color, #2196f3)));\n  border-color: #2196f3;\n  border-color: var(--ag-toggle-button-on-border-color, var(--ag-checkbox-checked-color, var(--ag-alpine-active-color, #2196f3)));\n}\n.ag-theme-alpine .ag-toggle-button-input-wrapper::before {\n  content: \" \";\n  position: absolute;\n  top: -1px;\n  left: -1px;\n  display: block;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 18px;\n  width: 18px;\n  background-color: #fff;\n  background-color: var(--ag-toggle-button-switch-background-color, var(--ag-background-color, #fff));\n  border-radius: 9px;\n  -webkit-transition: left 100ms;\n  transition: left 100ms;\n  border: 1px solid;\n  border-color: #999;\n  border-color: var(--ag-toggle-button-switch-border-color, var(--ag-toggle-button-off-border-color, var(--ag-checkbox-unchecked-color, #999)));\n}\n.ag-theme-alpine .ag-toggle-button-input-wrapper.ag-checked::before {\n  left: calc(100% - 18px );\n  border-color: #2196f3;\n  border-color: var(--ag-toggle-button-on-border-color, var(--ag-checkbox-checked-color, var(--ag-alpine-active-color, #2196f3)));\n}\n.ag-theme-alpine .ag-radio-button-input-wrapper {\n  font-family: \"agGridAlpine\";\n  font-size: 16px;\n  line-height: 16px;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  width: 16px;\n  height: 16px;\n  background-color: #fff;\n  background-color: var(--ag-checkbox-background-color, var(--ag-background-color, #fff));\n  border-radius: 3px;\n  display: inline-block;\n  vertical-align: middle;\n  -webkit-box-flex: 0;\n          flex: none;\n  border-radius: 16px;\n}\n.ag-theme-alpine .ag-radio-button-input-wrapper input, .ag-theme-alpine .ag-radio-button-input-wrapper input {\n  -webkit-appearance: none;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n}\n.ag-theme-alpine .ag-radio-button-input-wrapper:focus-within, .ag-theme-alpine .ag-radio-button-input-wrapper:active {\n  outline: none;\n  -webkit-box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);\n          box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);\n}\n.ag-theme-alpine .ag-radio-button-input-wrapper.ag-disabled {\n  opacity: 0.5;\n}\n.ag-theme-alpine .ag-radio-button-input-wrapper::after {\n  content: \"\\f126\";\n  color: #999;\n  color: var(--ag-checkbox-unchecked-color, #999);\n  position: absolute;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n}\n.ag-theme-alpine .ag-radio-button-input-wrapper.ag-checked::after {\n  content: \"\\f127\";\n  color: #2196f3;\n  color: var(--ag-checkbox-checked-color, var(--ag-alpine-active-color, #2196f3));\n  position: absolute;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n}\n.ag-theme-alpine input[class^=ag-][type=range] {\n  -webkit-appearance: none;\n  width: 100%;\n  height: 100%;\n  background: none;\n  overflow: visible;\n}\n.ag-theme-alpine input[class^=ag-][type=range]::-webkit-slider-runnable-track {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 3px;\n  background-color: #babfc7;\n  background-color: var(--ag-border-color, #babfc7);\n  border-radius: 3px;\n  border-radius: 3px;\n}\n.ag-theme-alpine input[class^=ag-][type=range]::-moz-range-track {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 3px;\n  background-color: #babfc7;\n  background-color: var(--ag-border-color, #babfc7);\n  border-radius: 3px;\n  border-radius: 3px;\n}\n.ag-theme-alpine input[class^=ag-][type=range]::-ms-track {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 3px;\n  background-color: #babfc7;\n  background-color: var(--ag-border-color, #babfc7);\n  border-radius: 3px;\n  border-radius: 3px;\n  color: transparent;\n  width: calc(100% - 2px);\n}\n.ag-theme-alpine input[class^=ag-][type=range]::-webkit-slider-thumb {\n  margin: 0;\n  padding: 0;\n  -webkit-appearance: none;\n  width: 16px;\n  height: 16px;\n  background-color: #fff;\n  background-color: var(--ag-background-color, #fff);\n  border: 1px solid;\n  border-color: #999;\n  border-color: var(--ag-checkbox-unchecked-color, #999);\n  border-radius: 16px;\n  -webkit-transform: translateY(-6.5px);\n          transform: translateY(-6.5px);\n}\n.ag-theme-alpine input[class^=ag-][type=range]::-ms-thumb {\n  margin: 0;\n  padding: 0;\n  -webkit-appearance: none;\n  width: 16px;\n  height: 16px;\n  background-color: #fff;\n  background-color: var(--ag-background-color, #fff);\n  border: 1px solid;\n  border-color: #999;\n  border-color: var(--ag-checkbox-unchecked-color, #999);\n  border-radius: 16px;\n}\n.ag-theme-alpine input[class^=ag-][type=range]::-moz-ag-range-thumb {\n  margin: 0;\n  padding: 0;\n  -webkit-appearance: none;\n  width: 16px;\n  height: 16px;\n  background-color: #fff;\n  background-color: var(--ag-background-color, #fff);\n  border: 1px solid;\n  border-color: #999;\n  border-color: var(--ag-checkbox-unchecked-color, #999);\n  border-radius: 16px;\n}\n.ag-theme-alpine input[class^=ag-][type=range]:focus {\n  outline: none;\n}\n.ag-theme-alpine input[class^=ag-][type=range]:focus::-webkit-slider-thumb {\n  -webkit-box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);\n          box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);\n  border-color: #2196f3;\n  border-color: var(--ag-checkbox-checked-color, var(--ag-alpine-active-color, #2196f3));\n}\n.ag-theme-alpine input[class^=ag-][type=range]:focus::-ms-thumb {\n  box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);\n  border-color: #2196f3;\n  border-color: var(--ag-checkbox-checked-color, var(--ag-alpine-active-color, #2196f3));\n}\n.ag-theme-alpine input[class^=ag-][type=range]:focus::-moz-ag-range-thumb {\n  box-shadow: 0 0 2px 0.1rem rgba(33, 150, 243, 0.4);\n  border-color: #2196f3;\n  border-color: var(--ag-checkbox-checked-color, var(--ag-alpine-active-color, #2196f3));\n}\n.ag-theme-alpine input[class^=ag-][type=range]:active::-webkit-slider-runnable-track {\n  background-color: rgba(33, 150, 243, 0.4);\n  background-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));\n}\n.ag-theme-alpine input[class^=ag-][type=range]:active::-moz-ag-range-track {\n  background-color: rgba(33, 150, 243, 0.4);\n  background-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));\n}\n.ag-theme-alpine input[class^=ag-][type=range]:active::-ms-track {\n  background-color: rgba(33, 150, 243, 0.4);\n  background-color: var(--ag-input-focus-border-color, rgba(33, 150, 243, 0.4));\n}\n.ag-theme-alpine input[class^=ag-][type=range]:disabled {\n  opacity: 0.5;\n}\n.ag-theme-alpine .ag-filter-toolpanel-header,\n.ag-theme-alpine .ag-filter-toolpanel-search,\n.ag-theme-alpine .ag-status-bar,\n.ag-theme-alpine .ag-header-row,\n.ag-theme-alpine .ag-panel-title-bar-title,\n.ag-theme-alpine .ag-multi-filter-group-title-bar {\n  font-weight: 700;\n  color: #181d1f;\n  color: var(--ag-header-foreground-color, var(--ag-secondary-foreground-color, var(--ag-foreground-color, #181d1f)));\n}\n.ag-theme-alpine .ag-rtl .ag-pinned-left-header .ag-header-row::before, .ag-theme-alpine .ag-ltr .ag-pinned-right-header .ag-header-row::after {\n  content: \"\";\n  position: absolute;\n  height: calc(100% - 20px);\n  top: 10px;\n  width: 1px;\n  background-color: #babfc7;\n  background-color: var(--ag-border-color, #babfc7);\n}\n.ag-theme-alpine .ag-ltr .ag-pinned-right-header .ag-header-row::after {\n  right: 0;\n}\n.ag-theme-alpine .ag-rtl .ag-pinned-left-header .ag-header-row::before {\n  left: 0;\n}\n.ag-theme-alpine .ag-row {\n  font-size: 14px;\n}\n.ag-theme-alpine input[class^=ag-]:not([type]),\n.ag-theme-alpine input[class^=ag-][type=text],\n.ag-theme-alpine input[class^=ag-][type=number],\n.ag-theme-alpine input[class^=ag-][type=tel],\n.ag-theme-alpine input[class^=ag-][type=date],\n.ag-theme-alpine input[class^=ag-][type=datetime-local],\n.ag-theme-alpine textarea[class^=ag-] {\n  min-height: 24px;\n  border-radius: 3px;\n}\n.ag-theme-alpine .ag-ltr input[class^=ag-]:not([type]),\n.ag-theme-alpine .ag-ltr input[class^=ag-][type=text],\n.ag-theme-alpine .ag-ltr input[class^=ag-][type=number],\n.ag-theme-alpine .ag-ltr input[class^=ag-][type=tel],\n.ag-theme-alpine .ag-ltr input[class^=ag-][type=date],\n.ag-theme-alpine .ag-ltr input[class^=ag-][type=datetime-local],\n.ag-theme-alpine .ag-ltr textarea[class^=ag-] {\n  padding-left: 6px;\n}\n\n.ag-theme-alpine .ag-rtl input[class^=ag-]:not([type]),\n.ag-theme-alpine .ag-rtl input[class^=ag-][type=text],\n.ag-theme-alpine .ag-rtl input[class^=ag-][type=number],\n.ag-theme-alpine .ag-rtl input[class^=ag-][type=tel],\n.ag-theme-alpine .ag-rtl input[class^=ag-][type=date],\n.ag-theme-alpine .ag-rtl input[class^=ag-][type=datetime-local],\n.ag-theme-alpine .ag-rtl textarea[class^=ag-] {\n  padding-right: 6px;\n}\n\n.ag-theme-alpine .ag-tab {\n  padding: 9px;\n  -webkit-transition: color 0.4s;\n  transition: color 0.4s;\n}\n.ag-theme-alpine .ag-tab-selected {\n  color: #2196f3;\n  color: var(--ag-alpine-active-color, #2196f3);\n}\n.ag-theme-alpine .ag-menu {\n  background-color: #f8f8f8;\n  background-color: var(--ag-control-panel-background-color, #f8f8f8);\n}\n.ag-theme-alpine .ag-menu-header {\n  background-color: #f8f8f8;\n  background-color: var(--ag-control-panel-background-color, #f8f8f8);\n  padding-top: 1px;\n}\n.ag-theme-alpine .ag-tabs-header {\n  border-bottom: solid 1px;\n  border-bottom-color: #babfc7;\n  border-bottom-color: var(--ag-border-color, #babfc7);\n}\n.ag-theme-alpine .ag-charts-settings-group-title-bar,\n.ag-theme-alpine .ag-charts-data-group-title-bar,\n.ag-theme-alpine .ag-charts-format-top-level-group-title-bar {\n  padding: 6px 12px;\n  line-height: 20px;\n}\n.ag-theme-alpine .ag-chart-mini-thumbnail {\n  background-color: #fff;\n  background-color: var(--ag-background-color, #fff);\n}\n.ag-theme-alpine .ag-chart-settings-nav-bar {\n  border-top: solid 1px;\n  border-top-color: #dde2eb;\n  border-top-color: var(--ag-secondary-border-color, #dde2eb);\n}\n.ag-theme-alpine .ag-ltr .ag-group-title-bar-icon {\n  margin-right: 6px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-group-title-bar-icon {\n  margin-left: 6px;\n}\n\n.ag-theme-alpine .ag-charts-format-top-level-group-toolbar {\n  margin-top: 6px;\n}\n.ag-theme-alpine .ag-ltr .ag-charts-format-top-level-group-toolbar {\n  padding-left: 20px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-charts-format-top-level-group-toolbar {\n  padding-right: 20px;\n}\n\n.ag-theme-alpine .ag-charts-format-sub-level-group {\n  border-left: dashed 1px;\n  border-left-color: #babfc7;\n  border-left-color: var(--ag-border-color, #babfc7);\n  padding-left: 6px;\n  margin-bottom: 12px;\n}\n.ag-theme-alpine .ag-charts-format-sub-level-group-title-bar {\n  padding-top: 0;\n  padding-bottom: 0;\n  background: none;\n  font-weight: 700;\n}\n.ag-theme-alpine .ag-charts-format-sub-level-group-container {\n  padding-bottom: 0;\n}\n.ag-theme-alpine .ag-charts-format-sub-level-group-item:last-child {\n  margin-bottom: 0;\n}\n.ag-theme-alpine .ag-dnd-ghost {\n  font-size: 12px;\n  font-weight: 700;\n}\n.ag-theme-alpine .ag-side-buttons {\n  width: 30px;\n}\n.ag-theme-alpine .ag-standard-button {\n  -moz-appearance: none;\n       appearance: none;\n  -webkit-appearance: none;\n  border-radius: 3px;\n  border: 1px solid;\n  border-color: #2196f3;\n  border-color: var(--ag-alpine-active-color, #2196f3);\n  color: #2196f3;\n  color: var(--ag-alpine-active-color, #2196f3);\n  background-color: #fff;\n  background-color: var(--ag-background-color, #fff);\n  font-weight: 600;\n  padding: 6px 12px;\n}\n.ag-theme-alpine .ag-standard-button:hover {\n  border-color: #2196f3;\n  border-color: var(--ag-alpine-active-color, #2196f3);\n  background-color: rgba(33, 150, 243, 0.1);\n  background-color: var(--ag-row-hover-color, rgba(33, 150, 243, 0.1));\n}\n.ag-theme-alpine .ag-standard-button:active {\n  border-color: #2196f3;\n  border-color: var(--ag-alpine-active-color, #2196f3);\n  background-color: #2196f3;\n  background-color: var(--ag-alpine-active-color, #2196f3);\n  color: #fff;\n  color: var(--ag-background-color, #fff);\n}\n.ag-theme-alpine .ag-standard-button:disabled {\n  color: rgba(24, 29, 31, 0.5);\n  color: var(--ag-disabled-foreground-color, rgba(24, 29, 31, 0.5));\n  background-color: #f1f2f4;\n  background-color: var(--ag-input-disabled-background-color, #f1f2f4);\n  border-color: rgba(186, 191, 199, 0.3);\n  border-color: var(--ag-input-disabled-border-color, rgba(186, 191, 199, 0.3));\n}\n.ag-theme-alpine .ag-column-drop-vertical {\n  min-height: 75px;\n}\n.ag-theme-alpine .ag-column-drop-vertical-title-bar {\n  padding: 12px;\n  padding-bottom: 0px;\n}\n.ag-theme-alpine .ag-column-drop-vertical-empty-message {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-align: center;\n          align-items: center;\n  border: dashed 1px;\n  border-color: #babfc7;\n  border-color: var(--ag-border-color, #babfc7);\n  margin: 12px;\n  padding: 12px;\n}\n.ag-theme-alpine .ag-column-drop-empty-message {\n  color: #181d1f;\n  color: var(--ag-foreground-color, #181d1f);\n  opacity: 0.75;\n}\n.ag-theme-alpine .ag-status-bar {\n  font-weight: normal;\n}\n.ag-theme-alpine .ag-status-name-value-value {\n  font-weight: 700;\n}\n.ag-theme-alpine .ag-paging-number, .ag-theme-alpine .ag-paging-row-summary-panel-number {\n  font-weight: 700;\n}\n.ag-theme-alpine .ag-column-drop-cell-button {\n  opacity: 0.5;\n}\n.ag-theme-alpine .ag-column-drop-cell-button:hover {\n  opacity: 0.75;\n}\n.ag-theme-alpine .ag-header-cell-menu-button:hover,\n.ag-theme-alpine .ag-side-button-button:hover,\n.ag-theme-alpine .ag-tab:hover,\n.ag-theme-alpine .ag-panel-title-bar-button:hover,\n.ag-theme-alpine .ag-header-expand-icon:hover,\n.ag-theme-alpine .ag-column-group-icons:hover,\n.ag-theme-alpine .ag-group-expanded .ag-icon:hover,\n.ag-theme-alpine .ag-group-contracted .ag-icon:hover,\n.ag-theme-alpine .ag-chart-settings-prev:hover,\n.ag-theme-alpine .ag-chart-settings-next:hover,\n.ag-theme-alpine .ag-group-title-bar-icon:hover,\n.ag-theme-alpine .ag-column-select-header-icon:hover,\n.ag-theme-alpine .ag-floating-filter-button-button:hover,\n.ag-theme-alpine .ag-filter-toolpanel-expand:hover,\n.ag-theme-alpine .ag-chart-menu-icon:hover {\n  color: #2196f3;\n  color: var(--ag-alpine-active-color, #2196f3);\n}\n.ag-theme-alpine .ag-chart-settings-card-item.ag-not-selected:hover {\n  opacity: 0.35;\n}\n.ag-theme-alpine .ag-ltr .ag-panel-title-bar-button {\n  margin-left: 12px;\n  margin-right: 6px;\n}\n\n.ag-theme-alpine .ag-rtl .ag-panel-title-bar-button {\n  margin-right: 12px;\n  margin-left: 6px;\n}\n\n.ag-theme-alpine .ag-filter-toolpanel-group-container {\n  padding-left: 6px;\n}\n.ag-theme-alpine .ag-filter-toolpanel-instance-filter {\n  border: none;\n  background-color: #f8f8f8;\n  background-color: var(--ag-control-panel-background-color, #f8f8f8);\n  border-left: dashed 1px;\n  border-left-color: #babfc7;\n  border-left-color: var(--ag-border-color, #babfc7);\n  margin-left: 8px;\n  padding-left: 8px;\n  margin-right: 12px;\n}\n.ag-theme-alpine .ag-set-filter-list {\n  padding-top: 3px;\n  padding-bottom: 3px;\n}\n.ag-theme-alpine .ag-layout-auto-height .ag-center-cols-clipper, .ag-theme-alpine .ag-layout-auto-height .ag-center-cols-container, .ag-theme-alpine .ag-layout-print .ag-center-cols-clipper, .ag-theme-alpine .ag-layout-print .ag-center-cols-container {\n  min-height: 150px;\n}\n.ag-theme-alpine .ag-overlay-no-rows-wrapper.ag-layout-auto-height {\n  padding-top: 60px;\n}\n.ag-theme-alpine .ag-date-time-list-page-entry-is-current {\n  background-color: #2196f3;\n  background-color: var(--ag-alpine-active-color, #2196f3);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
